import * as THREE from 'three'
//import * as THREE from 'https://unpkg.com/three@0.109.0/build/three.module.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

// rhino loader:
import { Rhino3dmLoader } from 'three/examples/jsm/loaders/3DMLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

import html2canvas from 'html2canvas';
// https://html2canvas.hertzen.com/ - 

const rhinoLoader = new Rhino3dmLoader();
rhinoLoader.setLibraryPath('https://cdn.jsdelivr.net/npm/rhino3dm@8.4.0/');

import posthog from 'posthog-js';
import axios from 'axios';
import FormData from 'form-data';
import * as mysql from 'mysql';
import * as fs from "fs";

// disable gallery loading since it's not used in havenpark
import "./resultsGallery/script.js";
import openAdminPanel from './adminPanel/script.js';

import { Application as SplineApplication } from '@splinetool/runtime';


// === Importing Shaders: ==== 

import treesVertexShader from "./shaders/trees/vertex.glsl";
import treesFragmentShader from "./shaders/trees/fragment.glsl";
import outlineVertexShader from "./shaders/outline/vertex.glsl";
import outlineFragmentShader from "./shaders/outline/fragment.glsl";
// import { int } from 'three/tsl';

// === Initializing Posthog ===

try {
    posthog.init('phc_g2h9OmTk9dQYB8NCVdYWwLAEXfiauaO0d1QOjQuNIm1', {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only', // optional: controls profile creation behavior
        autocapture: true, // optional: captures clicks, pageviews, etc.
        capture_pageview: true, // optional: capture a pageview on load
    });
} catch {
    console.log("unable to initialize posthog")
}


// INITIALIZING THE ABOUT THE PROJECT FUNCTIONS:
(function initHfCarousel() {
    const track = document.getElementById('hfCarouselTrack');
    const dotsWrap = document.getElementById('hfCarouselDots');
    if (!track || !dotsWrap) return;

    const slides = Array.from(track.querySelectorAll('.hf-c-slide'));
    // build dots
    dotsWrap.innerHTML = '';
    slides.forEach((_, i) => {
        const dot = document.createElement('div');
        dot.className = 'hf-c-dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', () => {
            track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
    });

    const dots = Array.from(dotsWrap.children);
    const setActiveByScroll = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0, bestDist = Infinity;
        slides.forEach((s, i) => {
            const mid = s.offsetLeft + s.clientWidth / 2;
            const d = Math.abs(mid - center);
            if (d < bestDist) { best = i; bestDist = d; }
        });
        dots.forEach((d, i) => d.classList.toggle('active', i === best));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(setActiveByScroll));
    setActiveByScroll();

    // arrows
    document.querySelectorAll('#hfCarousel .hf-c-arrow').forEach(btn => {
        btn.addEventListener('click', () => {
            const dir = Number(btn.dataset.dir || 1);
            const cur = track.scrollLeft;
            const w = track.clientWidth * 0.9; // slide approx a screen
            track.scrollTo({ left: cur + dir * w, behavior: 'smooth' });
        });
    });
})();

// INITIALIZING THE LANDING CAROUSEL:
(function initHfCarouselLanding() {
    const track = document.getElementById('hfCarouselLandingTrack');
    const dotsWrap = document.getElementById('hfCarouselLandingDots');
    if (!track || !dotsWrap) return;

    const slides = Array.from(track.querySelectorAll('.hf-c-slide'));
    // build dots
    dotsWrap.innerHTML = '';
    slides.forEach((_, i) => {
        const dot = document.createElement('div');
        dot.className = 'hf-c-dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', () => {
            track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
    });

    const dots = Array.from(dotsWrap.children);
    const setActiveByScroll = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0, bestDist = Infinity;
        slides.forEach((s, i) => {
            const mid = s.offsetLeft + s.clientWidth / 2;
            const d = Math.abs(mid - center);
            if (d < bestDist) { best = i; bestDist = d; }
        });
        dots.forEach((d, i) => d.classList.toggle('active', i === best));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(setActiveByScroll));
    setActiveByScroll();

    // arrows
    document.querySelectorAll('#hfCarouselLanding .hf-c-arrow').forEach(btn => {
        btn.addEventListener('click', () => {
            const dir = Number(btn.dataset.dir || 1);
            const cur = track.scrollLeft;
            const w = track.clientWidth * 0.9; // slide approx a screen
            track.scrollTo({ left: cur + dir * w, behavior: 'smooth' });
        });
    });
})();

// Landing page start button - hide landing menu and user menu (same as UrbanFutureStartExperienceButton)
document.getElementById('UrbanFutureStartExperienceFromLandingButton')?.addEventListener('click', function() {
    const landingMenu = document.getElementById('LandingUrbanFuture');
    if (landingMenu) {
        landingMenu.classList.add('NonActiveSegment');
    }


    if (map.getStyle().sprite && !map.getStyle().sprite.includes('cmantxs6m01ii01skcbe76l1u')) {
            map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u');


            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        } else {
            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        }


        // Fly to startingPoint and check zoom level
        flyTowards(startingPoint);
        zoomLevelCheck(startingPoint.zoom);

        document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone");
        document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone");
        document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")


        startParticipationUrbanFuture();

});

// "Aan de slag!" button - calls iniciateParticipate()
document.getElementById('StartParticipateButton')?.addEventListener('click', function() {
    iniciateParticipate();
});

// "Klik op een beeld" button - selects a random participation point
document.getElementById('SelectPinButton')?.addEventListener('click', function() {
    // Check if user has introduced themselves or logged in
    if (!(ReadyToStart || ReadyToStartViaLogin)) {
        console.log('cannot participate yet - showing introduce menu');
        while (document.getElementById("UserMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UserMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone");
        }
        document.getElementById("UrbanFutureIntroduceButton").click();
        return;
    }

    const points = Array.isArray(window.participationPoints)
        ? window.participationPoints
        : (typeof participationPoints !== 'undefined' ? participationPoints : []);
    if (!points || points.length === 0) return;

    const randomPoint = points[Math.floor(Math.random() * points.length)];
    if (randomPoint && typeof setCurrentParticipate === 'function') {
        setCurrentParticipate(randomPoint);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    //Checking user log in:
    if (window.self !== window.top) {

    } else {
        // Running as a top-level page
        checkLoginStatus();
    }

});

window.addEventListener("resize", () => {
    const isMobile = window.innerWidth <= 768; // Define your mobile breakpoint
    if (isMobile) {

        if (window.innerWidth > window.innerHeight) {
            console.log("Landscape");

            let url = window.location.href;

            // Create a URL object
            let urlObj = new URL(url);

            // Use URLSearchParams to extract the value
            let params = new URLSearchParams(urlObj.search);

            // Retrieve the value of the parameter
            let activeProjectValue = params.get('activeProject');
            console.log(activeProjectValue)

            if (activeProjectValue !== null) {
                if (activeProjectValue == "Plac Krakowski") {
                    console.log("change visibility")
                    document.getElementById("OnlyMobileAction").classList.add("OnlyMobileActionVisible")
                    while (document.getElementById("OnlyMobileAction").classList.contains("OnlyMobileActionHidden")) {
                        document.getElementById("OnlyMobileAction").classList.remove("OnlyMobileActionHidden");
                    }
                }
            }

        } else {
            console.log("Portrait");
            let url = window.location.href;

            // Create a URL object
            let urlObj = new URL(url);

            // Use URLSearchParams to extract the value
            let params = new URLSearchParams(urlObj.search);

            // Retrieve the value of the parameter
            let activeProjectValue = params.get('activeProject');
            console.log(activeProjectValue)

            if (activeProjectValue !== null) {

                console.log("Device is in portrait mode");
                document.getElementById("OnlyMobileAction").classList.add("OnlyMobileActionHidden")
                while (document.getElementById("OnlyMobileAction").classList.contains("OnlyMobileActionVisible")) {
                    document.getElementById("OnlyMobileAction").classList.remove("OnlyMobileActionVisible");
                }
            }
        }
    }

});

window.addEventListener('DOMContentLoaded', () => {


    // Restore Age
    const age = sessionStorage.getItem('userAge');
    if (age) document.getElementById('UFFormAge').value = age;
    if (age) sessionUserAge = age;

    // Restore Gender
    const gender = sessionStorage.getItem('userGender');
    if (gender) document.getElementById('UFFormGender').value = gender;
    if (gender) sessionUserGender = gender;

    // Restore Relation to Place
    const relation = sessionStorage.getItem('userRelation');
    if (relation) document.getElementById('UFFormRelation').value = relation;
    if (relation) sessionUserRelation = relation;


    // Restore Email
    const email = sessionStorage.getItem('userEmail');
    if (email) document.getElementById('UFFormEmail').value = email;
    if (email) sessionUserEmail = email;


    if (age && gender && relation) {
        document.getElementById("UrbanFutureIntroduceSave").style.backgroundColor = "#003d92";
        document.getElementById("UrbanFutureIntroduceSave").style.setProperty("color", "#FFFFFF", "important");
        document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
        document.getElementById("IntrouceIncompleteMessage").innerHTML = ""

    }




});




// GLOBAL VARIABLES:
// Setting the Project name:
let ReadyToStartViaLogin = false;

let projectName = "HavenparkGroningenPhase2";
let projectCode = "HGS2";
let databaseUsersName = projectName + "Users";
let databaseAnswersName = projectName + "Answers";
if (typeof window !== 'undefined') {
    window.databaseAnswersName = databaseAnswersName;
}


// Setting up session storage for user ID:

let code = Math.floor(10000000 + Math.random() * 90000000).toString();

let userID = projectCode + String(code);

// Set item (if its not set already):
if (!sessionStorage.getItem('userID')) {
    sessionStorage.setItem('userID', userID);
}

if (!sessionStorage.getItem("loginUserID")) {
    sessionStorage.setItem('loginUserID', "-");
}

// Get item
let sessionUserID = sessionStorage.getItem('userID');


function getUserIPAndCheck() {
    fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php')
        .then(r => r.json())
        .then(({ ip }) => {
            const table = databaseUsersName;
            const uid = sessionStorage.getItem('userID') || '-';
            const url = `https://publictwin.info/EngagementAppPrototypes/MainPHP/User_CheckOrInsert.php` +
                `?ip=${encodeURIComponent(ip)}&uid=${encodeURIComponent(uid)}&table=${encodeURIComponent(table)}`;

            return fetch(url);
        })
        .then(r => r.json())
        .then(result => {
            console.log('Database result:', result);
        })
        .catch(err => console.error(err));
}

getUserIPAndCheck();


let userIP = ""; // global variable to store IP

function getUserIP() {
    fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php')
        .then(response => response.json())
        .then(data => {
            userIP = data.ip;
        });
}
getUserIP();

async function resolveUserIdentity() {
    const uid = sessionStorage.getItem('userID') || '-';
    let ip = localStorage.getItem('userIP') || '';

    if (!ip && typeof userIP !== 'undefined' && userIP) {
        ip = userIP;
    }

    if (!ip) {
        try {
            const response = await fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php');
            const data = await response.json();
            ip = data.ip || '';
            if (ip) {
                localStorage.setItem('userIP', ip);
            }
        } catch (_err) {
            ip = '';
        }
    }

    return { uid, ip };
}



function loadUserDataByIP() {
    fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php')
        .then(res => res.json())
        .then(({ ip }) => {
            const uid = sessionStorage.getItem('userID') || '-';
            return fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/User_Load.php', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ip,
                    uid,
                    table: databaseUsersName,
                })
            });
        })
        .then(res => res.json())
        .then(userData => {
            if (userData.status === "success" && userData.user.user_end_session === "false") {
                const u = userData.user;
                // ... your existing restore logic ...
            } else if (userData.status === "not_found") {
                console.log("No user record for this (ip, uid) yet.");
            } else if (userData.status === "error") {
                console.error("Load error:", userData.message);
            }
        })
        .catch(err => console.error("Failed to load user data:", err));
}



loadUserDataByIP();


function setUserSessionActive() {
    const table = databaseUsersName;
    const uid = sessionStorage.getItem('userID') || '-';

    // use cached IP if you already have it; otherwise fetch
    const ensureIp = () =>
        userIP && userIP !== '' ? Promise.resolve({ ip: userIP })
            : fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php').then(r => r.json());

    ensureIp()
        .then(({ ip }) =>
            fetch("https://publictwin.info/EngagementAppPrototypes/MainPHP/User_SetSessionActive.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ip, uid, table })
            })
        )
        .then(res => res.json())
        .then(data => {
            console.log("Session reset result:", data);
        })
        .catch(err => console.error("Session reset failed:", err));
}








// ---- Config ----
const projectCenter = [6.593620314503482, 53.21995862905095];
const PROJECT_RADIUS_KM = 5;

const START_ZOOM_DESKTOP = 16.5;
const START_ZOOM_MOBILE = 15; // a touch wider view on phones

const ZOOM_THRESHOLD_DESKTOP = 16.4; // below this, hide details on desktop
const ZOOM_THRESHOLD_MOBILE = 14.9; // below this, hide details on mobile

let zoomLevelThreshold = isMobileDevice() ? ZOOM_THRESHOLD_MOBILE : ZOOM_THRESHOLD_DESKTOP;

// ---- Device detection (robust but simple) ----
function isMobileDevice() {
    const ua = navigator.userAgent || "";
    const coarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
    const small = Math.min(window.innerWidth, window.innerHeight) <= 820;
    const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    return coarse || small || mobileUA;
}

// ---- Geo helpers: 20 km envelope around center ----
function boundsAround(center, km) {
    const [lng, lat] = center;
    const latRad = lat * Math.PI / 180;

    // ~ km per degree
    const KM_PER_DEG_LAT = 110.574;
    const KM_PER_DEG_LNG = Math.max(1e-6, 111.320 * Math.cos(latRad)); // avoid div by 0 near poles

    const dLat = km / KM_PER_DEG_LAT;
    const dLng = km / KM_PER_DEG_LNG;

    const clampLat = v => Math.max(-85, Math.min(85, v)); // Mapbox safe latitude
    const wrapLng = v => ((v + 180) % 360 + 360) % 360 - 180;

    const sw = [wrapLng(lng - dLng), clampLat(lat - dLat)];
    const ne = [wrapLng(lng + dLng), clampLat(lat + dLat)];
    return [sw, ne];
}

// ---- Build derived values ----
const bounds = boundsAround(projectCenter, PROJECT_RADIUS_KM);

const cameraStartOverview = {
    zoom: isMobileDevice() ? START_ZOOM_MOBILE : START_ZOOM_DESKTOP,
    center: projectCenter,
    pitch: 0,
    bearing: 0,
};

let PasswordReset = true;

const CAMERA_ICON_URL = 'https://publictwin.info/PromptarePlacemakingWeek/content/Icons/CameraIconMain.svg';
const CAMERA_ICON_WHITE_URL = 'https://publictwin.info/PromptarePlacemakingWeek/content/Icons/CameraIconMainWhite.svg';


const QUESTION_ICON_URL = 'https://publictwin.info/HavenparkGroningen/content/Icons/QuestionIcon.svg';
const QUESTION_ICON_WHITE_URL = 'https://publictwin.info/HavenparkGroningen/content/Icons/QuestionIconWhite.svg';

let startingPointZoom = isMobileDevice() ? 11.990587517236904 : 12.990587517236904;
let startingPoint = {
    zoom: 12.990587517236904, 
    bearing: -19.999999999999773, 
    pitch: 0,
    center: {
        lat: 53.215922434075395,
        lng: 6.569173656401915
    }
}
startingPoint.zoom = startingPointZoom;

let contextElements = [
    {
        name: "Oosterpark",
        type: "park",
        points: [[6.582885616638947, 53.231369405897595], [6.582192982932099, 53.23104693784339], [6.584332451493651, 53.22933320971782], [6.5862940366947385, 53.2271064304195], [6.58729450760498, 53.22589013140177], [6.587832077907166, 53.22500977723206], [6.58874019765625, 53.22344324842564], [6.590602612735552, 53.224106726444916], [6.589907767471743, 53.22536416041669], [6.588262399290301, 53.22747594534411], [6.586769388854378, 53.229042326634385], [6.5859536202664515, 53.22986235045798], [6.585137851677331, 53.229632008273484], [6.582885616638947, 53.231369405897595]]
    },
    {
        name: "Pioenpark",
        type: "park",
        points: [[6.581979504093027, 53.23016065326763], [6.579602000009629, 53.22908272918991], [6.580516424657901, 53.2283500621777], [6.581444917376501, 53.22767633432014], [6.582134252879996, 53.22707839196781], [6.5827532480257105, 53.22616040788239], [6.583597332315122, 53.22681731592792], [6.584371076247777, 53.22720471851284], [6.584877526821657, 53.2273310446848], [6.583526991958365, 53.228872193975775], [6.582739179954331, 53.229596430767856], [6.581979504093027, 53.23016065326763]]
    },
    {
        name: "Noorderplantsoen",
        type: "park",
        points:[[6.56016112574838, 53.227639606363084], [6.5597362670610835, 53.22761898450119], [6.5592425123702185, 53.22768772400269], [6.558817653682922, 53.22760523658775], [6.557152666934996, 53.22649164092772], [6.556785221583226, 53.2263747804451], [6.554637962811512, 53.22620980039673], [6.554025219756966, 53.22605594173561], [6.553818531747311, 53.225774098336984], [6.55443431852305, 53.22423705895221], [6.554376905186643, 53.224030823498026], [6.55356163581331, 53.22360460041219], [6.553106569245102, 53.22322203679471], [6.552796537229682, 53.22253456512436], [6.552633035935543, 53.22171674979751], [6.552759345274609, 53.22112550404498], [6.553310513301881, 53.22009424192015], [6.553080859957106, 53.21977110801231], [6.554998465384898, 53.21936546837847], [6.555744838754691, 53.219475472726884], [6.556674934799986, 53.21955797580216], [6.556089318771399, 53.22067175176929], [6.556028249850414, 53.22179175571256], [6.555718217834993, 53.22271985595734], [6.556671162418269, 53.22483860751478], [6.5579258111741865, 53.22529331581265], [6.557535400488263, 53.22567827650823], [6.5589822165594, 53.22607010794806], [6.560681651308698, 53.22613884993601], [6.561060579327574, 53.22617322088888], [6.56016112574838, 53.227639606363084]]
    },
    {
        name: "Stadspark",
        type: "park",
        points: [[6.557584429329154, 53.20803224404381], [6.550525621592868, 53.20619845503691], [6.5488010888375925, 53.208896330190385], [6.534575750437284, 53.205402627644816], [6.533446589631467, 53.20514204989689], [6.532985542586289, 53.20486648983575], [6.531956506781313, 53.204636587873864], [6.532261627265029, 53.203532570082416], [6.528612501235841, 53.20260177022243], [6.52864214092105, 53.202294623368346], [6.532267111166732, 53.20215860877033], [6.533717837756143, 53.196223044404206], [6.536426908539653, 53.196189636370775], [6.536546561719149, 53.19598957569386], [6.540883625262637, 53.19687821666005], [6.542564808931928, 53.197387053089045], [6.543552867119985, 53.19822738763105], [6.5457025375523585, 53.19890454969183], [6.547095692129943, 53.19907938598769], [6.550915741919397, 53.20015480083302], [6.552516091536091, 53.20087453457958], [6.552908431231401, 53.20127228660826], [6.551396009852908, 53.20391285708365], [6.556191860045004, 53.20522987508545], [6.5569690286975515, 53.20384048980736], [6.558110317285383, 53.20413046004688], [6.558007550728433, 53.206650337603605], [6.557584429329154, 53.20803224404381]]
    },
    {
        name: "Zuiderplantsoen",
        type: "park",
        points: [[6.573833197518837, 53.20615830009004], [6.573297430069914, 53.20706499202322], [6.569717575798023, 53.206473053575536], [6.569470897320173, 53.20669554332173], [6.568719312142207, 53.20671948820831], [6.568109188747314, 53.206465140632105], [6.567982575802347, 53.206307358047155], [6.568268178537409, 53.20598671485723], [6.569155457025431, 53.20589357550759], [6.56987343960634, 53.204792765048865], [6.570323511816383, 53.20477789241167], [6.574028953739145, 53.20557773434814], [6.57423917012062, 53.205318581745956], [6.576423366757496, 53.20589561724498], [6.578563761366922, 53.20674196405008], [6.5796894270086455, 53.20745272685795], [6.581185010048841, 53.20839809847715], [6.582350415412009, 53.209030391381646], [6.583475246320745, 53.20943503498469], [6.583278130802739, 53.20968567294838], [6.5817236127813885, 53.20910427814087], [6.581272556463631, 53.20886689321537], [6.580174763674023, 53.20858305546986], [6.579338982663472, 53.20792922393477], [6.5783270717520566, 53.20706064274384], [6.5780790923914765, 53.20693119961578], [6.573833197518837, 53.20615830009004]]
    },
    {
        name: "Sterrebos",
        type: "park",
        points: [[6.5799408970312925, 53.20728903071981], [6.5787403304038605, 53.206576281428426], [6.577402446320804, 53.205955846737226], [6.576220470333055, 53.20557980926486], [6.574528520676097, 53.2051512311254], [6.575189610539184, 53.2039024596921], [6.575936197436334, 53.20278908258828], [6.576360194016445, 53.20293247618466], [6.579464388590594, 53.20428092319116], [6.580444068454, 53.20443213190484], [6.580718689089622, 53.204592167380156], [6.581979754079782, 53.20480155721083], [6.582779432524518, 53.20520855723535], [6.582156605769313, 53.20561303968489], [6.5815035111101, 53.20637086128261], [6.581093163646472, 53.20673992061461], [6.5799408970312925, 53.20728903071981]]
    },
    {
        name: "Martn Toren",
        type: "POI",
        points:[[6.569482434439692, 53.21985359080003], [6.569003492965351, 53.21980950144794], [6.568216443034288, 53.21963978024647], [6.567754081008019, 53.21952113212669], [6.568007811263186, 53.21906679399058], [6.569036876492959, 53.21929033044131], [6.569679220355937, 53.21942643714749], [6.569482434439692, 53.21985359080003]]
    }
]


let participationPoints = [
    {
        id: "point-1",
        name: "Point 1",
        no: 1,
        title: "Plek van Havenloods",
        title_en: "Harbor Shed Site",
        lngLat: [6.593850014248659,53.220490701665824],
        height: 2,
        description: "Plek van Havenloods: wat vind je er nu van en wat zou je er graag willen zien?",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/1-min.jpg', alt: 'View from Plek van Havenloods' },
        cameraSettings: {
            bearing: -127.16259978769847,
            center: { lng: 6.593467890338189, lat: 53.22035032522771 },
            pitch: 72.56292209043576,
            zoom: 18.94699425857589
        },
        BaseImage:"https://publictwin.info/HavenparkGroningen/content/Images/Locations/1-min.jpg",
        IconImage:"https://publictwin.info/HavenparkGroningen/content/Images/Locations/Havenloods.png",
        introduction:"Op het terrein van het Havenpark aan het water staat nu nog een grote, oude industriële loods. Die kunnen we opknappen en een mooie nieuwe functie geven. Maar we kunnen er ook voor kiezen om hem te slopen. Denk jij met ons mee hoe dat er uit kan gaan zien?",
        baseImageDescription:"Industrial harbor quay viewed from ground level on an overcast day. LEFT SIDE: Large industrial warehouse/harbor shed (havenloods) with brown corrugated metal siding on the far left, transitioning to a brick building with bright blue metal cladding and large blue sliding doors. Yellow overhead crane rails visible on the facade.a RIGHT SIDE: Industrial harbor crane (dark blue/black lattice structure) in the mid-background - this is a key heritage element. A white cargo ship/barge is moored at the quay edge on the far right. BACKGROUND: Industrial buildings, equipment, and overcast sky.",
        baseImageHardConstraints:[
            "the industrial crane must remain in place",
            "the right edge of the harbor is a coastline and can only change 15m to the right",
            "buildings in the far background cannot be changed"
        ],
        Question1: {
            name: "Om de loods heen zie ik een sfeer voor me van...", // In english: "Around the shed, I envision an atmosphere of..."
            name_en: "Atmosphere",
            type: "single",
            answers: [
                "Rust & Natuur", // In english: "Calm & Nature"
                "Kunst & cultuur", // In english: "Arts and Culture"
                "Actief & sportief", // In english: "Active & sporty"
                "Ontmoeting & samen", // In english: "Meeting & together"
                "Speels & avontuurlijk", // In english: "Playful & adventurous"
            ],
            answers_en: [
                "Calm & Nature",
                "Arts & Culture",
                "Active & Sporty",
                "Meeting & Together",
                "Playful & Adventurous",
            ],
            instruction: "Welke sfeer past het beste bij deze plek?", // In english: "Which atmosphere suits this place best?"
            promptInstuction:"This relates to the general atmosphere and feeling of the area."
        },
        Question2: {
            name: "Het gebouw van de Havenloods wil ik...", // In english: "I want the building of the Harbor Shed to..."
            name_en: "Harbor Shed",
            type: "single",
            answers: [
                "Laten zoals het is", // In english: "Leave it as is"
                "Gedeeltelijk slopen en opknappen", // In english: "Retain and renovate parts of the building. Allow parts of it to be repurposed"
                "Helemaal slopen ", // In english: "Remove the building completely, creating space for something new on the site"
                "Er bovenop bouwen", // In english: "Add floors create new functions on top of the existing building"
                "Herbestemmen", // In english: "Change function"
            ],
            answers_en: [
                "Leave it as is",
                "Retain and renovate parts of the building. Allow parts of it to be repurposed",
                "Remove the building completely, creating space for something new on the site",
                "Add floors create new functions on top of the existing building",
                "Change function of the building",
            ],
            instruction: "Wat zou jij met de havenloods willen doen?", // In english: "What would you like to do with the harbor shed?"
            promptInstuction:"This relates to the physical building of the harbor shed on the left side of the image"
        },
        Question3: {
            name: "Deze plek gebruik ik als / voor ...", // english translation: "I use this place as / for ..."
            name_en: "This place is intended for...",
            type: "multiple",
            answers: [
                "Wonen", // In english: "Living"
                "Creatieve Broedplaats", // In english: "Creative Incubator"
                "Horeca", // In english: "Hospitality"
                "Groen park", // In english: "Green park"
                "Sporten en spelen", // In english: "Sports and play"
            ],
            answers_en: [
                "Living",
                "Creative incubator",
                "Hospitality and food services",
                "Green park",
                "Sports and play",
            ],
            instruction: "Je kan meerdere opties kiezen.", // In english: "What would you like to use this place for?"
            promptInstuction:"This relates to the overall use of the area around the harbor shed."
        },
    },
    {
        id: "point-2",
        name: "Point 2",
        no: 2,
        title: "Eemskanaal",
        title_en: "Eemskanaal Canal",
        lngLat: [6.590397739430074,53.21997199959671],
        height: 2,
        description: "Eemskanaal: wat vind je er nu van en wat zou je er graag willen zien?",
            media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/2-min.jpg', alt: 'View Eemskanaal' },
        cameraSettings: {
            bearing: 76.077468504727,
            center: { lng: 6.591718941002739, lat: 53.22017277740065 },
            pitch: 79.93076663314675,
            zoom: 18.149829888006177
        },
        BaseImage:"https://publictwin.info/HavenparkGroningen/content/Images/Locations/2-min.jpg",
        IconImage:"https://publictwin.info/HavenparkGroningen/content/Images/Locations/Eemskanaal.png",
        introduction:"Aan het Eemskanaal komt een lange kade. De industriële kranen willen we een nieuw leven geven. Wat zie jij hier voor je?",
        baseImageDescription:"View of the Eemskanaal waterway from an elevated position on the right bank, looking along the canal. WATER (CENTER-LEFT): Wide calm canal water dominates the left and center of the image, reflecting the overcast sky. A large cargo ship named 'FIDENTE' is moored at the far quay (left bank). A small boat/barge is visible in the far left distance. The water must remain open on the left side. RIGHT BANK/QUAY (FOREGROUND): Industrial quay edge runs diagonally from bottom-right toward the center. A prominent blue industrial harbor crane stands as the dominant vertical element on the right side - this is a heritage element that must be preserved. Behind the crane are industrial warehouses with brick and blue metal cladding. FAR BACKGROUND: The canal extends into the distance with industrial facilities, a green crane/loader, bare winter trees.",
        baseImageHardConstraints:[
            "the industrial crane must remain in place",
            "any new propositions in the water can only be placed within 20m from the current quay edge, left side of the image has to remain open water",
        ],
        Question1: {
            name: "Op en rondom het Eemskanaal zie ik een sfeer voor me van...", // In english: "On and around the Eemskanaal, I envision an atmosphere of..."
            name_en: "Atmosphere",
            type: "single",
            answers: [
                "Rust & Natuur", // In english: "Calm & Nature"
                "Kunst & cultuur", // In english: "Arts & Culture"
                "Actief & sportief", // In english: "Active & sporty"
                "Ontmoeting & samen", // In english: "Meeting & together"
                "Speels & avontuurlijk", // In english: "Playful & adventurous"
            ],
            answers_en: [
                "Calm & Nature",
                "Arts & Culture",
                "Active & Sporty",
                "Meeting & Together",
                "Playful & Adventurous",
            ],
            instruction: "Welke sfeer past het beste bij deze plek?", // In english: "Which atmosphere suits this place best?"
            promptInstuction:"This relates to the general atmosphere and feeling of the area."
        },
        Question2: {
            name: "De kade gebruik ik als/voor...",
            name_en: "The quay is intended for...",
            type: "multiple",
            answers: [
                "Ontdek en leerplek", // In english: "Discovery and learning place"
                "Horeca paviljoen", // In english: "Hospitality and food pavilions"
                "Boulevard", // In english: "Boulevard"
                "Zitplek aan het water", // In english: "Seating by the water"
                "Natuurgebied", // In english: "Nature area"
            ],
            answers_en: [
                "Discovery and learning place",
                "Hospitality and food pavilions",
                "Boulevard",
                "Seating by the water",
                "Nature area",
            ],
            instruction: "Je kan meerdere opties kiezen.", // In english: "The quay is intended for... (multiple options)"
            promptInstuction:"This relates to the overall use of the quay area."
        },
        Question3: {
            name: "Het water gebruik ik als/voor... ",
            name_en: "The water is intended for...",
            type: "multiple",
            answers: [
                "Zitten op het water op steiger", // In english: "Sitting on the water on jetty"
                "Drijvend kantoor", // In english: "Floating office"
                "Drijvend park", // In english: "Floating park"
                "Aanleg steiger", // In english: "Jetty construction"
                "Woonschepen", // In english: "Houseboats"
            ],
            answers_en: [
                "Sitting on the water on a jetty",
                "Floating office",
                "Floating park",
                "Jetty construction",
                "Houseboats",
            ],
            instruction: "Je kan meerdere opties kiezen.", // In english: "The water is intended for.. (you can choose multiple options)"
            promptInstuction:"This relates to the overall use of the water area."
        },
    },
    {
        id: "point-3",
        name: "Point 3",
        no: 3,
        title: "Deense Haven",
        title_en: "Danish Harbor",
        lngLat: [6.59628576444922,53.219416095244924],
        height: 2,
        description: "Deense Haven: wat vind je er nu van en wat zou je er graag willen zien?",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/3-min.jpg', alt: 'View Deense Haven' },
        cameraSettings: {
            bearing: -88.88144677826273,
            center: { lng: 6.595468450458611, lat: 53.219632464651056 },
            pitch: 79.28959128476006,
            zoom: 18.40827849471134,
        },
        BaseImage:"https://publictwin.info/HavenparkGroningen/content/Images/Locations/3-min.jpg",
        IconImage:"https://publictwin.info/HavenparkGroningen/content/Images/Locations/DeenseHaven.png",
        introduction:"Tussen het Havenpark en de Sontbrug is een groot stuk water. Hier is ook van alles mogelijk. Wat zie jij hier voor je?",
        baseImageDescription:"Panoramic view of the Deense Haven (Danish Harbor) from a bridge on the left side, looking across the harbor basin on a sunny day with blue sky and scattered clouds. LEFT FOREGROUND: Metal bridge railing/barrier with vertical posts runs diagonally into the image. The quay edge with wooden pilings is visible below. IKEA store with yellow letters visible in the far left background. LEFT BANK: Quay with moored houseboats and work vessels. Urban buildings including a distinctive dark modern high-rise tower and lower residential/commercial buildings. Trees line the waterfront. CENTER: Calm harbor water reflecting the sky. A cluster of tall mature trees (appears to be an island or peninsula) dominates the center-background. RIGHT SIDE: Wild vegetation and shrubs along the water's edge in the foreground. A large  Industrial cranes (white/grey lattice structure) stand in the right background - these are heritage elements. Industrial buildings with brick facades and the harbor infrastructure are visible. FAR BACKGROUND: Mix of urban and industrial buildings on both sides, trees, and open sky. The harbor has a semi-enclosed character.",
        baseImageHardConstraints:[
            "the bridge and the coastline on the left side of the image must remain in place",
            "the buildings in the far background on the left side cannot be changed",
            "the industrial cranes and the buildings in the far background on the right must remain in place",
        ],
        Question1: {
            name: "Rondom het Deense Haven zie ik een sfeer voor me van...", // In english: "Around the Deense Haven, I envision an atmosphere of..."
            name_en: "Atmosphere",
            type: "single",
            answers: [
                "Rust & Natuur", // In english: "Calm & Nature"
                "Kunst & cultuur", // In english: "Arts & Culture"
                "Actief & sportief", // In english: "Active & sporty"
                "Ontmoeting & samen", // In english: "Meeting & together"
                "Speels & avontuurlijk", // In english: "Playful & adventurous"
            ],
            answers_en: [
                "Calm & Nature",
                "Arts & Culture",
                "Active & Sporty",
                "Meeting & Together",
                "Playful & Adventurous",
            ],
            instruction: "Welke sfeer past het beste bij deze plek?", // In english: "Which atmosphere suits this place best?"
            promptInstuction:"This relates to the general atmosphere and feeling of the area."
        },
        Question2: {
            name: "De kade gebruik ik als/voor... ",
            name_en: "The quay is intended for...",
            type: "multiple",
            answers: [
                "Sport en spelen", // In english: "Sports and play"
                "Wandelroute ", // In english: "Walking route"
                "Natuurgebied", // In english: "Nature area"
                "Wonen aan het water", // In english: "Living by the water"
                "Horeca", // In english: "Hospitality and food services"
            ],
            answers_en: [
                "Sports and play",
                "Walking route",
                "Nature area",
                "Living by the water",
                "Hospitality and food services",
            ],
            instruction: "Je kan meerdere opties kiezen.", // In english: "The quay is intended for... (multiple options)"
            promptInstuction:"This relates to the overall use of the quay area."
        },
        Question3: {
            name: "Het water gebruik ik als/voor...",
            name_en: "The water is intended for...",
            type: "multiple",
            answers: [
                "Drijvend zwembad", // In english: "Floating pool"
                "Drijvend park", // In english: "Floating park"
                "(Historische) woonschepen", // In english: "Historic houseboats"
                "Drijvende sauna", // In english: "Floating sauna"
                "Watersport", // In english: "Water sports"
            ],
            answers_en: [
                "Floating pool",
                "Floating park",
                "Houseboats - could be both modern and historic",
                "Floating sauna",
                "Water sports",
            ],
            instruction: "Je kan meerdere opties kiezen.", // In english: "The water is intended for.. (you can choose multiple options)"
            promptInstuction:"This relates to the overall use of the water area."
        },
    },
]
window.participationPoints = participationPoints;
let sitePhotosPoints = [
    {
        id: "point-1",
        name: "Point 1",
        no: 1,
        title: "Locatie 01",
        lngLat: [6.5971, 53.2213],
        height: 2,
        description: "",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/1-min.png', alt: 'View from the Piazza Camillo Prampolini' },
        cameraSettings: {
            bearing: -114.66072759205923,
            center: { lng: 6.595583057017393, lat: 53.220698009944044 },
            pitch: 64.77817580435186,
            zoom: 17.335840646987076,
        }

    },
    {
        id: "point-2",
        name: "Point 2",
        no: 2,
        title: "Locatie 02",
        lngLat: [6.5944, 53.2208],
        height: 2,
        description: "",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/2-min.png', alt: 'View from the Piazza Della Vittoria' },
        cameraSettings: {
            bearing: 171.95358537647303,
            center: { lng: 6.594444463423486, lat: 53.22053998854179 },
            pitch: 64.01457838216855,
            zoom: 17.898754015439863,
        }
    },
    {
        id: "point-3",
        name: "Point 3",
        no: 3,
        title: "Locatie 03",
        lngLat: [6.5946, 53.2189],
        height: 2,
        description: "",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/3-min.png', alt: 'View from the Reggio Emilia Stazione' },
        cameraSettings: {
            bearing: -26.8162795010295,
            center: { lng: 6.593819242821837, lat: 53.21972659422215 },
            pitch: 63.644695745495206,
            zoom: 17.588350744630947,
        }
    },
    {
        id: "point-4",
        name: "Point 4",
        no: 4,
        title: "Locatie 04",
        lngLat: [6.5928, 53.22],
        height: 2,
        description: "",
        media: { type: 'image', src: 'https://publictwin.info/HavenparkGroningen/content/Images/Locations/4-min.png', alt: 'View from the Reggio Emilia Stazione' },
        cameraSettings: {
            bearing: 19.32873556939512,
            center: { lng: 6.592773739888344, lat: 53.21997298486542 },
            pitch: 57.372799579060505,
            zoom: 18.03260800766054,
        }
    },
]
sitePhotosPoints = [];



const relationSelect = document.getElementById('UFFormRelation');
const selfInput = document.getElementById('UFFormRelationSelf');



relationSelect.addEventListener('change', updateRelationField);
updateRelationField(); // initialize on load


function updateRelationField() {
    const isSelfDescribe = relationSelect.value === 'anders, namelijk:';

    // Show/hide the text input and toggle required accordingly
    selfInput.style.display = isSelfDescribe ? '' : 'none';
    selfInput.required = isSelfDescribe;

    // If the user switches away from self-describe, clear the input
    if (!isSelfDescribe) selfInput.value = '';
}




function escapeHTML(str = '') {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
// --- indexing/state ---
const __pointsSorted = [...participationPoints].sort((a, b) => (a.no ?? 0) - (b.no ?? 0));
const __idToIndex = __pointsSorted.reduce((m, p, i) => (m[p.id] = i, m), {});
window.__participationState = { idx: null };

// --- photos indexing/state ---
const __photoPointsSorted = [...sitePhotosPoints].sort((a, b) => (a.no ?? 0) - (b.no ?? 0));
const __photoIdToIndex = __photoPointsSorted.reduce((m, p, i) => (m[p.id] = i, m), {});
window.__photoState = { idx: null };

function resetPinSelection() {
    document.querySelectorAll('.participation-pin').forEach(pin => {
        pin.classList.remove('selectedPin');
        pin.innerHTML = `<img class="iconImage" alt="" src="${pin.IconImage}">`;
        if (pin.classList.contains('photo')) {
            pin.innerHTML = `<img class="icon" alt="" src="${CAMERA_ICON_URL}">`;
        }
    });
}

function selectParticipatePoint(point) {
    if (!point) return;
    resetPinSelection();
    const selectedPin = document.querySelector(`.participation-pin[data-id="${point.id}"]`);
    if (selectedPin) {
        selectedPin.classList.add('selectedPin');
        selectedPin.innerHTML = `<img class="icon" alt="" src="${QUESTION_ICON_WHITE_URL}">`;
    }
}

function navigateParticipate(delta) {
    const st = window.__participationState;
    const N = __pointsSorted.length;
    if (!N) return;
    st.idx = st.idx == null ? 0 : ((st.idx + delta) % N + N) % N;
    const point = __pointsSorted[st.idx];

    let CameraMoveTo = {
        zoom: isMobileDevice() ? point.cameraSettings.zoom - 2 : point.cameraSettings.zoom,
        center: [point.cameraSettings.center.lng, point.cameraSettings.center.lat],
        pitch: point.cameraSettings.pitch,
        bearing: point.cameraSettings.bearing,
    };

    flyTowards(CameraMoveTo);

    console.log('flying to point', point);
    renderParticipatePanel(point);
    selectParticipatePoint(point);



}

function navigatePhotos(delta) {
    const st = window.__photoState;
    const N = __photoPointsSorted.length;
    if (!N) return;
    st.idx = st.idx == null ? 0 : ((st.idx + delta) % N + N) % N;
    const point = __photoPointsSorted[st.idx];

    const CameraMoveTo = {
        zoom: isMobileDevice() ? point.cameraSettings.zoom - 2 : point.cameraSettings.zoom,
        center: [point.cameraSettings.center.lng, point.cameraSettings.center.lat],
        pitch: point.cameraSettings.pitch,
        bearing: point.cameraSettings.bearing,
    };
    flyTowards(CameraMoveTo);

    renderPhotosPanel(point);
    selectPhotoPoint(point);
}

function setCurrentPhoto(point) {
    const idx = __photoIdToIndex[point.id];
    window.__photoState.idx = Number.isInteger(idx) ? idx : 0;

    const CameraMoveTo = {
        zoom: isMobileDevice() ? point.cameraSettings.zoom - 2 : point.cameraSettings.zoom,
        center: [point.cameraSettings.center.lng, point.cameraSettings.center.lat],
        pitch: point.cameraSettings.pitch,
        bearing: point.cameraSettings.bearing,
    };
    flyTowards(CameraMoveTo);

    renderPhotosPanel(point);
    selectPhotoPoint(point);
}



function setCurrentParticipate(point) {
    const idx = __idToIndex[point.id];
    window.__participationState.idx = Number.isInteger(idx) ? idx : 0;
    let CameraMoveTo = {
        zoom: isMobileDevice() ? point.cameraSettings.zoom - 2 : point.cameraSettings.zoom,
        center: [point.cameraSettings.center.lng, point.cameraSettings.center.lat],
        pitch: point.cameraSettings.pitch,
        bearing: point.cameraSettings.bearing,
    };

    flyTowards(CameraMoveTo);


    console.log('flying to point', point);
    renderParticipatePanel(point);
    selectParticipatePoint(point);

}

function resetPhotoPinSelection() {
    document.querySelectorAll('.camera-pin.photo').forEach(pin => {
        pin.classList.remove('selectedPhotoPin');
        pin.innerHTML = `<img class="icon" alt="" src="${CAMERA_ICON_URL}">`;
    });
}

function selectPhotoPoint(point) {
    if (!point) return;
    resetPhotoPinSelection();
    const sel = document.querySelector(`.camera-pin.photo[data-id="${point.id}"]`);
    if (sel) {
        sel.classList.add('selectedPhotoPin');
        sel.innerHTML = `<img class="icon" alt="" src="${CAMERA_ICON_WHITE_URL}">`;
    }
}


// scroll bar:
function isMobileLike() {
    // coarse pointer or small viewport = “mobile enough”
    const coarse = window.matchMedia?.('(pointer: coarse)').matches;
    const small = Math.min(window.innerWidth, window.innerHeight) <= 820;
    return coarse || small;
}

// Per-instance state keyed by element
const SCROLLBAR_STATE = new WeakMap();

function attachMobileScrollBar(bodyEl) {
    if (!bodyEl) return;
    if (SCROLLBAR_STATE.has(bodyEl)) return; // already attached to this element

    // build DOM
    const track = document.createElement('div');
    track.className = 'participate-scrollbar';
    const thumb = document.createElement('div');
    thumb.className = 'thumb';
    track.appendChild(thumb);
    bodyEl.appendChild(track);

    function update() {
        const h = bodyEl.clientHeight;
        const sh = bodyEl.scrollHeight;

        // no overflow => hide track
        if (sh <= h + 1) {
            track.style.display = 'none';
            return;
        }
        track.style.display = 'block';

        // Clamp scrollTop into [0, sh - h] to avoid overscroll jitter
        const maxScroll = Math.max(1, sh - h);
        const stRaw = bodyEl.scrollTop;
        const st = Math.min(Math.max(stRaw, 0), maxScroll);

        // Use the track’s own height; cheaper than getBoundingClientRect() on every tick
        const trackH = track.offsetHeight;

        // Keep the thumb *visible*: ~50% of the track height, with a sane minimum
        const THUMB_FRAC = 0.5;
        const tHeight = Math.max(24, Math.round(trackH * THUMB_FRAC));
        const maxTop = Math.max(0, trackH - tHeight);
        const tTop = Math.round((st / maxScroll) * maxTop);

        thumb.style.height = `${tHeight}px`;
        // Smoother, GPU-friendly movement:
        thumb.style.transform = `translateY(${tTop}px)`;
    }


    let fadeTimer;
    function onScroll() {
        bodyEl.classList.add('scrolling');
        update();
        clearTimeout(fadeTimer);
        fadeTimer = setTimeout(() => bodyEl.classList.remove('scrolling'), 600);
    }

    bodyEl.addEventListener('scroll', onScroll, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(bodyEl);

    // save per-instance state + destroy fn
    SCROLLBAR_STATE.set(bodyEl, {
        track, thumb, ro, onScroll,
        destroy() {
            bodyEl.removeEventListener('scroll', onScroll);
            ro.disconnect();
            track.remove();
            SCROLLBAR_STATE.delete(bodyEl);
        }
    });

    // initial paint
    requestAnimationFrame(() => {
        update();
        if (isMobileLike?.()) {
            bodyEl.classList.add('show-bar');
            setTimeout(() => bodyEl.classList.remove('show-bar'), 1200);
        }
    });
}

function detachMobileScrollBar(bodyEl) {
    SCROLLBAR_STATE.get(bodyEl)?.destroy();
}






// Attach to every .scroll element now
function attachMobileScrollBarsAll(root = document) {
    root.querySelectorAll('.scroll').forEach(el => attachMobileScrollBar(el));
}

// Observe DOM for dynamically added/removed .scroll nodes
(function observeScrollables() {
    const mo = new MutationObserver(muts => {
        for (const m of muts) {
            // added nodes
            m.addedNodes.forEach(n => {
                if (n.nodeType !== 1) return;
                if (n.classList?.contains('scroll')) attachMobileScrollBar(n);
                n.querySelectorAll?.('.scroll').forEach(el => attachMobileScrollBar(el));
            });
            // removed nodes -> cleanup to avoid leaks
            m.removedNodes.forEach(n => {
                if (n.nodeType !== 1) return;
                if (n.classList?.contains('scroll')) detachMobileScrollBar(n);
                n.querySelectorAll?.('.scroll').forEach(el => detachMobileScrollBar(el));
            });
        }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // initial pass (after DOM ready)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => attachMobileScrollBarsAll());
    } else {
        attachMobileScrollBarsAll();
    }
})();

function showParticipateWrapper() {
    const wrapper = document.getElementById('ParticipateMenuWrapper');
    if (!wrapper) return;

    toggleParticipateUi(true);

    // Cancel any pending close cleanup
    if (wrapper._closing?.cancel) wrapper._closing.cancel();

    wrapper.classList.remove('UrbanFutureDisplayNone'); // legacy safety
    wrapper.classList.add('is-open');
    wrapper.setAttribute('aria-hidden', 'false');
}

function hideParticipateWrapper(clearOnEnd = true) {
    const wrapper = document.getElementById('ParticipateMenuWrapper');
    if (!wrapper) return;

    toggleParticipateUi(false);

    wrapper.classList.remove('is-open');
    wrapper.setAttribute('aria-hidden', 'true');

    if (!clearOnEnd) return;

    // Cancel previous closing handler (if any)
    if (wrapper._closing?.cancel) wrapper._closing.cancel();

    // Token to identify THIS hide operation
    const token = Symbol('uf-hide');
    const onEnd = (e) => {
        if (e.propertyName !== 'transform') return;       // only care about transform
        if (wrapper._closing?.token !== token) return;     // stale handler; ignore
        if (wrapper.classList.contains('is-open')) return; // reopened; don't clear

        wrapper.removeEventListener('transitionend', onEnd);
        wrapper._closing = null;
        wrapper.innerHTML = '';
    };

    // Save cancel handle
    wrapper._closing = {
        token,
        cancel() {
            wrapper.removeEventListener('transitionend', onEnd);
            wrapper._closing = null;
        }
    };

    wrapper.addEventListener('transitionend', onEnd);
}

function toggleParticipateUi(isOpen) {
    const adminPanel = document.getElementById('admin-panel');
    const editPanel = document.getElementById('answer-edit-panel');
    const analyticsButton = document.getElementById('AnalyticsTriggerButton');
    const shareButtons = document.querySelectorAll('#ShareAppButton, #share-results-button');

    if (isOpen) {
        if (adminPanel) adminPanel.classList.add('participate-suspend');
        if (editPanel) editPanel.classList.add('participate-suspend');
        if (analyticsButton) analyticsButton.classList.add('participate-suspend');
        shareButtons.forEach(btn => btn.classList.add('participate-suspend'));
        document.getElementById('ShareSheet')?.remove();
        return;
    }

    if (adminPanel) adminPanel.classList.remove('participate-suspend');
    if (editPanel) editPanel.classList.remove('participate-suspend');
    if (analyticsButton) analyticsButton.classList.remove('participate-suspend');
    shareButtons.forEach(btn => btn.classList.remove('participate-suspend'));
}

// Helper function to render a single question
function renderQuestion(question, questionNum) {
    if (!question || !question.answers || question.answers.length === 0) {
        return '';
    }

    const inputType = question.type === 'multiple' ? 'checkbox' : 'radio';
    const inputName = `question-${questionNum}`;

    return `
        <div class="participate-question-section">
            <div class="participate-question-divider">${escapeHTML(question.name || '')}</div>
            <div class="participate-question-instruction">${escapeHTML(question.instruction || '')}</div>
            <div class="participate-question-options">
                ${question.answers.map((answer, idx) => `
                    <label class="participate-option-label">
                        <input
                            type="${inputType}"
                            name="${inputName}"
                            value="${escapeHTML(answer)}"
                            class="participate-option-input"
                            data-question="${questionNum}"
                        />
                        <span class="participate-option-text">${escapeHTML(answer)}</span>
                    </label>
                `).join('')}
            </div>
        </div>
    `;
}

// Helper function to render all questions for a point
function renderQuestions(point) {
    let questionsHTML = '';

    if (point.Question1) {
        questionsHTML += renderQuestion(point.Question1, 1);
    }
    if (point.Question2) {
        questionsHTML += renderQuestion(point.Question2, 2);
    }
    if (point.Question3) {
        questionsHTML += renderQuestion(point.Question3, 3);
    }

    return questionsHTML;
}

// ============================================================================
// HELPER FUNCTIONS FOR STATUS AND VISION GENERATION
// ============================================================================

/**
 * Show a transient status message in the participate panel
 * @param {string} message - The message to display
 * @param {string} mode - 'loading' | 'ok' | 'error' | 'info'
 */
// Track pending hide timeout so we can cancel it
let _participateStatusHideTimeout = null;

function showParticipateStatus(message, mode = 'info') {
    const panel = document.querySelector('.participate-panel');
    if (!panel) return;

    // Clear any pending hide timeout
    if (_participateStatusHideTimeout) {
        clearTimeout(_participateStatusHideTimeout);
        _participateStatusHideTimeout = null;
    }

    // Reuse or create status element
    let status = panel.querySelector('.participate-status');
    if (!status) {
        status = document.createElement('div');
        status.className = 'participate-status';

        // Insert after last input wrapper or at panel end
        const lastWrapper = panel.querySelector('.participate-input-wrapper:last-of-type')
            || panel.querySelector('.participate-generate-wrapper');

        if (lastWrapper) {
            lastWrapper.insertAdjacentElement('afterend', status);
        } else {
            panel.appendChild(status);
        }
    }

    // Update content and mode
    status.textContent = message;
    status.className = 'participate-status ' + mode;
    status.style.display = 'block';
}

/**
 * Hide the status message
 * @param {number} delay - Optional delay in ms before hiding
 */
function hideParticipateStatus(delay = 0) {
    const status = document.querySelector('.participate-status');
    if (!status) return;

    // Clear any existing timeout
    if (_participateStatusHideTimeout) {
        clearTimeout(_participateStatusHideTimeout);
        _participateStatusHideTimeout = null;
    }

    if (delay > 0) {
        _participateStatusHideTimeout = setTimeout(() => {
            status.style.display = 'none';
            _participateStatusHideTimeout = null;
        }, delay);
    } else {
        status.style.display = 'none';
    }
}

/**
 * Build the vision reel (animated background marquee) for loading state
 * @param {number} questionId - The question/point ID for preview images
 * @returns {HTMLElement} The reel element
 */
function buildVisionReel(questionId) {
    const reel = document.createElement('div');
    reel.className = 'vision-reel';
    reel.setAttribute('aria-hidden', 'true');

    const track = document.createElement('div');
    track.className = 'track';

    // Base URL for preview images
    const baseUrl = `https://publictwin.info/HavenparkGroningen/content/Images/GenerationsPreview/${questionId}/`;

    // Load 7 preview images (duplicate for seamless loop)
    const imageCount = 7;
    for (let set = 0; set < 2; set++) {
        for (let i = 1; i <= imageCount; i++) {
            const img = new Image();
            img.src = `${baseUrl}${i}.jpg`;
            img.loading = 'lazy';
            img.decoding = 'async';
            img.alt = '';

            // Remove if image fails to load
            img.onerror = () => img.remove();

            track.appendChild(img);
        }
    }

    reel.appendChild(track);
    return reel;
}

/**
 * Build the vision overlay (loading message) for generation state
 * @param {string} answerSummary - Summary of user's answers to display
 * @returns {HTMLElement} The overlay element
 */
function buildVisionOverlay(answerSummary) {
    const inner = document.createElement('div');
    inner.className = 'vision-inner';

    inner.innerHTML = `
        <div class="vision-title">Bedankt! Je antwoorden zijn ontvangen</div>
        <div class="uf-spinner"></div>
        <div class="vision-msg">Je beeld wordt gemaakt…</div>
        <blockquote class="vision-quote">"${escapeHTML(answerSummary)}"</blockquote>
        <div class="vision-sub">Dit kan ongeveer 40 seconden duren</div>
    `;

    return inner;
}

/**
 * Translate text to English using OpenAI API
 * @param {string} text - Text to translate
 * @returns {Promise<string>} Translated text, or original if translation fails
 */
async function translateTextToEnglish(text) {
    if (!text || text.trim() === '') {
        return { flagged: false, translated_text: '' };
    }

    try {
        const response = await fetch(
            'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Translate_Text.php',
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ text: text.trim() })
            }
        );

        const result = await response.json();

        // Check if content was flagged as inappropriate
        if (result?.status === 'flagged' || result?.flagged === true) {
            return { flagged: true, flag_reason: result.flag_reason || 'not in line with the policy' };
        }

        if (result?.status === 'ok' && result.translated_text) {
            return { flagged: false, translated_text: result.translated_text };
        } else {
            console.warn('Translation failed, using original text:', result);
            return { flagged: false, translated_text: text }; // Fallback to original
        }
    } catch (error) {
        console.error('Translation error:', error);
        return { flagged: false, translated_text: text }; // Fallback to original
    }
}

/**
 * Build visitor question dropdown (shown during image generation)
 * @param {number} imageId - The ID of the image being generated
 * @param {Object} meta - User metadata (ip, uid, age_group, etc.)
 * @returns {HTMLElement} The dropdown wrapper element
 */
function buildVisitorQuestionDropdown(imageId, meta) {
    const wrapper = document.createElement('div');
    wrapper.className = 'visitor-question-wrapper';
    wrapper.dataset.imageId = String(Number(imageId) || 0);

    const questionLabel = document.createElement('div');
    questionLabel.className = 'visitor-question-label';
    questionLabel.textContent = 'Wie denk jij dat het Havenpark straks komt bezoeken?';

    const select = document.createElement('select');
    select.className = 'visitor-question-select';

    // Options based on the visitor question
    const options = [
        { value: '', text: '-- Selecteer een optie --' },
        { value: 'Mensen uit de regio', text: 'Mensen uit de regio' },
        { value: 'Mensen uit de hele stad', text: 'Mensen uit de hele stad' },
        { value: 'Mensen uit de buurt', text: 'Mensen uit de buurt' }
    ];

    options.forEach(opt => {
        const option = document.createElement('option');
        option.value = opt.value;
        option.textContent = opt.text;
        select.appendChild(option);
    });

    // Submit button
    const submitBtn = document.createElement('button');
    submitBtn.type = 'button';
    submitBtn.id = 'visitor-question-submit-btn';
    submitBtn.className = 'visitor-question-submit clickableButton';
    submitBtn.textContent = 'Verstuur antwoord';
    submitBtn.disabled = true; // Initially disabled until user selects an option

    const statusMsg = document.createElement('div');
    statusMsg.className = 'visitor-question-status';

    const setStatus = (message, mode = 'info') => {
        statusMsg.textContent = message;
        statusMsg.className = `visitor-question-status ${mode}`;
    };

    let isSending = false;

    const updateState = () => {
        if (isSending) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Versturen...';
            return;
        }
        submitBtn.disabled = !select.value;
        submitBtn.textContent = 'Verstuur antwoord';
        if (!select.value) {
            setStatus('', 'info');
        }
    };

    const resolveImageId = async () => {
        let activeImageId = Number(wrapper.dataset.imageId || 0);
        if (activeImageId > 0) return activeImageId;

        const waitPromise = wrapper.waitForImageId;
        if (waitPromise && typeof waitPromise.then === 'function') {
            setStatus('Even geduld... antwoord wordt opgeslagen.', 'info');
            activeImageId = Number(await waitPromise) || 0;
            if (activeImageId > 0) {
                wrapper.dataset.imageId = String(activeImageId);
            }
        }

        if (activeImageId <= 0) {
            activeImageId = await fetchLatestImageRecordId({
                ip: meta.ip || '',
                uid: meta.uid || '',
                question_id: meta.question_id || 0
            }, {
                attempts: 4,
                intervalMs: 500
            });
            if (activeImageId > 0) {
                wrapper.dataset.imageId = String(activeImageId);
            }
        }

        return activeImageId;
    };

    const sendVisitorAnswer = async (answerValue) => {
        isSending = true;
        submitBtn.disabled = true;
        select.disabled = true;
        updateState();

        setStatus('Antwoord wordt opgeslagen...', 'info');

        const activeImageId = await resolveImageId();
        if (activeImageId <= 0) {
            setStatus('Kon nog geen afbeelding koppelen — probeer het opnieuw.', 'error');
            isSending = false;
            return false;
        }

        try {
            const { ip, uid } = await resolveUserIdentity();
            const age_group = sessionStorage.getItem('userAge') || window.sessionUserAge || meta.age_group || '-';
            const relation_to_place = sessionStorage.getItem('userRelation') || window.sessionUserRelation || meta.relation_to_place || '-';
            const gender = sessionStorage.getItem('userGender') || window.sessionUserGender || meta.gender || '-';
            const resolvedIp = ip || meta.ip || '';
            const resolvedUid = uid || meta.uid || '';
            if (!resolvedIp || !resolvedUid) {
                throw new Error('Missing identity');
            }

            const response = await fetch(
                'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/VisitorQuestion_Insert.php',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        table: 'HavenparkGroningenPhase2VisitorQuestion',
                        image_id: activeImageId,
                        question_id: meta.question_id || 0,
                        visitor_answer: answerValue,
                        user_IP: resolvedIp,
                        user_identifier: resolvedUid,
                        age_group,
                        relation_to_place,
                        gender
                    })
                }
            );

            const result = await response.json();
            if (result?.status === 'ok') {
                console.log('Visitor question saved successfully:', result);
                setStatus('Bedankt voor je antwoord!', 'ok');

                setTimeout(() => {
                    wrapper.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
                    wrapper.style.opacity = '0';
                    wrapper.style.transform = 'translateY(-10px)';
                    setTimeout(() => wrapper.remove(), 500);
                }, 3000);
                return true;
            }

            console.error('Failed to save visitor question:', result);
            setStatus('Kon antwoord niet opslaan — probeer het opnieuw.', 'error');
            return false;
        } catch (error) {
            console.error('Error saving visitor question:', error);
            setStatus('Netwerkfout — probeer het opnieuw.', 'error');
            return false;
        } finally {
            isSending = false;
        }
    };

    wrapper.updateVisitorQuestionState = () => {
        updateState();
    };

    select.addEventListener('change', updateState);
    updateState();

    // Handle submit button click
    submitBtn.addEventListener('click', async () => {
        const selectedValue = select.value;
        if (!selectedValue) {
            setStatus('Kies eerst een optie.', 'error');
            return;
        }

        const ok = await sendVisitorAnswer(selectedValue);
        if (!ok) {
            select.disabled = false;
            updateState();
        }
    });

    wrapper.appendChild(questionLabel);
    wrapper.appendChild(select);
    wrapper.appendChild(submitBtn);
    wrapper.appendChild(statusMsg);

    return wrapper;
}

async function fetchLatestImageRecordId(meta, opts = {}) {
    const {
        attempts = 8,
        intervalMs = 750
    } = opts;

    const payload = {
        user_IP: meta.ip || '',
        user_identifier: meta.uid || '',
        question_id: meta.question_id || 0
    };

    for (let i = 0; i < attempts; i += 1) {
        try {
            const response = await fetch(
                'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Get_Latest_Image_Record.php',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                }
            );
            const result = await response.json();
            const recordId = Number(result?.record_id || 0);
            if (recordId > 0) return recordId;
        } catch (error) {
            console.warn('Failed to fetch latest image record:', error);
        }

        await new Promise(resolve => setTimeout(resolve, intervalMs));
    }

    return 0;
}

/**
 * Generate vision image from user's answers
 * @param {Object} point - The participation point object
 * @param {Object} answers - Object containing question1, question2, question3 arrays and additionalText
 * @param {Object} meta - Metadata (question_id, ip, uid, age_group, etc.)
 */
async function generateVisionFromAnswer(point, answers, meta = {}) {
    const {
        question_id = 0,
        ip = '-',
        uid = '-',
        age_group = '-',
        relation_to_place = '-',
        gender = '-'
    } = meta;

    const bodyEl = document.getElementById('participate-body');
    const srcImage = point?.media?.src;
    if (!bodyEl || !srcImage) {
        console.error('Missing participate-body or source image');
        return;
    }

    // Create summary of answers for display
    const answerSummary = [
        answers.question1.length > 0 ? answers.question1.join(', ') : '',
        answers.question2.length > 0 ? answers.question2.join(', ') : '',
        answers.question3.length > 0 ? answers.question3.join(', ') : '',
        answers.additionalText || ''
    ].filter(s => s).join(' • ');

    // Create (or reuse) the 3:2 placeholder frame
    let frame = bodyEl.querySelector('.vision-frame.generating') || bodyEl.querySelector('.vision-frame');
    if (!frame) {
        frame = document.createElement('div');
        frame.className = 'vision-frame generating';
        frame.setAttribute('role', 'status');
        frame.setAttribute('aria-live', 'polite');
        bodyEl.appendChild(frame);
    }

    // Build loading UI: background reel + overlay text
    frame.classList.add('generating');
    frame.innerHTML = '';
    frame.appendChild(buildVisionReel(question_id || 1));
    frame.appendChild(buildVisionOverlay(answerSummary));
    frame.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    // 👉 DEV: show UI only (no network) so you can style it
    if (window.__DEV_SHOW_GENERATING) {
        return frame; // remove this line (or set toggle=false) when done
    }

    // Remove any previous CTA or visitor question below the frame to avoid duplicates
    if (frame.nextElementSibling?.classList?.contains('vision-gallery-btn')) {
        frame.nextElementSibling.remove();
    }
    if (frame.nextElementSibling?.classList?.contains('visitor-question-wrapper')) {
        frame.nextElementSibling.remove();
    }

    // Translate additional_text to English if provided (also checks for inappropriate content)
    const hasAdditionalText = Boolean(answers.additionalText && answers.additionalText.trim() !== '');
    let translatedAdditionalText = '';
    if (hasAdditionalText) {
        try {
            const translationResult = await translateTextToEnglish(answers.additionalText);

            // Check if content was flagged as inappropriate
            if (translationResult.flagged) {
                console.warn('Content flagged as inappropriate:', translationResult.flag_reason);
                // Hide the generating reel/frame
                if (frame) {
                    frame.classList.remove('generating');
                    frame.innerHTML = '';
                    frame.style.display = 'none';
                }
                showParticipateStatus('Je invoer is niet in lijn met ons beleid. Pas je tekst aan en probeer opnieuw.', 'error');
                hideParticipateStatus(15000); // Hide error after 15 seconds
                return; // Stop image generation
            }

            translatedAdditionalText = translationResult.translated_text;
            console.log('Translated additional text:', translatedAdditionalText);
        } catch (error) {
            console.error('Translation error, using original text:', error);
            // Keep original text as fallback
            translatedAdditionalText = answers.additionalText;
        }
    }

    // Build the AI prompt based on the point and answers (with translated text)
    const translatedAnswers = {
        ...answers,
        additionalText: translatedAdditionalText
    };
    const prompt = buildPromptForPoint(point, translatedAnswers);
    // buildPromptForPoint

    const payload = {
        images_table: 'HavenparkGroningenPhase2Images',
        image_url: srcImage,
        prompt: prompt,
        model: 'gpt-image-1.5',
        size: '1536x1024',
        n: 1,
        output_format: 'jpeg',
        quality: 'medium',
        output_compression: 80,
        // DB metadata (store original text, not translated)
        question_id,
        question1_answers: answers.question1,
        question2_answers: answers.question2,
        question3_answers: answers.question3,
        additional_text: hasAdditionalText ? answers.additionalText.trim() : '-',
        user_IP: ip,
        user_identifier: uid,
        age_group,
        relation_to_place,
        gender
    };

    try {
        // Start the fetch request (this will take ~40 seconds)
        const fetchPromise = fetch(
            'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/OpenAI_ImageEdit.php',
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            }
        );

        // While waiting for the image, show the visitor question dropdown
        const visitorDropdown = buildVisitorQuestionDropdown(0, {
            ip, uid, age_group, relation_to_place, gender, question_id
        });
        frame.insertAdjacentElement('afterend', visitorDropdown);

        visitorDropdown.waitForImageId = fetchLatestImageRecordId({
            ip,
            uid,
            question_id
        });
        visitorDropdown.waitForImageId.then(recordId => {
            if (recordId > 0) {
                visitorDropdown.dataset.imageId = String(recordId);
                if (typeof visitorDropdown.updateVisitorQuestionState === 'function') {
                    visitorDropdown.updateVisitorQuestionState();
                }
            }
        });

        // Now await the actual response
        const genRes = await fetchPromise.then(r => r.json());

        if (genRes?.status === 'ok' && genRes.image_url && genRes.record_id) {
            // Replace the frame content with ONLY the final image
            frame.classList.remove('generating');
            frame.innerHTML = '';

            const img = new Image();
            img.className = 'vision-output';
            img.src = genRes.image_url;
            img.alt = 'Gegenereerde visie';
            img.loading = 'lazy';
            frame.appendChild(img);

            // Add CTA button FIRST (directly after the frame)
            const cta = document.createElement('button');
            cta.type = 'button';
            cta.id = 'vision-gallery-btn';
            cta.className = 'vision-gallery-btn clickableButton';
            cta.textContent = 'Bekijk de beelden van andere Stadjers!';
            cta.addEventListener('click', () => {
                // Open results gallery
                const btn = document.getElementById('EngagementOptionsResults');
                if (btn) btn.click();
            });
            frame.insertAdjacentElement('afterend', cta);

            img.onload = () => frame.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        } else {
            frame.classList.remove('generating');
            frame.innerHTML = `
                <div class="vision-inner">
                    <div class="vision-title">Hmm, er ging iets mis</div>
                    <div class="vision-sub">Kon de visie niet maken - Probeer het opnieuw</div>
                </div>
            `;
            console.warn('OpenAI proxy error:', genRes);
        }
    } catch (e) {
        frame.classList.remove('generating');
        frame.innerHTML = `
            <div class="vision-inner">
                <div class="vision-title">Netwerkprobleem</div>
                <div class="vision-sub">Probeer het alstublieft opnieuw</div>
            </div>
        `;
        console.error('Image generation error:', e);
    }
}

// Normalize option text for comparison
const normalizeOptionText = (value) => String(value ?? '').trim().toLowerCase();

function mapAnswersToEnglish(selectedAnswers, questionMeta = {}) {
    if (!Array.isArray(selectedAnswers) || selectedAnswers.length === 0) return '';

    const sourceAnswers = Array.isArray(questionMeta.answers) ? questionMeta.answers : [];
    const targetAnswers = Array.isArray(questionMeta.answers_en) ? questionMeta.answers_en : [];

    return selectedAnswers.map(answer => {
        const normalized = normalizeOptionText(answer);
        const idx = sourceAnswers.findIndex(opt => normalizeOptionText(opt) === normalized);
        if (idx >= 0 && targetAnswers[idx]) {
            return targetAnswers[idx];
        }
        const idxEn = targetAnswers.findIndex(opt => normalizeOptionText(opt) === normalized);
        if (idxEn >= 0) {
            return targetAnswers[idxEn];
        }
        return answer;
    }).join(', ');
}

let includeBaseDescriptionToggle = true;
function getNextBaseDescriptionToggle() {
    // const current = includeBaseDescriptionToggle;
    // includeBaseDescriptionToggle = !includeBaseDescriptionToggle;
    // return current;
    return true; // always include for now
}

/**
 * Build a context-aware prompt for each participation point
 * All content is translated to English for OpenAI API
 * @param {Object} point - The participation point
 * @param {Object} answers - The user's answers
 * @returns {string} The formatted prompt in English
 */
function buildPromptForPoint(point, answers) {
    // Get point-specific context (translate title)
    const pointTitle = point.title_en || point.title || point.name || 'this location';
    const baseImageDescription = point.baseImageDescription || '';
    const includeBaseImageDescription = baseImageDescription && getNextBaseDescriptionToggle();

    // Get question metadata for building contextual prompts
    const q1Meta = point.Question1 || {};
    const q2Meta = point.Question2 || {};
    const q3Meta = point.Question3 || {};

    // Translate answers to English and pair with prompt instructions
    const q1Text = mapAnswersToEnglish(answers.question1, q1Meta);
    const q2Text = mapAnswersToEnglish(answers.question2, q2Meta);
    const q3Text = mapAnswersToEnglish(answers.question3, q3Meta);

    const additionalText = answers.additionalText
        ? `(User input): ${answers.additionalText}`
        : '';

    // Build user preferences section with prompt instructions for context
    let userPreferencesSection = '';

    if (q1Text) {
        const q1Name = q1Meta.name_en || q1Meta.name || 'Question 1';
        const q1Instruction = q1Meta.promptInstuction || '';
        userPreferencesSection += `- ${q1Name}: ${q1Text}${q1Instruction ? ` (Context: ${q1Instruction})` : ''}\n`;
    }

    if (q2Text) {
        const q2Name = q2Meta.name_en || q2Meta.name || 'Question 2';
        const q2Instruction = q2Meta.promptInstuction || '';
        userPreferencesSection += `- ${q2Name}: ${q2Text}${q2Instruction ? ` (Context: ${q2Instruction})` : ''}\n`;
    }

    if (q3Text) {
        const q3Name = q3Meta.name_en || q3Meta.name || 'Question 3';
        const q3Instruction = q3Meta.promptInstuction || '';
        userPreferencesSection += `- ${q3Name}: ${q3Text}${q3Instruction ? ` (Context: ${q3Instruction})` : ''}\n`;
    }

    if (additionalText) {
        userPreferencesSection += `- Additional ideas: ${additionalText}\n`;
    }

    // Build point-specific hard constraints from baseImageHardConstraints
    const pointHardConstraints = point.baseImageHardConstraints && point.baseImageHardConstraints.length > 0
        ? point.baseImageHardConstraints.map(c => `- MUST: ${c}`).join('\n')
        : '';

    // General hard constraints for all images (in English)
    const generalConstraints = `
- Preserve the basic structure, perspective, and scale of the original image
- Create photorealistic imagery with consistent lighting
- Consider Groningen context and climate (Northern Netherlands)
- Consider Dutch architecture and urban design style
    `.trim();
    // - Ensure Dutch architecture and urban design style
    // Assemble the full prompt in English with strong emphasis on constraints
    const prompt = `
Generate an alternative future vision for ${pointTitle} based on the following input.

${includeBaseImageDescription ? `BASE IMAGE DESCRIPTION (reference only; used to anchor the scene, by describing the existing environment and key elements):\n${baseImageDescription}\n` : ''}

USER PREFERENCES (incorporate these into the vision):
${userPreferencesSection.trim()}

CRITICAL CONSTRAINTS - THESE MUST BE STRICTLY FOLLOWED:
${pointHardConstraints}

GENERAL REQUIREMENTS:
${generalConstraints}

Create a detailed, photorealistic image that brings this vision to life while strictly adhering to all constraints above. The user preferences should guide the creative direction, but the critical constraints must never be violated.

PRIORITY:
1.CRITICAL CONSTRAINTS
2.USER PREFERENCES
3.GENERAL REQUIREMENTS
${includeBaseImageDescription ? `4.BASE IMAGE DESCRIPTION (used only as reference)`:""}


`.trim();

    return prompt;
}

// Render the participate panel for a given point, or hide if none
function renderParticipatePanel(point) {
    const wrapper = document.getElementById('ParticipateMenuWrapper');
    if (!wrapper) return;

    if (!point) {
        // Deselect the currently selected participation pin (if any)
        const sel = PinZManager.selectedId;               // e.g. "participation::point-1"
        if (sel) {
            const [type, id] = String(sel).split('::');
            if (type === 'participation') {
                PinZManager.setSelected(id, type, false);     // closes pin-popup via onDeselect
            }
        }

        window.__participationState.idx = null;
        resetPinSelection();
        hideParticipateWrapper();
        return;
    }

    const title = escapeHTML(point.title ?? point.name ?? '');
    const desc = escapeHTML(point.description ?? '');
    const media = point.media && point.media.type === 'image'
        ? `<img class="participate-media" src="${point.media.src}" alt="${escapeHTML(point.media.alt || title)}">`
        : '';

    wrapper.innerHTML = `
    <div class="participate-panel" data-point-id="${escapeHTML(point.id)}">
      <button id="participate-close" class="participate-close clickableButton" aria-label="Close">
        <img class="participateIcon"
             src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseMenu.png" />
      </button>

      <div id="participate-nav" class="participate-nav-abs" aria-label="Navigate places">
        <button id="participate-prev" class="participate-nav-btn" aria-label="Previous place" title="Previous">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/PreviousIcon.svg" />
        </button>
        <select id="participate-point-select" class="participate-point-select" aria-label="Select participation point">
          ${__pointsSorted.map((p, i) => `
            <option value="${i}" ${p.id === point.id ? 'selected' : ''}>
              ${escapeHTML(p.title || p.name || `Point ${i + 1}`)}
            </option>
          `).join('')}
        </select>
        <button id="participate-next" class="participate-nav-btn" aria-label="Next place" title="Next">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/NextIcon.svg" />
        </button>
      </div>



      <div class="participate-body scroll" id="participate-body">
        ${media}

        ${point.introduction ? `
          <div class="participate-introduction">
            ${escapeHTML(point.introduction)}
          </div>
        ` : ''}

        <div id="participate-questions-container" class="participate-questions-container">
          ${renderQuestions(point)}
        </div>

        <div id="participate-additional-input" class="participate-additional-input" style="display: none;">
          <div class="participate-additional-label">
            Wat daarbij echt niet mag ontbreken is...
          </div>
          <textarea id="participate-additional-text" class="participate-textarea" placeholder="Voeg zelf iets toe aan het beeld..."></textarea>
        </div>

        <div class="participate-generate-wrapper">
          <button id="participate-generate" class="participate-generate-btn">
            <span>Maak mijn beeld!</span> 
            <img class="participateIcon"
                 src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/SendIconMainWhite.svg" />
          </button>
        </div>
      </div>
    </div>
  `;
    //    Wat daarbij echt niet mag ontbreken is...  in english: What should definitely not be missing is...

    // attach mobile scrollbar to this body
    attachMobileScrollBar(document.getElementById('participate-body'));

    // wire buttons
    document.getElementById('participate-close').onclick = () => renderParticipatePanel(null);
    const prev = document.getElementById('participate-prev');
    const next = document.getElementById('participate-next');
    const pointSelect = document.getElementById('participate-point-select');
    if (__pointsSorted.length <= 1) { prev.disabled = true; next.disabled = true; }
    prev.onclick = () => navigateParticipate(-1);
    next.onclick = () => navigateParticipate(1);
    pointSelect.onchange = (e) => {
        const selectedIndex = parseInt(e.target.value, 10);
        if (!isNaN(selectedIndex) && selectedIndex >= 0 && selectedIndex < __pointsSorted.length) {
            window.__participationState.idx = selectedIndex;
            const selectedPoint = __pointsSorted[selectedIndex];

            let CameraMoveTo = {
                zoom: isMobileDevice() ? selectedPoint.cameraSettings.zoom - 2 : selectedPoint.cameraSettings.zoom,
                center: [selectedPoint.cameraSettings.center.lng, selectedPoint.cameraSettings.center.lat],
                pitch: selectedPoint.cameraSettings.pitch,
                bearing: selectedPoint.cameraSettings.bearing,
            };

            flyTowards(CameraMoveTo);
            renderParticipatePanel(selectedPoint);
            selectParticipatePoint(selectedPoint);
        }
    };
    if (point?.id != null) {
        // select via manager so z-order & popup rules apply
        PinZManager.setSelected(point.id, 'participation', true);
    }

    // ---- Question selection logic ----
    const questionInputs = document.querySelectorAll('.participate-option-input');
    const additionalInputContainer = document.getElementById('participate-additional-input');

    function checkAllQuestionsAnswered() {
        const hasQuestion1 = point.Question1 && point.Question1.answers && point.Question1.answers.length > 0;
        const hasQuestion2 = point.Question2 && point.Question2.answers && point.Question2.answers.length > 0;
        const hasQuestion3 = point.Question3 && point.Question3.answers && point.Question3.answers.length > 0;

        let question1Answered = !hasQuestion1;
        let question2Answered = !hasQuestion2;
        let question3Answered = !hasQuestion3;

        if (hasQuestion1) {
            if (point.Question1.type === 'multiple') {
                question1Answered = document.querySelectorAll('input[name="question-1"]:checked').length > 0;
            } else {
                question1Answered = document.querySelector('input[name="question-1"]:checked') !== null;
            }
        }

        if (hasQuestion2) {
            if (point.Question2.type === 'multiple') {
                question2Answered = document.querySelectorAll('input[name="question-2"]:checked').length > 0;
            } else {
                question2Answered = document.querySelector('input[name="question-2"]:checked') !== null;
            }
        }

        if (hasQuestion3) {
            if (point.Question3.type === 'multiple') {
                question3Answered = document.querySelectorAll('input[name="question-3"]:checked').length > 0;
            } else {
                question3Answered = document.querySelector('input[name="question-3"]:checked') !== null;
            }
        }

        const allAnswered = question1Answered && question2Answered && question3Answered;

        if (allAnswered && additionalInputContainer) {
            additionalInputContainer.style.display = 'block';
        } else if (additionalInputContainer) {
            additionalInputContainer.style.display = 'none';
        }

        return allAnswered;
    }

    questionInputs.forEach(input => {
        input.addEventListener('change', checkAllQuestionsAnswered);
    });

    // ---- Generate button ----
    const generateBtn = document.getElementById('participate-generate');
    if (generateBtn) {
        generateBtn.onclick = async () => {
            const allAnswered = checkAllQuestionsAnswered();

            if (!allAnswered) {
                showParticipateStatus('Beantwoord alstublieft alle vragen voordat u genereert.', 'error');
                return;
            }

            // Collect answers
            const answers = {
                question1: [],
                question2: [],
                question3: [],
                additionalText: ''
            };

            // Collect Question 1 answers
            if (point.Question1) {
                const q1Inputs = document.querySelectorAll('input[name="question-1"]:checked');
                q1Inputs.forEach(input => answers.question1.push(input.value));
            }

            // Collect Question 2 answers
            if (point.Question2) {
                const q2Inputs = document.querySelectorAll('input[name="question-2"]:checked');
                q2Inputs.forEach(input => answers.question2.push(input.value));
            }

            // Collect Question 3 answers
            if (point.Question3) {
                const q3Inputs = document.querySelectorAll('input[name="question-3"]:checked');
                q3Inputs.forEach(input => answers.question3.push(input.value));
            }

            // Collect additional text
            const additionalTextInput = document.getElementById('participate-additional-text');
            if (additionalTextInput) {
                answers.additionalText = additionalTextInput.value.trim();
            }

            console.log('Collected answers:', answers);

            // Gather user data
            const uid = sessionStorage.getItem('userID') || '-';

            // Prefer cached IP (userIP) if already fetched
            const { ip } = (window.userIP && window.userIP !== '')
                ? { ip: window.userIP }
                : await fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php').then(r => r.json());

            // question_id: use numeric .no if present; else parse digits from id
            const question_id = Number.isFinite(point.no)
                ? point.no
                : (parseInt(String(point.id).replace(/\D+/g, ''), 10) || 0);

            // user profile (from session)
            const age_group = sessionStorage.getItem('userAge') || window.sessionUserAge || '-';
            const relation_to_place = sessionStorage.getItem('userRelation') || window.sessionUserRelation || '-';
            const gender = sessionStorage.getItem('userGender') || window.sessionUserGender || '-';

            // Disable button while processing
            generateBtn.disabled = true;
            showParticipateStatus('antwoorden worden opgeslagen...', 'loading');

            try {
                // Step 1: Save answers to database
                const answerResponse = await fetch('https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Answers_Insert.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        table: 'HavenparkGroningenPhase2Answers',
                        question_id,
                        question1_answers: answers.question1,
                        question2_answers: answers.question2,
                        question3_answers: answers.question3,
                        additional_text: answers.additionalText,
                        user_IP: ip,
                        user_identifier: uid,
                        age_group,
                        relation_to_place,
                        gender
                    })
                });

                // Check if response is valid before parsing JSON
                const responseText = await answerResponse.text();
                let answerRes;
                try {
                    answerRes = JSON.parse(responseText);
                } catch (jsonError) {
                    console.error('Invalid JSON response:', responseText);
                    throw new Error('Server returned invalid response');
                }

                if (answerRes.status === 'ok') {
                    showParticipateStatus('je antwoorden zijn opgeslagen ✔', 'ok');
                    hideParticipateStatus(3000);

                    // Step 2: Kick off generation (non-blocking)
                    generateVisionFromAnswer(point, answers, {
                        question_id,
                        ip,
                        uid,
                        age_group,
                        relation_to_place,
                        gender
                    });
                } else {
                    showParticipateStatus('kon niet opslaan — probeer het opnieuw', 'error');
                }
            } catch (e) {
                console.error('Error saving answers:', e);
                showParticipateStatus('netwerkfout — probeer het opnieuw', 'error');
            } finally {
                generateBtn.disabled = false;
            }
        };
    }

    // ---- Trigger selection logic (random on point change) ----
    const triggerSpan = document.getElementById('participate-trigger-text');
    const regenBtn = document.getElementById('participate-trigger-regenerate');

    // participation state bag
    const st = (window.__participationState = window.__participationState || {});
    st.triggerByPoint = st.triggerByPoint || {};  // map: pointId -> triggerId

    // detect if point changed since last open
    const prevPointId = st._prevPointId;
    const pointChanged = prevPointId !== point.id;
    st._prevPointId = point.id;


    // --- Submit answer ---
    const inputEl = document.getElementById('participate-input');
    const submitEl = document.getElementById('participate-submit');

    // Check readiness whenever the field is focused/clicked
    if (inputEl) {
        const checkReady = () => {
            if (ReadyToStart || ReadyToStartViaLogin) {
                console.log('can submit');
            }
            else {
                console.log('cannot submit yet');
                while (document.getElementById("UserMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
                    document.getElementById("UserMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone")
                }
                document.getElementById("UrbanFutureIntroduceButton").click();
            }
        };

        // Fire on keyboard/tab focus and on pointer/touch clicks
        inputEl.addEventListener('focus', checkReady, { passive: true });
        inputEl.addEventListener('pointerdown', checkReady, { passive: true });
        inputEl.addEventListener('click', checkReady, { passive: true });
    }



    // simple double-submit guard
    let isSubmitting = false;

    if (submitEl) {
        submitEl.addEventListener('click', async (ev) => {
            ev.preventDefault();

            if (isSubmitting) return; // guard
            const answer_text = (inputEl?.value || '').trim();

            // OPTIONAL: minimum length gate (reduce noise)
            if (!answer_text) {
                inputEl?.focus();
                inputEl?.setAttribute('placeholder', 'Typ iets concreets (min. 5 tekens)…');
                return;
            }

            // disable UI while working
            isSubmitting = true;
            submitEl.disabled = true;
            submitEl.classList.add('is-loading'); // if you have a CSS spinner class

            // helper: fetch with timeout
            const fetchJSON = async (url, options = {}, timeoutMs = 15000) => {
                const ctrl = new AbortController();
                const to = setTimeout(() => ctrl.abort(), timeoutMs);
                try {
                    const res = await fetch(url, { ...options, signal: ctrl.signal });
                    const json = await res.json().catch(() => ({}));
                    return { ok: res.ok, status: res.status, json };
                } finally {
                    clearTimeout(to);
                }
            };

            try {
                // 1) Classify first
                showParticipateStatusHTML('<strong>Even geduld…</strong> je idee wordt geanalyseerd…', 'loading');
                const classifyPayload = { answer_text };
                const cls = await fetchJSON(
                    'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Classify_And_Translate.php',
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(classifyPayload)
                    },
                    15000 // 15s timeout
                );

                if (!cls.ok || cls.json?.status !== 'ok') {
                    showParticipateStatus('kan niet classificeren — probeer opnieuw', 'error');
                    return;
                }

                // destructure + sanity
                const answer_text_en = typeof cls.json.answer_text_en === 'string' ? cls.json.answer_text_en : '-';
                const language = typeof cls.json.language === 'string' ? cls.json.language : 'und';
                const sentiment = typeof cls.json.sentiment === 'string' ? cls.json.sentiment : 'not for classification';
                const categories = Array.isArray(cls.json.categories) ? cls.json.categories : ['other'];
                const insight_score = Number.isFinite(cls.json.insight_score)
                    ? Math.max(0, Math.min(100, Math.trunc(cls.json.insight_score))) : 0;

                // 2) Gather other fields
                const uid = sessionStorage.getItem('userID') || '-';
                const ipObj = (window.userIP && window.userIP !== '')
                    ? { ip: window.userIP }
                    : (await fetchJSON('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php', {}, 8000)).json || {};
                const ip = ipObj.ip || '-';

                const question_id = Number.isFinite(point.no)
                    ? point.no
                    : (parseInt(String(point.id).replace(/\D+/g, ''), 10) || 0);

                const age_group = sessionStorage.getItem('userAge') || window.sessionUserAge || '-';
                const relation_to_place = sessionStorage.getItem('userRelation') || window.sessionUserRelation || '-';
                const gender = sessionStorage.getItem('userGender') || window.sessionUserGender || '-';

                // 3) Insert with classification fields (+ insight_score, source: 'app')
                const insertBody = {
                    table: databaseAnswersName,
                    question_id,
                    answer_text,
                    answer_text_en,
                    language,
                    sentiment,
                    categories,       // array is fine; PHP will normalize
                    insight_score,    // NEW
                    user_IP: ip,
                    user_identifier: uid,
                    logged_in_user_id: sessionStorage.getItem('loginUserID') || '-',
                    age_group,
                    relation_to_place,
                    gender,
                    source: 'app'     // distinguish from OCR forms
                };

                const ins = await fetchJSON(
                    'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Answers_Insert.php',
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(insertBody)
                    },
                    15000
                );

                if (ins.ok && ins.json?.status === 'ok') {
                    inputEl.value = '';
                    // categories is your array from the classifier result
                    const catsHTML = categories.map(c => `
                    <span class="cat-chip">
                        <span class="cat-ico">${iconFor(c)}</span>
                        <span class="cat-lbl">${labelNL(c)}</span>
                    </span>
                    `).join(' ');

                    showParticipateStatusHTML(
                        `jouw idee is opgeslagen ✔ — je droeg bij aan: ${catsHTML}`,
                        'ok'
                    );
                    hideParticipateStatus(5000);
                    updateAnswerBadgesAll?.();
                    updateCategoryChipsAll?.();

                    // OPTIONAL: tiny “receipt” chip under the textarea
                    // (Uncomment if you want to show immediate feedback)
                    /*
                    const chipHost = document.getElementById('participate-question-block');
                    if (chipHost && !chipHost.querySelector('.cls-chip')) {
                      const chip = document.createElement('div');
                      chip.className = 'cls-chip';
                      chip.innerHTML = `
                        <span class="cls-sentiment">${sentiment}</span>
                        <span class="cls-cats">${categories.join(', ')}</span>
                        <span class="cls-score">insight: ${insight_score}</span>
                      `;
                      chipHost.appendChild(chip);
                      setTimeout(() => chip.remove(), 4500);
                    }
                    */
                } else {
                    const msg = ins.json?.message || 'kon niet opslaan — probeer het opnieuw';
                    showParticipateStatus(msg, 'error');
                }
            } catch (err) {
                const aborted = err?.name === 'AbortError';
                showParticipateStatus(aborted ? 'timeout — probeer het opnieuw' : 'netwerkfout — probeer het opnieuw', 'error');
            } finally {
                isSubmitting = false;
                submitEl.disabled = false;
                submitEl.classList.remove('is-loading');
            }
        }, { passive: false });
    }


    // open with slide-in
    showParticipateWrapper();

    // Optionally close other menus
    if (UrbanFutureSelectOptionsMenuOpen) {
        UrbanFutureTopNavbarSelectOptions.click();
    }
}


function setParticipateTrigger(span, trigger, pointId) {
    if (!span || !trigger) return;
    // safer than innerHTML; change to innerHTML if you plan to pass markup in prompts
    span.textContent = trigger.prompt;
    span.setAttribute('selectedID', String(trigger.id));
    // let other components know
    span.dispatchEvent(new CustomEvent('triggerchange', {
        bubbles: true,
        detail: { id: trigger.id, prompt: trigger.prompt, pointId }
    }));
}

function pickRandomTrigger(excludeId = null) {
    if (!Array.isArray(customTriggers) || customTriggers.length === 0) return null;
    if (customTriggers.length === 1) return customTriggers[0];

    // avoid immediate repeats
    const pool = excludeId == null
        ? customTriggers
        : customTriggers.filter(t => String(t.id) !== String(excludeId));

    // if filter removes all, fall back to full list
    const candidates = pool.length ? pool : customTriggers;
    const idx = Math.floor(Math.random() * candidates.length);
    return candidates[idx];
}

const PERSON_ICON_URL = 'https://publictwin.info/digital_maquette/content/Urban_Future/Icons/PersonIcon.svg';
function metersToPixelsAtLat(meters, lat, zoom) {
    const earth = 40075016.686;              // meters
    const latRad = lat * Math.PI / 180;
    const metersPerPixel = (earth * Math.cos(latRad)) / (512 * Math.pow(2, zoom));
    return meters / metersPerPixel;          // pixels
}
function bindOutsideClose(handler) {
    const host = map?.getContainer?.() || document; // only listen on the map, not whole document
    const onDoc = (ev) => {
        const t = ev.target;
        if (!t) return;

        // ignore clicks inside pins or their popup
        if (t.closest('.pin-wrap') || t.closest('.pin-popup')) return;

        // ignore clicks inside any menu/panel
        if (t.closest('#ParticipateMenuWrapper')) return;

        // if the click wasn't even on the map container, ignore it
        if (!host.contains(t)) return;

        handler();
    };

    host.addEventListener('pointerdown', onDoc, true); // pointerdown is snappier & consistent
    return () => host.removeEventListener('pointerdown', onDoc, true);
}


function createParticipationPinsSimple(points) {
    const pins = [];
    let selectedIdLocal = null;
    let unbindOutsideClose = null; // cleanup handle

    const ICONS = (typeof CATEGORY_ICONS === 'object' && CATEGORY_ICONS) || {};
    const labelNLsafe = (typeof labelNL === 'function') ? labelNL : (c => c);
    const iconForsafe = (typeof iconFor === 'function') ? iconFor : (c => (ICONS[c] || '•'));

    async function fetchCategorySummaryForPins() {
        const table = window.databaseAnswersName || 'HavenparkGroningenPhase2Answers';
        if (table === 'HavenparkGroningenPhase2Answers') return {};
        const qids = (window.participationPoints || points)
            .map(p => Number(p.no || 0))
            .filter(n => Number.isFinite(n) && n > 0);
        if (!qids.length) return {};
        const res = await fetch(
            'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Answers_Categories_Summary.php',
            { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ table, question_ids: qids }) }
        ).then(r => r.json()).catch(() => null);
        if (!res || res.status !== 'ok') return {};
        return res.summary || {};
    }

    function renderTop3Chips(container, topArr) {
        container.innerHTML = '';
        const row = document.createElement('div');
        row.className = 'pin-chips';
        (topArr || []).slice(0, 3).forEach(({ category }) => {
            const chip = document.createElement('div');
            chip.className = 'pin-chip';
            chip.title = labelNLsafe(category);
            chip.textContent = ICONS[category] || '•';
            row.appendChild(chip);
        });
        container.appendChild(row);
    }

    function closePinPopup(wrap) {
        const el = wrap?.querySelector?.('.pin-popup');
        if (el) el.remove();
    }

    // shows immediately (loading…), then fills with data
    async function showTop6PopupOverPin(pinWrap, point) {
        closePinPopup(pinWrap);
        const table = window.databaseAnswersName || 'HavenparkGroningenPhase2Answers';
        if (table === 'HavenparkGroningenPhase2Answers') return;

        const popup = document.createElement('div');
        popup.className = 'pin-popup';
        popup.style.left = '50%';
        popup.style.bottom = '40px';
        popup.innerHTML = `<span class="pill">loading…</span>`;
        pinWrap.style.position = 'relative';
        pinWrap.appendChild(popup);

        const qid = Number(point.no || 0);
        if (!qid) {
            popup.innerHTML = `<span class="pill">no data</span>`;
            return;
        }

        try {
            const res = await fetch(
                'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP/Answers_Categories_Summary.php',
                { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ table, question_ids: [qid] }) }
            ).then(r => r.json());
            const list = (res?.summary?.[String(qid)] || []).slice(0, 6);
            if (!list.length) {
                popup.innerHTML = `<span class="pill">geen categorieën</span>`;
            } else {
                popup.innerHTML = list.map(({ category, count }) =>
                    `<span class="pill" title="${labelNLsafe(category)}">
             ${iconForsafe(category)} ${labelNLsafe(category)} (${count})
           </span>`
                ).join(' ');
            }
        } catch {
            popup.innerHTML = `<span class="pill">kon niet laden</span>`;
        }

        popup.addEventListener('wheel', (ev) => ev.stopPropagation(), { passive: false });
        let touchStartY = 0;
        popup.addEventListener('touchstart', (ev) => { touchStartY = ev.touches?.[0]?.clientY || 0; }, { passive: true });
        popup.addEventListener('touchmove', (ev) => {
            const el = popup;
            const atTop = el.scrollTop <= 0;
            const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
            const y = ev.touches?.[0]?.clientY || touchStartY;
            const dy = y - touchStartY;
            if ((atTop && dy > 0) || (atBottom && dy < 0)) ev.preventDefault();
            ev.stopPropagation();
        }, { passive: false });
    }

    function makeEl(point) {
        const wrap = document.createElement('div');
        wrap.className = 'pin-wrap';
        wrap.style.position = 'relative';

        const chipsHost = document.createElement('div');
        chipsHost.className = 'chips-host';
        wrap.appendChild(chipsHost);

        // Add title label above the pin
        const titleLabel = document.createElement('div');
        titleLabel.className = 'pin-title';
        titleLabel.textContent = point.title || point.name || '';
        wrap.appendChild(titleLabel);

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'participation-pin';
        btn.dataset.id = point.id;
        btn.setAttribute('aria-label', point.title || point.name || 'Location');
        btn.IconImage = point.IconImage || '';
        btn.innerHTML = `<img class="iconImage" alt="" src="${point.IconImage}">`;

        const badge = document.createElement('div');
        badge.className = 'pin-count';
        badge.dataset.questionId = String(point.no || 0);
        badge.innerHTML = `<img src="${PERSON_ICON_URL}" alt=""><span class="n">0</span>`;

        wrap.appendChild(btn);
        wrap.appendChild(badge);

        const handleOpen = (ev) => {
            ev?.stopPropagation?.();

            // Check if user is ready to participate
            if (!(ReadyToStart || ReadyToStartViaLogin)) {
                console.log('cannot participate yet - showing introduce menu');
                while (document.getElementById("UserMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
                    document.getElementById("UserMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone");
                }
                document.getElementById("UrbanFutureIntroduceButton").click();
                return;
            }

            PinZManager.setSelected(point.id, 'participation', true);   // will open popup via onSelect
            selectedIdLocal = point.id;
            setCurrentParticipate(point);
            // bind outside close once when something is selected
            if (!unbindOutsideClose) {
                unbindOutsideClose = bindOutsideClose(() => {
                    renderParticipatePanel(null);
                    if (selectedIdLocal != null) {
                        PinZManager.setSelected(selectedIdLocal, 'participation', false);
                        selectedIdLocal = null;
                    }
                    if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
                });
            }
        };

        btn.addEventListener('click', handleOpen, { passive: true });
        btn.addEventListener('touchend', handleOpen, { passive: true });
        btn.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); handleOpen(ev); }
        });

        return { wrap, btn, badge, chipsHost };
    }

    function updateAllOffsets() {
        pins.forEach(p => {
            const lat = p.def.lngLat[1];
            const hMeters = Number(p.def.height || 0);
            const px = hMeters > 0 ? Math.round(metersToPixelsAtLat(hMeters, lat, map.getZoom())) : 0;
            p.marker.setOffset([0, -px]);
        });
    }

    points.forEach(pt => {
        const { wrap, btn, badge, chipsHost } = makeEl(pt);
        const marker = new mapboxgl.Marker({ element: wrap, anchor: 'bottom', offset: [0, 0] })
            .setLngLat(pt.lngLat)
            .addTo(map);

        pins.push({ def: pt, marker, el: btn, wrap, badge, chipsHost });

        PinZManager.register(pt.id, 'participation', {
            wrap,
            lngLat: pt.lngLat,
            type: 'participation',
            onSelect: () => showTop6PopupOverPin(wrap, pt),
            onDeselect: () => closePinPopup(wrap)
        });
    });

    (async () => {
        const summary = await fetchCategorySummaryForPins();
        for (const p of pins) {
            const qid = String(p.def.no || 0);
            renderTop3Chips(p.chipsHost, summary[qid] || []);
        }
        PinZManager.updateAll();
    })();

    const update = () => updateAllOffsets();
    map.on('zoom', update);
    map.on('pitch', update);
    map.on('resize', update);
    updateAllOffsets();

    // expose selection for participate-nav
    function selectById(id) {
        PinZManager.setSelected(id, 'participation', true);
        selectedIdLocal = id;
        if (!unbindOutsideClose) {
            unbindOutsideClose = bindOutsideClose(() => {
                renderParticipatePanel(null);
                if (selectedIdLocal != null) {
                    PinZManager.setSelected(selectedIdLocal, 'participation', false);
                    selectedIdLocal = null;
                }
                if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
            });
        }
    }
    window.__participationPinsAPI = { selectById };

    return {
        pins,
        show: renderParticipatePanel,
        hide() {
            renderParticipatePanel(null);
            if (selectedIdLocal != null) PinZManager.setSelected(selectedIdLocal, 'participation', false);
            selectedIdLocal = null;
            if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
        },
        selectById,
        destroy() {
            pins.forEach(p => {
                p.marker.remove();
                PinZManager.unregister(p.def.id, 'participation');
            });
            map.off('zoom', update);
            map.off('pitch', update);
            map.off('resize', update);
            if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
        }
    };
}



// Fetch counts for a set of question IDs and update badges
async function updateAnswerBadgesAll() {
    const table = window.databaseAnswersName || 'HavenparkGroningenPhase2Answers';
    const qids = participationPoints
        .map(p => Number(p.no || 0))
        .filter(n => Number.isFinite(n) && n > 0);

    if (!qids.length) return;

    try {
        const res = await fetch('https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Answers_Counts.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                table,
                question_ids: qids
                // option: source: 'app' // if you want to limit counts by source
            })
        }).then(r => r.json());

        // Expect: { status: 'ok', counts: { "1": 5, "2": 12, ... } }
        if (res?.status === 'ok' && res.counts) {
            const counts = res.counts;
            for (const pin of (window.__participationPins?.pins || [])) {
                const qid = String(pin?.def?.no || 0);
                const n = counts[qid] ?? 0;
                if (pin?.badge) {
                    const nEl = pin.badge.querySelector('.n');
                    if (nEl) nEl.textContent = String(n);
                }
            }
        }
    } catch (e) {
        console.warn('Failed to fetch answer counts', e);
    }
}
async function updateCategoryChipsAll() {
    const table = window.databaseAnswersName || 'HavenparkGroningenPhase2Answers';
    if (table === 'HavenparkGroningenPhase2Answers') return;
    const qids = participationPoints
        .map(p => Number(p.no || 0))
        .filter(n => Number.isFinite(n) && n > 0);

    if (!qids.length) return;

    try {
        const res = await fetch('https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Answers_Categories_Summary.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ table, question_ids: qids })
        }).then(r => r.json());

        if (res?.status === 'ok' && res.summary) {
            const summary = res.summary;
            for (const pin of (window.__participationPins?.pins || [])) {
                const qid = String(pin?.def?.no || 0);
                const top = summary[qid] || [];
                if (pin?.wrap) {
                    const chipsHost = pin.wrap.querySelector('.chips-host') || pin.chipsHost;
                    if (chipsHost) renderTop3Chips(chipsHost, top);
                }
            }
        }
    } catch (e) {
        console.warn('Failed to fetch categories summary', e);
    }
}


// Increment just one badge (after a successful save) for snappy UX
function incrementAnswerBadge(question_id, delta = 1) {
    const qid = String(question_id);
    const pin = (window.__participationPins?.pins || []).find(p => String(p?.def?.no || 0) === qid);
    if (!pin?.badge) return;
    const nEl = pin.badge.querySelector('.n');
    if (!nEl) return;
    const current = parseInt(nEl.textContent || '0', 10) || 0;
    nEl.textContent = String(current + delta);
}





function renderPhotosPanel(point) {
    const wrapper = document.getElementById('ParticipateMenuWrapper');
    if (!wrapper) return;

    if (!point) {
        window.__photoState.idx = null;
        resetPhotoPinSelection();
        hideParticipateWrapper();
        return;
    }

    const title = escapeHTML(point.title ?? point.name ?? '');
    const media = (point.media && point.media.type === 'image')
        ? `<img class="participate-media" src="${point.media.src}" alt="${escapeHTML(point.media.alt || title)}">`
        : '';
    const desc = point.description ? `<p class="participate-desc">${escapeHTML(point.description)}</p>` : '';

    wrapper.innerHTML = `
    <div class="participate-panel" data-photo-id="${escapeHTML(point.id)}">
      <button id="participate-close" class="participate-close clickableButton" aria-label="Close">
        <img class="participateIcon"
             src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseMenu.png" />
      </button>

      <div id="participate-nav" class="participate-nav-abs" aria-label="Navigate photos">
        <button id="participate-prev" class="participate-nav-btn" aria-label="Previous photo" title="Previous">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/PreviousIcon.svg" />
        </button>
        <button id="participate-next" class="participate-nav-btn" aria-label="Next photo" title="Next">
          <img class="participateIcon"
               src="https://publictwin.info/PromptarePlacemakingWeek/content/Icons/NextIcon.svg" />
        </button>
      </div>



      <div class="participate-body scroll" id="participate-body">
        ${media}
        ${desc}
      </div>
    </div>
  `;

    // scroll bar for the body
    attachMobileScrollBar(document.getElementById('participate-body'));

    // wire buttons
    document.getElementById('participate-close').onclick = () => renderPhotosPanel(null);
    const prev = document.getElementById('participate-prev');
    const next = document.getElementById('participate-next');
    if (__photoPointsSorted.length <= 1) { prev.disabled = true; next.disabled = true; }
    prev.onclick = () => navigatePhotos(-1);
    next.onclick = () => navigatePhotos(1);

    showParticipateWrapper();

    if (window.UrbanFutureSelectOptionsMenuOpen) {
        UrbanFutureTopNavbarSelectOptions.click();
    }
}

function createPhotosPinsSimple(points) {
    const pins = [];
    let selectedPhotoIdLocal = null;
    let unbindOutsideClose = null;

    function makeEl(point) {
        const el = document.createElement('button');
        el.type = 'button';
        el.className = 'camera-pin photo';
        el.dataset.id = point.id;
        el.setAttribute('aria-label', point.title || point.name || 'Photo location');
        el.innerHTML = `<img class="icon" alt="" src="${CAMERA_ICON_URL}">`;

        const open = (ev) => {
            ev?.stopPropagation?.();
            PinZManager.setSelected(point.id, 'photo', true);
            selectedPhotoIdLocal = point.id;
            setCurrentPhoto(point);

            if (!unbindOutsideClose) {
                unbindOutsideClose = bindOutsideClose(() => {
                    renderPhotosPanel(null);
                    if (selectedPhotoIdLocal != null) {
                        PinZManager.setSelected(selectedPhotoIdLocal, 'photo', false);

                        selectedPhotoIdLocal = null;
                    }
                    if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
                });
            }
        };

        el.addEventListener('click', open, { passive: true });
        el.addEventListener('touchend', open, { passive: true });
        el.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); open(ev); }
        });

        return el;
    }

    points.forEach(pt => {
        const el = makeEl(pt);
        const marker = new mapboxgl.Marker({ element: el, anchor: 'center' })
            .setLngLat(pt.lngLat)
            .addTo(map);

        pins.push({ def: pt, marker, el });

        PinZManager.register(pt.id, 'photo', {
            wrap: el,
            lngLat: pt.lngLat,
            type: 'photo'
        });
    });

    return {
        pins,
        show: renderPhotosPanel,
        hide() {
            renderPhotosPanel(null);
            if (selectedPhotoIdLocal != null) PinZManager.setSelected(selectedPhotoIdLocal, 'photo', false);

            selectedPhotoIdLocal = null;
            if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
        },
        destroy() {
            pins.forEach(p => {
                p.marker.remove();
                PinZManager.unregister(p.def.id, 'photo');
            });
            if (unbindOutsideClose) { unbindOutsideClose(); unbindOutsideClose = null; }
        }
    };
}







function initPinsOnce() {
    if (!window.__participationPins) {
        window.__participationPins = createParticipationPinsSimple(participationPoints);
    }
    if (!window.__photoPins) {
        window.__photoPins = createPhotosPinsSimple(sitePhotosPoints);
    }
    console.log('pins initialized');
    updateAnswerBadgesAll();
}



function ensureParticipateStatusHost() {
    const body = document.getElementById('participate-body');
    if (!body) return null;

    // Reuse one status node per panel
    let status = body.querySelector('.participate-status');
    if (!status) {
        status = document.createElement('div');
        status.className = 'participate-status';
        const anchor = body.querySelector('.participate-input-wrapper:last-of-type') || body.lastElementChild;
        (anchor || body).insertAdjacentElement('afterend', status);
    }
    return status;
}

/**
 * Text-only status (safe): message as plain text.
 * mode: 'loading' | 'ok' | 'error' | 'info'
 */
// function showParticipateStatus(message, mode = 'loading') {
//     const status = ensureParticipateStatusHost();
//     if (!status) return;

//     status.innerHTML = '';                 // clear any HTML
//     status.textContent = message;          // set plain text
//     status.className = 'participate-status';
//     status.classList.add(mode);

//     // Add spinner only for loading
//     if (mode === 'loading') {
//         const spin = document.createElement('span');
//         spin.className = 'spinner';
//         status.prepend(spin);
//     }
// }

/**
 * HTML-capable status (use when you need icons/badges).
 * mode: 'loading' | 'ok' | 'error' | 'info'
 */
function showParticipateStatusHTML(html, mode = 'info') {
    const status = ensureParticipateStatusHost();
    if (!status) return;

    status.className = 'participate-status';
    status.classList.add(mode);
    status.innerHTML = html;

    if (mode === 'loading') {
        // If your HTML didn’t include a spinner, we’ll add one at the start
        if (!status.querySelector('.spinner')) {
            const spin = document.createElement('span');
            spin.className = 'spinner';
            status.prepend(spin);
        }
    }
}

// function hideParticipateStatus(delay = 1200) {
//     const body = document.getElementById('participate-body');
//     const status = body?.querySelector('.participate-status');
//     if (status) setTimeout(() => status.remove(), delay);
// }







let map = null;

// --- Shared z-index manager for ALL pins (participation + photos) ---
// Depth metric: geodesic distance (meters) from camera target (map.getCenter()).
// Closer distance -> higher z-index. Selected pin still wins via a large boost.
const PinZManager = (() => {
    const registry = new Map();
    let mapRef = null;
    let selectedKey = null;

    // --- z-index budget (keep pins within ~0..1000) ---
    const Z_CAP = 1000;
    const TYPE_BASE = { participation: 600, photo: 400 }; // tier bases
    const DEPTH_RANGE = 200;   // contribution from distance: 0..200
    const SELECT_BOOST = 350;   // selected pin gets a big bump

    // keep your keying the same
    const keyFor = (id, type) => `${type}::${id}`;

    function geoDistanceMeters(a, b) {
        const toRad = d => d * Math.PI / 180;
        const R = 6371008.8;
        const dLat = toRad(b.lat - a.lat);
        const dLng = toRad(b.lng - a.lng);
        const la1 = toRad(a.lat);
        const la2 = toRad(b.lat);
        const sa = Math.sin(dLat / 2);
        const sb = Math.sin(dLng / 2);
        const h = sa * sa + Math.cos(la1) * Math.cos(la2) * sb * sb;
        return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
    }

    // distance -> 0..DEPTH_RANGE (closer => larger). Tune D0 for your scene scale.
    function depthFromDistance(dist) {
        const D0 = 500;                 // ~“half distance” in meters
        const frac = 1 / (1 + dist / D0);  // 0..1
        return Math.round(frac * DEPTH_RANGE);
    }

    function zFor(p) {
        const base = TYPE_BASE[p.type] ?? 0;
        const center = mapRef?.getCenter?.();
        const dist = (center && p.lngLat)
            ? geoDistanceMeters({ lng: center.lng, lat: center.lat }, { lng: p.lngLat[0], lat: p.lngLat[1] })
            : 0;

        const depth = depthFromDistance(dist);           // 0..200
        const boost = p.selected ? SELECT_BOOST : 0;     // 0 or 350

        // cap so pins never exceed ~1000
        return Math.min(Z_CAP, base + depth + boost);
    }

    function updateAll() {
        registry.forEach((p) => {
            if (!p?.wrap) return;
            p.wrap.style.zIndex = String(zFor(p));
        });
    }

    function setSelected(id, type, on) {
        const key = keyFor(id, type);
        if (on) {
            if (selectedKey && registry.has(selectedKey)) {
                const prev = registry.get(selectedKey);
                prev.selected = false;
                prev.onDeselect?.(prev);
            }
            selectedKey = key;
            const cur = registry.get(key);
            if (cur) {
                cur.selected = true;
                cur.onSelect?.(cur);
            }
        } else {
            if (selectedKey === key) selectedKey = null;
            const cur = registry.get(key);
            if (cur) {
                cur.selected = false;
                cur.onDeselect?.(cur);
            }
        }
        updateAll();
    }

    return {
        init(map) { mapRef = map; updateAll(); },
        register(id, type, pinData) {
            registry.set(keyFor(id, type), { ...pinData, type, selected: !!pinData.selected });
            updateAll();
        },
        unregister(id, type) {
            if (selectedKey === keyFor(id, type)) selectedKey = null;
            registry.delete(keyFor(id, type));
            updateAll();
        },
        setSelected,
        updateAll,
        get selectedId() { return selectedKey; },
        _keyFor: keyFor
    };
})();





let initialDistance = null;
let URLBasedProject = null;
var modelLoaded = false;
var detailedModelLoaded = false;
var symbolsEntered = [];
var multitouchDetected = false;
var raycast = null;



var activeModel = null;
var selectedProject = null;
var zoomLevel = null;


var currentScale = "global";
var clickPointLngLat = null;
var imagesLoaded = null;
var dropingPinState = false;

var userPermissionsStatus = null;
var userProjectPermissionsStatus = "public";


// === Initialize ===


initializeMapbox();

// map on load functionality: => To be cleared up:

function initializeMapbox() {
    fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/mapbox_get_token.php')
        .then(response => response.json())
        .then(data => {
            mapboxgl.accessToken = data.token;

            map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u',
                ...cameraStartOverview,
                antialias: true,
                preserveDrawingBuffer: true,
                maxBounds: bounds
            });
            PinZManager.init(map);

            // keep z-order in sync with camera
            map.on('move', () => PinZManager.updateAll());
            map.on('zoom', () => PinZManager.updateAll());
            map.on('pitch', () => PinZManager.updateAll());
            map.on('rotate', () => PinZManager.updateAll());

            // Ensure pins are created only after the map is fully loaded
            if (typeof map.loaded === 'function' && map.loaded()) {
                initPinsOnce();
            } else {
                map.once('load', initPinsOnce);
            }

            initializeMapFunctionalities();

            // Continue with map setup...
        })
        .catch(err => {
            console.error("Failed to fetch Mapbox token:", err);
        });

}


function initializeMapFunctionalities() {

    map.on('load', () => {


        // Figutnig out what layers are added to the map:
        const style = map.getStyle();

        // Extract the layers array
        const layers = style.layers;

        // Log the layers to the console
        // console.log("Current map layers:", layers);


        // Add images and layer after images are loaded
        imagesLoaded = 0;
        // console.log("loading the map!");

        function checkImagesLoaded() {
            // console.log("running check images loaded!")
            imagesLoaded++;
            if (imagesLoaded >= 2) { // Number of images
                // Add the source and layer after images are loaded
                map.addSource('PTProjects', {
                    'type': 'geojson',
                    'data': PublicTwinProjects
                });

                map.addLayer({
                    'id': 'PTProjects',
                    'type': 'symbol',
                    'source': 'PTProjects',
                    'layout': {
                        'icon-image': [
                            'case',
                            ['==', ['get', 'activeStatus'], 'maquetteInDevelopment'], 'logo2',
                            ['==', ['get', 'activeStatus'], 'activeMaquette'], 'logo1',
                            'logo1'
                        ],
                        'icon-size': 0.025,
                        'icon-padding': 0,
                        'icon-allow-overlap': true
                    }
                });
            }
        }
        checkLoadedOrigin();

        // console.log(PublicTwinProjects);

        // Load images
        map.loadImage('./res/map/PublicTwin_Marker_Logo_Yellow.png', (error, image) => {
            if (error) throw error;
            map.addImage('logo1', image);
            checkImagesLoaded();
        });

        map.loadImage('./res/map/PublicTwin_Marker_Logo_Grey.png', (error, image) => {
            if (error) throw error;
            map.addImage('logo2', image);
            checkImagesLoaded();
        });





        map.on('mouseenter', 'PTProjects', (e) => {
            map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = e.features[0].properties.description;

            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            popup.setLngLat(coordinates)
                .setHTML(
                    `<h3>${e.features[0].properties.title}</h3>
                <img src="${e.features[0].properties.image}" class="popupImage"></img>
                <p><span>${e.features[0].properties.description}</span></p>
                <button id="enterProjectButton-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="enterButton clickableButton">Aan de slag!</button>`
                )
                .addTo(map);

            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');

            const enterButton = document.getElementById(`enterProjectButton-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
            if (enterButton) {
                enterButton.addEventListener('click', () => {

                    for (var l = 0; l < PublicTwinProjects.features.length; l++) {
                        if (PublicTwinProjects.features[l].properties.title == e.features[0].properties.title) {
                            selectedProject = PublicTwinProjects.features[l];
                        }
                    }


                    if (e.features[0].properties.activeStatus === "activeMaquette") {
                        handleButtonClick(e.features[0].properties.title, e.features[0].geometry.coordinates);
                        flyTowards(selectedProject.properties.cameraReset);
                        zoomLevelCheck(selectedProject.properties.cameraReset.zoom);
                        popup.remove();
                    }
                });
            }

            if (e.features[0].properties.activeStatus === "maquetteInDevelopment") {
                popupContent.classList.add("maquetteInDevelopment");
                popupTip.classList.add("maquetteInDevelopment");

                popupContent.classList.remove("activeMaquette");
                popupTip.classList.remove("activeMaquette");
            } else if (e.features[0].properties.activeStatus === "activeMaquette") {
                popupContent.classList.add("activeMaquette");
                popupTip.classList.add("activeMaquette");

                popupContent.classList.remove("maquetteInDevelopment");
                popupTip.classList.remove("maquetteInDevelopment");
            }
        });



        map.on('touchstart', 'PTProjects', (e) => {
            map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = e.features[0].properties.description;
            const touchedProject = e.features[0];
            // console.log(touchedProject);

            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            popup.setLngLat(coordinates)
                .setHTML(
                    `<h3>${e.features[0].properties.title}</h3>
                <img src="${e.features[0].properties.image}" class="popupImage"></img>
                <p><span class="boldPopUp">description:</span><span>${e.features[0].properties.description}</span></p>
                <button id="enterProjectButton-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="enterButton clickableButton">enter!</button>`
                )
                .addTo(map);

            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');

            const enterButton = document.getElementById(`enterProjectButton-${e.features[0].properties.title.replace(/\s+/g, '-')}`);

            if (enterButton) {
                enterButton.addEventListener('click', () => {
                    for (var l = 0; l < PublicTwinProjects.features.length; l++) {
                        if (PublicTwinProjects.features[l].properties.title == touchedProject.properties.title) {
                            selectedProject = PublicTwinProjects.features[l];
                        }
                    }


                    if (touchedProject.properties.activeStatus === "activeMaquette") {
                        handleButtonClick(touchedProject.properties.title, touchedProject.geometry.coordinates);
                        flyTowards(touchedProject.properties.cameraReset);
                        zoomLevelCheck(selectedProject.properties.cameraReset.zoom);
                        popup.remove();
                    }
                });
            }

            if (e.features[0].properties.activeStatus === "maquetteInDevelopment") {
                popupContent.classList.add("maquetteInDevelopment");
                popupTip.classList.add("maquetteInDevelopment");

                popupContent.classList.remove("activeMaquette");
                popupTip.classList.remove("activeMaquette");
            } else if (e.features[0].properties.activeStatus === "activeMaquette") {
                popupContent.classList.add("activeMaquette");
                popupTip.classList.add("activeMaquette");

                popupContent.classList.remove("maquetteInDevelopment");
                popupTip.classList.remove("maquetteInDevelopment");
            }
        });


        map.on('mouseleave', 'PTProjects', () => {
            map.getCanvas().style.cursor = '';
        });

        handleUrl();


    });
    // map on move functionality: => To be cleared up;
    map.on("mousemove", (e) => {


    });

    map.on("touchmove", (e) => {
        zoomLevel = map.getZoom();
        zoomLevelCheck();



    });
    map.on("move", function () {
    });
    map.on("wheel", (e) => {


        zoomLevel = map.getZoom();
        // console.log(zoomLevel);

        zoomLevelCheck()

    });

    // Detect when two fingers touch the map
    map.on('touchstart', function (e) {
        if (e.points.length === 2) {
            // Calculate the initial distance between two fingers
            const point1 = e.points[0];
            const point2 = e.points[1];
            initialDistance = calculateDistance(point1, point2);
        }
        if (e.points.length >= 2) {
            console.log("multitouch detected");
            multitouchDetected = true;
            raycast = false;
        } else {
            multitouchDetected = false;
        }
    });

    // Detect finger movement (pinching)
    map.on('touchmove', function (e) {
        if (e.points.length === 2 && initialDistance !== null) {
            // Calculate the current distance between two fingers
            const point1 = e.points[0];
            const point2 = e.points[1];
            const currentDistance = calculateDistance(point1, point2);

            // Determine if pinch zooming in or out
            if (currentDistance > initialDistance) {
                // console.log('Pinch zooming in');
                zoomLevel = map.getZoom();
                // console.log(zoomLevel);

                zoomLevelCheck()
                // alert("zooming in");
                // You can apply custom logic here or let Mapbox handle zooming
            } else {
                // console.log('Pinch zooming out');
                // console.log('Pinch zooming in');
                zoomLevel = map.getZoom();
                // console.log(zoomLevel);

                zoomLevelCheck()
                // alert("zooming out");
                // You can apply custom logic here or let Mapbox handle zooming
            }

            // Update the initial distance
            initialDistance = currentDistance;
        }
        if (e.points.length >= 2) {
            // console.log("multitouch detected");
            multitouchDetected = true;
            raycast = true;
        } else {
            multitouchDetected = false;
        }
        raycast = false;
    });

    // Clean up on touch end (reset initial distance)
    map.on('touchend', function (e) {
        if (e.points.length < 2) {
            initialDistance = null;
        }
        // if(symbolsEntered.length>=2){
        //     enteredSymbol=false;
        //     symbolsEntered=[];

        // }
        multitouchDetected = false;
        raycast = true;
    });


    map.on('touchstart', 'UrbanFutureReactionsLayer', (e) => {
        if (multitouchDetected == false && raycast == true) {
            popupReactions.remove();
            // map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const question = e.features[0].properties.question;
            selectedReaction = e.features[0].properties.title;


            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            // map.stop();

            const cameraZoom = {
                center: map.getCenter(),
                zoom: map.getZoom(),
                bearing: map.getBearing(),
                pitch: map.getPitch()
            };

            // map.stop();

            setTimeout(() => {
                map.flyTo({
                    center: coordinates,
                    zoom: cameraZoom.zoom,
                    pitch: cameraZoom.pitch,
                    bearing: cameraZoom.bearing,
                    essential: true,
                    duration: 1000,
                });
            }, 50);


            // rating

            popupReactions
                .setLngLat(coordinates)
                .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>${e.features[0].properties.comment}</h3>
                        </div>
                    `)
                .addTo(map);

            popupParticipateApp.remove();
            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');


            popupContent.classList.add("reactionsPopUp");
            popupTip.classList.add("reactionsPopUp");

            popupContent.classList.remove("ParticipateAppPopUp");
            popupTip.classList.remove("ParticipateAppPopUp");


            popupContent.classList.remove("Rating0");
            popupContent.classList.remove("Rating1");
            popupContent.classList.remove("Rating2");
            popupContent.classList.remove("Rating3");
            popupContent.classList.remove("Rating4");
            popupContent.classList.remove("Rating5");


            popupContent.classList.add(`Rating${e.features[0].properties.rating}`);
            // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

            popupContent.classList.remove("maquetteInDevelopment");
            popupTip.classList.remove("maquetteInDevelopment");
            popupContent.classList.remove("activeMaquette");
            popupTip.classList.remove("activeMaquette");
            popupContent.classList.remove("openQuestions");
            popupTip.classList.remove("openQuestions");
        }

    });

    map.on('touchstart', 'UrbanFutureCommentsLayer', (e) => {
        if (multitouchDetected == false && raycast == true) {
            popupReactions.remove();
            // map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const question = e.features[0].properties.question;
            selectedReaction = e.features[0].properties.title;


            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            // map.stop();

            const cameraZoom = {
                center: map.getCenter(),
                zoom: map.getZoom(),
                bearing: map.getBearing(),
                pitch: map.getPitch()
            };

            // map.stop();

            setTimeout(() => {
                map.flyTo({
                    center: coordinates,
                    zoom: cameraZoom.zoom,
                    pitch: cameraZoom.pitch,
                    bearing: cameraZoom.bearing,
                    essential: true,
                    duration: 1000,
                });
            }, 50);


            // rating

            popupReactions
                .setLngLat(coordinates)
                .setHTML(`
                            <div class="questionTitleDiv">
                                <span class="questionTitleSpan">${e.features[0].properties.selected_comment_question}</span>
                            </div>
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
                .addTo(map);

            popupParticipateApp.remove();
            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');


            popupContent.classList.add("reactionsPopUp");
            popupTip.classList.add("reactionsPopUp");

            popupContent.classList.remove("ParticipateAppPopUp");
            popupTip.classList.remove("ParticipateAppPopUp");


            popupContent.classList.remove("Rating0");
            popupContent.classList.remove("Rating1");
            popupContent.classList.remove("Rating2");
            popupContent.classList.remove("Rating3");
            popupContent.classList.remove("Rating4");
            popupContent.classList.remove("Rating5");


            popupContent.classList.add(`Rating0`);
            // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

            popupContent.classList.remove("maquetteInDevelopment");
            popupTip.classList.remove("maquetteInDevelopment");
            popupContent.classList.remove("activeMaquette");
            popupTip.classList.remove("activeMaquette");
            popupContent.classList.remove("openQuestions");
            popupTip.classList.remove("openQuestions");
        }

    });

    map.on('touchstart', 'UrbanFuturePhotosLayer', (e) => {
        if (multitouchDetected == false && raycast == true) {
            popupReactions.remove();
            // map.getCanvas().style.cursor = 'pointer';

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const question = e.features[0].properties.question;
            selectedReaction = e.features[0].properties.title;


            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            // map.stop();

            const cameraZoom = {
                center: map.getCenter(),
                zoom: map.getZoom(),
                bearing: map.getBearing(),
                pitch: map.getPitch()
            };

            // map.stop();

            setTimeout(() => {
                map.flyTo({
                    center: coordinates,
                    zoom: cameraZoom.zoom,
                    pitch: cameraZoom.pitch,
                    bearing: cameraZoom.bearing,
                    essential: true,
                    duration: 1000,
                });
            }, 50);


            // rating

            popupReactions
                .setLngLat(coordinates)
                .setHTML(`
                            <div class="popupImageDivUF">
                                    <img src=${e.features[0].properties.httpadress} class="popupImageUF"/>
                            </div>
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
                .addTo(map);

            popupParticipateApp.remove();
            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');


            popupContent.classList.add("reactionsPopUp");
            popupTip.classList.add("reactionsPopUp");

            popupContent.classList.remove("ParticipateAppPopUp");
            popupTip.classList.remove("ParticipateAppPopUp");


            popupContent.classList.remove("Rating0");
            popupContent.classList.remove("Rating1");
            popupContent.classList.remove("Rating2");
            popupContent.classList.remove("Rating3");
            popupContent.classList.remove("Rating4");
            popupContent.classList.remove("Rating5");


            popupContent.classList.add(`Rating0`);
            // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

            popupContent.classList.remove("maquetteInDevelopment");
            popupTip.classList.remove("maquetteInDevelopment");
            popupContent.classList.remove("activeMaquette");
            popupTip.classList.remove("activeMaquette");
            popupContent.classList.remove("openQuestions");
            popupTip.classList.remove("openQuestions");
        }

    });

    map.on('touchstart', (e) => {
        if (multitouchDetected == false && raycast == true) {
            const possibleLayers = [
                'UrbanFutureReactionsLayer',
                'UrbanFutureCommentsLayer',
                'UrbanFuturePhotosLayer'
            ];

            // Only include layers that are currently on the map
            const layersToCheck = possibleLayers.filter(layerID => map.getLayer(layerID));

            if (!layersToCheck.length) return; // no active layers to check

            const features = map.queryRenderedFeatures(e.point, {
                layers: layersToCheck
            });

            if (!features.length) {
                popupReactions.remove(); // Or handle safely if popupReactions may be undefined
            }
        }
    });




    map.on('click', 'UrbanFutureReactionsLayer', (e) => {
        popupReactions.remove();
        // map.getCanvas().style.cursor = 'pointer';

        // selectedProject = e.features[0];
        const coordinates = e.features[0].geometry.coordinates.slice();
        const question = e.features[0].properties.question;
        selectedReaction = e.features[0].properties.title;


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }
        const cameraZoom = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
        };

        // map.stop();

        setTimeout(() => {
            map.flyTo({
                center: coordinates,
                zoom: cameraZoom.zoom,
                pitch: cameraZoom.pitch,
                bearing: cameraZoom.bearing,
                essential: true,
                duration: 1000,
            });
        }, 50);


        // rating

        popupReactions
            .setLngLat(coordinates)
            .setHTML(`
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
            .addTo(map);

        popupParticipateApp.remove();
        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');


        popupContent.classList.add("reactionsPopUp");
        popupTip.classList.add("reactionsPopUp");

        popupContent.classList.remove("ParticipateAppPopUp");
        popupTip.classList.remove("ParticipateAppPopUp");


        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");


        popupContent.classList.add(`Rating${e.features[0].properties.rating}`);
        // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");


    });
    map.on('mouseenter', 'UrbanFutureReactionsLayer', () => {
        map.getCanvas().style.cursor = 'pointer';
    });

    map.on('click', 'UrbanFutureCommentsLayer', (e) => {

        popupReactions.remove();
        // map.getCanvas().style.cursor = 'pointer';

        // selectedProject = e.features[0];
        const coordinates = e.features[0].geometry.coordinates.slice();
        const question = e.features[0].properties.question;
        selectedReaction = e.features[0].properties.title;


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }

        const cameraZoom = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
        };

        // map.stop();

        setTimeout(() => {
            map.flyTo({
                center: coordinates,
                zoom: cameraZoom.zoom,
                pitch: cameraZoom.pitch,
                bearing: cameraZoom.bearing,
                essential: true,
                duration: 1000,
            });
        }, 50);


        // rating

        popupReactions
            .setLngLat(coordinates)
            .setHTML(`
                            <div class="questionTitleDiv">
                                <span class="questionTitleSpan">${e.features[0].properties.selected_comment_question}</span>
                            </div>
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
            .addTo(map);

        popupParticipateApp.remove();
        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');


        popupContent.classList.add("reactionsPopUp");
        popupTip.classList.add("reactionsPopUp");

        popupContent.classList.remove("ParticipateAppPopUp");
        popupTip.classList.remove("ParticipateAppPopUp");


        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");


        popupContent.classList.add(`Rating0`);
        // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");


    });
    map.on('mouseenter', 'UrbanFutureCommentsLayer', () => {
        map.getCanvas().style.cursor = 'pointer';
    });

    map.on('click', 'UrbanFuturePhotosLayer', (e) => {

        popupReactions.remove();
        // map.getCanvas().style.cursor = 'pointer';

        // selectedProject = e.features[0];
        const coordinates = e.features[0].geometry.coordinates.slice();
        const question = e.features[0].properties.question;
        selectedReaction = e.features[0].properties.title;


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }

        const cameraZoom = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
        };

        // map.stop();

        setTimeout(() => {
            map.flyTo({
                center: coordinates,
                zoom: cameraZoom.zoom,
                pitch: cameraZoom.pitch,
                bearing: cameraZoom.bearing,
                essential: true,
                duration: 1000,
            });
        }, 50);


        // rating

        popupReactions
            .setLngLat(coordinates)
            .setHTML(`
                            <div class="popupImageDivUF">
                                    <img src=${e.features[0].properties.httpadress} class="popupImageUF"/>
                            </div>
                            <div class="questionTitleDiv">
                                <h3>${e.features[0].properties.comment}</h3>
                            </div>
                        `)
            .addTo(map);

        popupParticipateApp.remove();
        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');


        popupContent.classList.add("reactionsPopUp");
        popupTip.classList.add("reactionsPopUp");

        popupContent.classList.remove("ParticipateAppPopUp");
        popupTip.classList.remove("ParticipateAppPopUp");


        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");


        popupContent.classList.add(`Rating0`);
        // popupTip.classList.add(`Rating${e.features[0].properties.rating}`);

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");


    });
    map.on('mouseenter', 'UrbanFuturePhotosLayer', () => {
        map.getCanvas().style.cursor = 'pointer';
    });


    map.on('click', (e) => {
        let cameraPosition = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
        };
        console.log("cameraPosition", cameraPosition);

        const possibleLayers = [
            'UrbanFutureReactionsLayer',
            'UrbanFutureCommentsLayer',
            'UrbanFuturePhotosLayer'
        ];

        // Only include layers that are currently on the map
        const layersToCheck = possibleLayers.filter(layerID => map.getLayer(layerID));

        if (!layersToCheck.length) return; // no active layers to check

        const features = map.queryRenderedFeatures(e.point, {
            layers: layersToCheck
        });

        if (!features.length) {
            popupReactions.remove(); // Or handle safely if popupReactions may be undefined
        }
    });


}


const ENGAGEMENT_SELECTED_COLOR = '#003d92';
const ENGAGEMENT_CONTAINER_SEL = '#EngagementOptions';
const OPTION_SEL = '.EngagementOptionButtons';
const ICON_SEL = '.EngagementOptionIcon';
const LABEL_SEL = '.EngagementOptionText';

const ENGAGEMENT_ACTIONS = {
    // by label text (fallbacks, case-insensitive)
    informatie: () => { try { iniciateInform(); } catch (_) { } },
    'mee doen': () => { try { iniciateParticipate(); } catch (_) { } },
    resultaten: () => { try { iniciateResults(); } catch (_) { } },
};



function stripActiveSuffix(src) {

    return src.replace(/Active(?=\.svg(\?.*)?$)/, '');
}

function withActiveSuffix(src, isActive) {
    const base = stripActiveSuffix(src);
    if (!isActive) return base;
    // insert "Active" right before the .svg extension, keep any query string
    return base.replace(/(\.svg)(\?.*)?$/, 'Active$1$2');
}


function applyEngagementOptionStyles() {
    const container = document.querySelector(ENGAGEMENT_CONTAINER_SEL);
    if (!container) return;
    const options = container.querySelectorAll(OPTION_SEL);

    options.forEach(opt => {
        const isSelected = (opt.getAttribute('selected') === 'true');
        const img = opt.querySelector(ICON_SEL);
        const label = opt.querySelector(LABEL_SEL);

        // Text color
        if (label) {
            label.style.color = isSelected ? ENGAGEMENT_SELECTED_COLOR : '';
        }

        // Icon swap
        if (img && img.src) {
            img.src = withActiveSuffix(img.src, isSelected);
            // Optional: set alt for accessibility
            if (!img.alt) {
                const txt = label ? label.textContent.trim() : '';
                img.alt = isSelected ? `${txt} (selected)` : txt;
            }
        }

        // Accessibility niceties
        opt.setAttribute('aria-selected', String(isSelected));
        opt.classList.toggle('is-selected', isSelected);
    });
}


function initEngagementOptionsInteractions() {
    if (window.__engagementOptionsBound) return; // avoid double-binding
    const container = document.querySelector(ENGAGEMENT_CONTAINER_SEL);
    if (!container) return;
    const options = Array.from(container.querySelectorAll(OPTION_SEL));
    if (!options.length) return;

    // Make the options behave like radio buttons
    options.forEach(opt => {
        opt.setAttribute('role', 'tab'); // semantics, optional
        opt.addEventListener('click', () => {
            options.forEach(o => o.setAttribute('selected', o === opt ? 'true' : 'false'));
            applyEngagementOptionStyles();
            runSelectedEngagementAction();
        }, { passive: true });
    });

    // Mark container as a tablist for a11y (optional)
    container.setAttribute('role', 'tablist');

    window.__engagementOptionsBound = true;
}

function runSelectedEngagementAction() {
    const selected = getSelectedEngagementOption();
    if (!selected) return;

    // Prefer ID mapping
    const id = selected.id && String(selected.id).trim();
    if (id && ENGAGEMENT_ACTIONS[id]) {
        ENGAGEMENT_ACTIONS[id]();
        return;
    }

    // Fallback: use the visible label text
    const label = selected.querySelector(LABEL_SEL);
    const key = label ? label.textContent.trim().toLowerCase() : '';
    if (key && ENGAGEMENT_ACTIONS[key]) {
        ENGAGEMENT_ACTIONS[key]();
    }
}
function getSelectedEngagementOption() {
    const container = document.querySelector(ENGAGEMENT_CONTAINER_SEL);
    if (!container) return null;
    return container.querySelector(`${OPTION_SEL}[selected="true"]`) || null;
}
function resetEngagementOptions() {
    document.getElementById("EngagementOptionsInform").setAttribute('selected', 'false');
    document.getElementById("EngagementOptionsParticipate").setAttribute('selected', 'true');
    document.getElementById("EngagementOptionsResults").setAttribute('selected', 'false');
}


const ResultsMenuClose = document.getElementById('ResultsMenuClose');
const InformMenuClose = document.getElementById('InformMenuClose');

ResultsMenuClose.addEventListener('click', () => {
    document.getElementById("EngagementOptionsParticipate").click();
});
InformMenuClose.addEventListener('click', () => {
    document.getElementById("EngagementOptionsParticipate").click();
});

// Engagement actions functions:
function iniciateInform() {
    console.log("Inform action initiated");
    if (UrbanFutureSelectOptionsMenuOpen) {
        UrbanFutureTopNavbarSelectOptions.click();
    }
    document.getElementById("ParticipateMenuWrapper").classList.add("UrbanFutureDisplayNone");
    document.getElementById("ResultsMenu").classList.add("UrbanFutureDisplayNone");
    while (document.getElementById("InformAndResultsMenuWrapper").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("InformAndResultsMenuWrapper").classList.remove("UrbanFutureDisplayNone")
    }
    while (document.getElementById("InformMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("InformMenu").classList.remove("UrbanFutureDisplayNone")
    }

    enterInstruction("viaInform");
}

function iniciateParticipate() {

    flyTowards(cameraStartOverview);
    zoomLevelCheck(cameraStartOverview.zoom);
    document.getElementById("InformAndResultsMenuWrapper").classList.add("UrbanFutureDisplayNone");
    document.getElementById("InformMenu").classList.add("UrbanFutureDisplayNone");
    document.getElementById("ResultsMenu").classList.remove("UrbanFutureDisplayNone");

    console.log("Participate action initiated");
}
function iniciateResults() {
    if (UrbanFutureSelectOptionsMenuOpen) {
        UrbanFutureTopNavbarSelectOptions.click();
    }
    console.log("Results action initiated");
    if (typeof window.closeGalleryLightbox === 'function') {
        window.closeGalleryLightbox();
    }
    document.getElementById("InformMenu").classList.add("UrbanFutureDisplayNone");
    document.getElementById("ParticipateMenuWrapper").classList.add("UrbanFutureDisplayNone");

    document.getElementById("InformAndResultsMenuWrapper").classList.remove("UrbanFutureDisplayNone");
    document.getElementById("ResultsMenu").classList.remove("UrbanFutureDisplayNone");
    if (typeof window.selectResultsTab === 'function') {
        window.selectResultsTab('gallery');
    }
}

function launchRandomParticipation() {
    // Check if user is ready to participate
    if (!(ReadyToStart || ReadyToStartViaLogin)) {
        console.log('cannot participate yet - showing introduce menu');
        while (document.getElementById("UserMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UserMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone");
        }
        document.getElementById("UrbanFutureIntroduceButton").click();
        return;
    }

    const points = Array.isArray(window.participationPoints)
        ? window.participationPoints
        : participationPoints;
    if (!points || points.length === 0) return;

    try {
        iniciateParticipate();
    } catch (err) {
        console.warn('Unable to start participation flow.', err);
        return;
    }

    const point = points[Math.floor(Math.random() * points.length)];
    requestAnimationFrame(() => {
        try {
            setCurrentParticipate(point);
        } catch (err) {
            console.warn('Unable to select a random participation point.', err);
        }
    });
}

if (typeof window !== 'undefined') {
    window.launchRandomParticipation = launchRandomParticipation;
}

function launchParticipationForLocation(locationId) {
    // Check if user is ready to participate
    if (!(ReadyToStart || ReadyToStartViaLogin)) {
        console.log('cannot participate yet - showing introduce menu');
        if (typeof window.closeGalleryLightbox === 'function') {
            window.closeGalleryLightbox();
        }
        while (document.getElementById("UserMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UserMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone");
        }
        document.getElementById("UrbanFutureIntroduceButton").click();
        return;
    }

    const points = Array.isArray(window.participationPoints)
        ? window.participationPoints
        : participationPoints;
    if (!points || points.length === 0) return;

    const parsed = Number(locationId);
    const fallback = parseInt(String(locationId ?? '').replace(/\D+/g, ''), 10);
    const locId = Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    if (!Number.isFinite(locId) || locId <= 0) return;

    const point = points.find(p => Number(p.no) === locId);
    if (!point) {
        console.warn('Unable to find participation point for location:', locationId);
        return;
    }

    try {
        if (typeof window.closeGalleryLightbox === 'function') {
            window.closeGalleryLightbox();
        }
        iniciateParticipate();
    } catch (err) {
        console.warn('Unable to start participation flow.', err);
        return;
    }

    requestAnimationFrame(() => {
        try {
            setCurrentParticipate(point);
        } catch (err) {
            console.warn('Unable to select participation point.', err);
        }
    });
}

if (typeof window !== 'undefined') {
    window.launchParticipationForLocation = launchParticipationForLocation;
}



document.addEventListener('DOMContentLoaded', () => {

    initEngagementOptionsInteractions();


    if (typeof UrbanFutureStartExperienceButton !== 'undefined' && UrbanFutureStartExperienceButton) {
        UrbanFutureStartExperienceButton.addEventListener('click', function () {

            resetEngagementOptions();
            applyEngagementOptionStyles();
            runSelectedEngagementAction();

        }, true);
    }
});





// POPUP DEFINITIONS:

const participatePopup = new mapboxgl.Popup({
    offset: 25,
    closeOnClick: false

});
const popup = new mapboxgl.Popup({
    offset: 25,
    closeOnClick: false

});
const popupQuestions = new mapboxgl.Popup({
    offset: 25,
    closeOnClick: false,
    closeButton: false,

});
const popupReactions = new mapboxgl.Popup({
    offset: 25,
    closeOnClick: false,
    closeButton: false,

});
const popupParticipateApp = new mapboxgl.Popup({
    offset: 40,
    closeOnClick: false,
    closeButton: false,

});




var PublicTwinProjects = {
    'type': 'FeatureCollection',
    'features': [

        {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': projectCenter,

            },
            'properties': {
                'title': 'Havenpark Groningen',
                'projectCode': "2025_3_NL_GR_HV",
                "permissions": "public",
                "image": "https://publictwin.info/HavenparkGroningen/content/Images/HavenparkGroningen_Main.png",
                'icon': 'logo1',
                // english: answer questions to help create future visions for Havenpark, Groningen. 
                // dutch: Beantwoord vragen om te helpen bij het creëren van toekomstvisies voor Havenpark, Groningen.
                'description': 'Ontwerp jouw droompark in Stadshavens!',
                "descriptionLong": ".",
                'location': 'Groningen, Netherlands',
                'status': 'active',
                'activeStatus': 'activeMaquette',
                'digitalTwin': "none",
                'digitalTwinLink': "-",
                "advancedSelection": "false",
                "projectSelected": "false",
                "participatoryModuleActive": true,
                "modelID": "-",
                "origin": projectCenter,
                "cameraReset": {
                    center: projectCenter,
                    zoom: isMobileDevice() ? START_ZOOM_MOBILE : START_ZOOM_DESKTOP,
                    bearing: 0,
                    pitch: 0
                },
                "participatoryActions": {
                    'type': 'FeatureCollection',
                    'features': [
                        {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'Point',
                                'coordinetes': [18.6732, 50.2916]
                                //   'coordinates': [19.4513, 51.7788],
                                //   'coordinates': [18.651,50.291],
                            },
                            'properties': {
                                'title': 'Havenpark: Groningen',
                                "image": "https://publictwin.info/HavenparkGroningen/content/Images/HavenparkGroningen_Main.png",
                                'icon': 'participate',
                                'description': 'Hybrid participation workshop, creating visions for the future of Groningen.',
                                'location': 'Groningen, Netherlands',
                                'status': 'active',
                                'openTill': '01.07.2025',
                                "participatoryForm": "https://eoxsnlhinp7.typeform.com/to/bT4Az155",
                                "qrCode": "https://publictwin.info/digital_maquette/content/Urban_Future/Participation/Urban_Future_General_Form.png",
                                // "center":[18.651,50.291],
                                'center': [18.6732, 50.2916],
                                // 'center': [19.4513, 51.7788],
                                "zoom": 14.5,
                                "bearing": -22.396,
                                "pitch": 62.361

                            },
                        },
                    ],
                },
            }
        },

    ]
}





window.onload = function () {
    const urlParams = new URLSearchParams(window.location.search);
    let resetToken = urlParams.get('token');
    let activeProjectValue = urlParams.get('activeProject');
    checkLoadedOrigin();

    console.log(resetToken);
    console.log(activeProjectValue);

    if (resetToken && activeProjectValue) {

        if (activeProjectValue == "Plac Krakowski") {
            document.getElementById('tokenUF').value = resetToken;
            console.log("entering plac Krakowski via password-reset link");
            // Starting with resetToken - allowing for password change:

            // alert(`ID: ${sessionUserID}\nGender: ${sessionUserGender}\nAge: ${sessionUserAge}\nRelation: ${sessionUserRelation}\nEmail: ${sessionUserEmail}\nRole: ${sessionUserRole}`);

            //SETTING UP THE CORRECT STYLES AND VIEW:



            map.once('load', function () {
                const currentStyle = map.getStyle();
                if (currentStyle.sprite && !currentStyle.sprite.includes('cmantxs6m01ii01skcbe76l1u')) {
                    map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u');

                    map.once('style.load', function () {
                        urbanFutureAddProjectElements();
                        urbanFutureMoveLayersToFront();
                        explorePlacKrakowskiReactions();
                        explorePlacKrakowskiComments();
                        explorePlacKrakowskiPhotos();
                    });
                } else {
                    explorePlacKrakowskiReactions();
                    explorePlacKrakowskiComments();
                    explorePlacKrakowskiPhotos();
                }
            });




            if (locationTypeAction == "PinBased") {
                let cameraMoveTo = cameraStartOverview;
                flyTowards(cameraMoveTo);

            } else {
                UpdateLocationToUser();

            }

            // zoomLevelCheck(cameraMoveTo.zoom);


            console.log("hidding the main menu:");
            document.getElementById("UserMenuUrbanFuture").style.display = "none";
            document.getElementById("UserMenuUrbanFuture").style.visibility = "hidden";

            // document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")



            document.getElementById("StartIncompleteMessage").innerHTML = "";


            // hidding login menu on project start - as a double check:
            document.getElementById("closeMediaGalleryImage").style.display = "none";
            document.getElementById("loginMenu").style.display = "none";
            document.getElementById("mainMenuWrapper").style.display = "none";
            document.getElementById("mainMenuMasterplanWrapper").style.display = "none";

            startParticipationUrbanFuture();


            console.log("hidding the login menu");
            // Showing the password reset menu:
            showElement(document.getElementById("UserLoginMenuUrbanFuture"));

            toggleRemindTokenFunctionUF();

        }
    } else if (resetToken) {
        // Show the password reset form and set the token value
        // to ensure that password reset is shown on link click:
        document.getElementById("UrbanFutureLoginButton").click();

        // document.getElementById('passwordResetDiv').style.display = 'block';
        document.getElementById('tokenUF').value = resetToken;

        menuSignUpDiv.style.display = 'none';
        menuLogInDiv.style.display = 'none';
        passwordResetRequestDiv.style.display = 'none';
    }

};

function checkLoadedOrigin() {
    if (window.self !== window.top) {


        let url = window.location.href;

        // Create a URL object
        let urlObj = new URL(url);

        // Use URLSearchParams to extract the value
        let params = new URLSearchParams(urlObj.search);

        // Retrieve the value of the parameter
        let activeProjectValue = params.get('activeProject');

        // Iniciate project start sequence:

        if (map.getStyle().sprite && !map.getStyle().sprite.includes('cmantxs6m01ii01skcbe76l1u')) {
            map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u');


            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        } else {
            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        }

        // Adjustment of loaded origin based in embedding - not needed in Phase 2:

        // document.getElementById("UrbanFutureIntroduceCloseButton").classList.remove("UrbanFutureDisplayNone");

        // document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone");
        // document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone");
        // document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")

        // document.getElementById("StartIncompleteMessage").innerHTML = "";

        // startParticipationUrbanFuture();


    } else {
    }


}

function setPinsVisibility(show) {
    const pins = window.__participationPins?.pins || [];
    const display = show ? 'flex' : 'none'; // your .camera-pin uses flex
    for (const p of pins) {
        const wrap = p?.wrap; // <-- wrapper that contains button + badge
        if (!wrap) continue;

        wrap.style.display = display;
        wrap.setAttribute("aria-hidden", String(!show));
        // be extra safe: when hidden, don’t allow any interactions
        wrap.style.pointerEvents = show ? "auto" : "none";
    }

    const pinsPhotos = window.__photoPins?.pins || [];
    const displayPhotos = show ? 'flex' : 'none'; // your .camera-pin uses flex
    for (const p of pinsPhotos) {
        if (p?.el) {
            p.el.style.display = displayPhotos;
            p.el.setAttribute('aria-hidden', String(!show));
        }
    }




}


function zoomLevelCheck(targetZoomLevel) {



    let functionZoomLevel = null;
    if (targetZoomLevel) {
        functionZoomLevel = targetZoomLevel;
        console.log("target zoom", functionZoomLevel)
    } else {
        functionZoomLevel = map.getZoom();
        // console.log("no target zoom provided:", functionZoomLevel);
    }


    setPinsVisibility(functionZoomLevel >= zoomLevelThreshold);

    if (functionZoomLevel < zoomLevelThreshold) {

        if (map.getLayer("PTProjects")) {
            map.setLayoutProperty("PTProjects", 'visibility', 'visible');
        }
        // Show "Aan de slag!" button at far zoom out
        const startBtn = document.getElementById('StartParticipateButton');
        if (startBtn) startBtn.classList.add('visible');
        // Hide "Klik op een beeld" button at far zoom out
        const selectPinBtn = document.getElementById('SelectPinButton');
        if (selectPinBtn) selectPinBtn.classList.remove('visible');
    }
    else {

        if (map.getLayer("PTProjects")) {
            map.setLayoutProperty("PTProjects", 'visibility', 'none');
        }
        popup.remove();
        // Hide "Aan de slag!" button when zoomed in
        const startBtn = document.getElementById('StartParticipateButton');
        if (startBtn) startBtn.classList.remove('visible');
        // Show "Klik op een beeld" button when zoomed in
        const selectPinBtn = document.getElementById('SelectPinButton');
        if (selectPinBtn) selectPinBtn.classList.add('visible');
    }


}


// mouse position vector:
const mouse = new THREE.Vector2();

// window sizes parameters:
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
const cameraStart = {
    zoom: 16,
    center: [4.358780, 52.00236828785361],
    pitch: 60,
    bearing: 35,

};






function handleUrl() {
    // URL analysis functionality:
    let url = window.location.href;

    // Create a URL object
    let urlObj = new URL(url);

    // Use URLSearchParams to extract the value
    let params = new URLSearchParams(urlObj.search);

    // Retrieve the value of the parameter
    let activeProjectValue = params.get('activeProject');


    if (activeProjectValue !== null) {
        // alert(`The value of myVariable is: ${activeProjectValue}`);

        if (activeProjectValue == "Plac Krakowski") {

            if (window.innerWidth <= 768) {
                document.getElementById("OnlyMobileAction").classList.add("OnlyMobileActionHidden")
                while (document.getElementById("OnlyMobileAction").classList.contains("OnlyMobileActionVisible")) {
                    document.getElementById("OnlyMobileAction").classList.remove("OnlyMobileActionVisible");
                }

            } else {
                // console.log("set only mobile visible")

                // Changing for desktop-based-action:
                // document.getElementById("OnlyMobileAction").classList.add("OnlyMobileActionVisible")
                // while(document.getElementById("OnlyMobileAction").classList.contains("OnlyMobileActionHidden")){
                //     document.getElementById("OnlyMobileAction").classList.remove("OnlyMobileActionHidden");
                // }

            }
            // document.documentElement.requestFullscreen();

            // document.getElementById("UserMenuUrbanFuture").style.display="none";
            // document.getElementById("UserMenuUrbanFuture").style.visibility="hidden";
        }
        else {

            // comment for now:
            // document.getElementById("UserMenuUrbanFuture").style.display="none";
            // document.getElementById("UserMenuUrbanFuture").style.visibility="hidden";
        }

        URLBasedProject = activeProjectValue;

        for (var i = 0; i < PublicTwinProjects.features.length; i++) {

            // console.log("publicTwin projects:",PublicTwinProjects.features);

            if (PublicTwinProjects.features[i].properties.title == activeProjectValue) {
                selectedProject = PublicTwinProjects.features[i];
                // console.log("project selected via URL:", selectedProject);
                handleButtonClick(selectedProject.properties.title, selectedProject.geometry.coordinates);
            }
            else {
                // console.log("no project match");
            }

        };

    } else {
        // comment for now will add later:
        // alert('activeProject is not present in the URL');
        // document.getElementById("UserMenuUrbanFuture").style.display="none";
        // document.getElementById("UserMenuUrbanFuture").style.visibility="hidden";
    }



};

function handleButtonClick(title, coordinates, popup) {

    if (selectedProject.properties.status == "active") {



        if (selectedProject.properties.title == "Plac Krakowski") {
            // original mapbox standard style:
            // map.setStyle('mapbox://styles/mapbox/standard');

            // updated and cleaned:
            let isMobile = window.innerWidth <= 768; // Define your mobile breakpoint

            if (isMobile) {

            }

            if (window.self !== window.top) {
                map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u')

                map.once('style.load', function () {
                    urbanFutureAddProjectElements();
                });
            } else {

            }



            activeModel = "Plac Krakowski";

            let cameraMoveTo = cameraStartOverview

            flyTowards(cameraMoveTo);

            enterProject(title);
            zoomLevelCheck(cameraMoveTo.zoom);

            // console.log(layers);
            try {
                checkOrder();
            } catch {

            }


            window.addEventListener("load", function () {
                setTimeout(function () {
                    window.scrollTo(0, 1); // Scroll 1px to trigger URL bar hide
                }, 0);
            });

        }

    }
    else {
        accessStatus.innerHTML = "projects is not active!"
    }


}

function enterProject(title) {

    popup.remove();

}




// Utility function to calculate the distance between two touch points
function calculateDistance(point1, point2) {
    const dx = point1.x - point2.x;
    const dy = point1.y - point2.y;
    return Math.sqrt(dx * dx + dy * dy);
}



//camera adjustments:

function flyTowards(target) {

    const isMobile = window.innerWidth <= 768; // Define your mobile breakpoint

    if (isMobile) {
        const isLowEndDevice = () => {
            return navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4;
        };

        if (!isLowEndDevice()) {
            // console.log("on mobile")
            map.easeTo({
                ...target,
                duration: 1000, // Smooth easing with shorter duration
                essential: true
            });

        } else {
            // console.log("on mobile, low-end")
            map.jumpTo(target); // Instant transition for low-end devices
        }


    } else {
        // console.log("not on mobile")
        map.flyTo({
            ...target,
            duration: 2000,
            essential: true,
        });
    }

    setTimeout(() => {
        map.setMaxBounds(bounds);
    }, 2000);


    // map.flyTo({
    //     ...target,
    //     duration:2000,
    //     essential: true,
    //     animate:true,
    // }



}




function checkLoginStatus(fromIframe = false, iframeData = {}) {
    fetch('https://publictwin.info/digital_maquette/php_scripts/check_login_status.php', {
        method: 'GET',
        credentials: 'include',   // <= important
    })
        .then(response => response.json())
        .then(data => {

            // URL verification to check what needs to happen afeter the user loggs in correctly:

            let url = window.location.href;

            // Create a URL object
            let urlObj = new URL(url);

            // Use URLSearchParams to extract the value
            let params = new URLSearchParams(urlObj.search);

            // Retrieve the value of the parameter
            let activeProjectValue = params.get('activeProject');
            console.log(activeProjectValue)




            if (data.isLoggedIn) {
                // document.getElementById("UrbanFutureTopNavbarSelectOptions").click();
                ReadyToStartViaLogin = true;
                document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#003d92";
                document.getElementById("UrbanFutureStartExperienceButton").classList.add("override-color");
                document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
                document.getElementById("StartIncompleteMessage").innerHTML = "";

                document.getElementById("UrbanFutureLoginButton").setAttribute("loggedInStatus", "true");
                document.getElementById("UrbanFutureLoginButton").innerHTML = `<img class="CheckboxMainMenuIcon"
                                src="https://publictwin.info/HavenparkGroningen/content/Icons/UnlockIcon.svg" />
                            <span>gebruikerspaneel!</span>`;

                document.getElementById("userEmailUF").innerText = data.email;
                document.getElementById("userRoleUF").innerText = data.user_role;
                document.getElementById("userPermissionsUF").innerText = data.user_permissions;

                sessionStorage.setItem('loginUserID', data.user_id);

                userPermissionsStatus = data.user_permissions;
                userProjectPermissionsStatus = data.project_permissions;

                if (userPermissionsStatus == "KOM" || userPermissionsStatus == "admin" || userProjectPermissionsStatus.includes("HPGroningen")) {
                    showElement(document.getElementById("AnalyticsTriggerButton"));
                    while (document.getElementById("UrbanFutureScanningSegment").classList.contains("NonActiveSegment")) {
                        document.getElementById("UrbanFutureScanningSegment").classList.remove("NonActiveSegment");
                    }
                }
                document.getElementById("UrbanFutureLoginBack").click();


            } else {
                ReadyToStartViaLogin = false;
                if (ReadyToStart == false) {
                    document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#616161";
                    document.getElementById("UrbanFutureStartExperienceButton").classList.remove("override-color");
                }

                document.getElementById("UrbanFutureLoginButton").setAttribute("loggedInStatus", "false");
                document.getElementById("UrbanFutureLoginButton").innerHTML = `<img class="CheckboxMainMenuIcon"
                                src="https://publictwin.info/HavenparkGroningen/content/Icons/LockIcon.svg" />
                            <span>login!</span>`;
                sessionStorage.setItem('loginUserID', "-");

                hideElement(document.getElementById("AnalyticsTriggerButton"));
                document.getElementById("UrbanFutureScanningSegment").classList.add("NonActiveSegment");
                hideElement(document.getElementById("reactionsFilteringSystem"));


            }

            if (fromIframe == true) {
                console.log("checking login status via iframe")
                if (iframeData.isLoggedIn == "true") {
                    ReadyToStartViaLogin = true;
                    document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#003d92";
                    document.getElementById("UrbanFutureStartExperienceButton").classList.add("override-color");
                    document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
                    document.getElementById("StartIncompleteMessage").innerHTML = "";
                    // console.log(iframeData);
                    // document.getElementById("UrbanFutureTopNavbarSelectOptions").click();

                    document.getElementById("UrbanFutureLoginButton").setAttribute("loggedInStatus", "true");

                    document.getElementById("userEmailUF").innerText = iframeData.email;
                    document.getElementById("userRoleUF").innerText = iframeData.user_role;
                    document.getElementById("userPermissionsUF").innerText = iframeData.user_permissions;

                    sessionStorage.setItem('loginUserID', iframeData.user_id);

                    userPermissionsStatus = iframeData.user_permissions;
                    userProjectPermissionsStatus = iframeData.project_permissions;

                    document.getElementById("UrbanFutureLoginButton").innerHTML = `<img class="CheckboxMainMenuIcon"
                                src="https://publictwin.info/HavenparkGroningen/content/Icons/UnlockIcon.svg" />
                            <span>gebruikerspaneel!</span>`;

                    if (userPermissionsStatus == "KOM" || userPermissionsStatus == "admin" || userProjectPermissionsStatus.includes("HPGroningen")) {
                        showElement(document.getElementById("AnalyticsTriggerButton"));
                        while (document.getElementById("UrbanFutureScanningSegment").classList.contains("NonActiveSegment")) {
                            document.getElementById("UrbanFutureScanningSegment").classList.remove("NonActiveSegment");
                        }
                    }

                }
                else {
                    ReadyToStartViaLogin = false;
                    if (ReadyToStart == false) {
                        document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#616161";
                        document.getElementById("UrbanFutureStartExperienceButton").classList.remove("override-color");
                    }

                    document.getElementById("UrbanFutureLoginButton").setAttribute("loggedInStatus", "false");
                    sessionStorage.setItem('loginUserID', "-");
                    document.getElementById("UrbanFutureLoginButton").innerHTML = `<img class="CheckboxMainMenuIcon"
                                src="https://publictwin.info/HavenparkGroningen/content/Icons/LockIcon.svg" />
                            <span>login!</span>`;

                    hideElement(document.getElementById("AnalyticsTriggerButton"));
                    document.getElementById("UrbanFutureScanningSegment").classList.add("NonActiveSegment");
                }

            } else {

            }




        })
        .catch(error => console.error('Error:', error));
}







// Plac Krakowski functionalities:





var PinQuestions = {
    'type': 'FeatureCollection',
    'features': [
        {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': [18.6737, 50.2926],
            },
            'properties': {
                'title': 'Pytania_Otwarte_01',
                'icon': 'IconLike',
                'question': 'Czym Plac Cię zachęca? Które elementy są dla Ciebie ważne?',
                "origin": [18.6737, 50.2926],
                "cameraReset": {
                    center: [18.6737, 50.2926],
                    zoom: 16.00,
                    bearing: 45,
                    pitch: 45,
                },
            }
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': [18.6726, 50.2909],
            },
            'properties': {
                'title': 'Pytania_Otwarte_02',
                'icon': 'IconDislike',
                'question': 'Czym plac cię zniechęca? Co warto zmienić, żeby był lepszym miejscem?',
                "origin": [18.6726, 50.2909],
                "cameraReset": {
                    center: [18.6726, 50.2909],
                    zoom: 16.00,
                    bearing: 45,
                    pitch: 45,
                },
            }
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': [18.6732, 50.2916],
            },
            'properties': {
                'title': 'Pytania_Otwarte_03',
                'icon': 'IconIdentity',
                'question': 'Czym Plac jest dla miasta? Czym jest dla Ciebie? Dla nas?',
                "origin": [18.6732, 50.2916],
                "cameraReset": {
                    center: [18.6732, 50.2916],
                    zoom: 16.00,
                    bearing: 45,
                    pitch: 45,
                },
            }
        },
        {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': [18.6742, 50.2917],
            },
            'properties': {
                'title': 'Pytania_Otwarte_04',
                'icon': 'IconActivity',
                'question': 'Jak korzystasz z placu? Czy tylko przechodzisz, czy zostajesz na dłużej?',
                "origin": [18.6742, 50.2917],
                "cameraReset": {
                    center: [18.6742, 50.2917],
                    zoom: 16.00,
                    bearing: 45,
                    pitch: 45,
                },
            }
        },
    ]
}






let locationTypeAction = "PinBased";
let modelTypeSelection = "3Dmodel";
let cameraFunctionActive = false;
locationTypeAction = "PinBased";
if (locationTypeAction == "PinBased") {
    document.getElementById("UFParticipationIcon").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CameraIconGrey.png";
    document.getElementById("UrbanFutureParticipationPhotoCoinIcon").style.display = "none";
    cameraFunctionActive = false;
}
let locationTypeActionNew = "";

let sessionIntroduceComplete = null;
let sessionRoleComplete = null;
let sessionSurveyComplete = null;
let sessionLocationComplete = null;
let lastKnownUserCoords = null;

let sessionUserGender = null;
let sessionUserAge = null;
let sessionUserRelation = null;
let sessionUserRelationBusiness = null;
let sessionUserEmail = "";
let introduceReadyToSave = false;
let ReadyToStart = false;
let roleReadyToSave = false;
let sessionUserRole = null;
let sessionPTCoins = 0;
let UrbanFutureSelectOptionsMenuOpen = false;
let slectedReactionValue = 0;
let slectedReactionComment = "-";
let slectedCommentQuestion = "-"
let dataToSubmit = {};
let capturedState = false;
let openMenu = "";
let selectedQuestion = "";
let selectedReaction = "";

let locatingEnabled = false;
let QuestionImagesLoaded = 0;

document.getElementById("CameraSubmitButton").style.backgroundColor = "#d0af2d";

// to be defined based on user - if logged in should be different than if not:
sessionStorage.setItem('userRole', "partycypacyjny nowicjusz");
sessionUserRole = sessionStorage.getItem('userRole');
document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

const PlacKrakowskiDropPinMarker = new mapboxgl.Marker({
    draggable: true,
    color: "#003d92",
})



const introduceCheckbox = document.getElementById('introduceCheckbox');


if (!sessionStorage.getItem('userPTCoins')) {
    sessionStorage.setItem('userPTCoins', 0);
    sessionPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
} else {
    sessionPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
}

function checkCoinsRole() {
    if (sessionStorage.getItem('userPTCoins')) {
        if (parseInt(sessionStorage.getItem('userPTCoins')) >= 1000) {
            sessionStorage.setItem('userRole', "lokalny wizjoner");
            sessionUserRole = sessionStorage.getItem('userRole');
            document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

        } else if (parseInt(sessionStorage.getItem('userPTCoins')) < 1000 && parseInt(sessionStorage.getItem('userPTCoins')) >= 300) {
            sessionStorage.setItem('userRole', "kurator przestrzeni");
            sessionUserRole = sessionStorage.getItem('userRole');
            document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

        } else if (parseInt(sessionStorage.getItem('userPTCoins')) < 300 && parseInt(sessionStorage.getItem('userPTCoins')) >= 150) {
            sessionStorage.setItem('userRole', "miejski tropiciel");
            sessionUserRole = sessionStorage.getItem('userRole');
            document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

        } else {
            sessionStorage.setItem('userRole', "partycypacyjny nowicjusz");
            sessionUserRole = sessionStorage.getItem('userRole');
            document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

        }

    }
}

document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');

sessionIntroduceComplete = sessionStorage.getItem('IntroduceComplete');
sessionSurveyComplete = sessionStorage.getItem('SurveyComplete');
sessionLocationComplete = sessionStorage.getItem('LocationComplete');

checkSessionAndBoxes();

// Main menu buttons:

let UrbanFutureIntroduceButton = document.getElementById("UrbanFutureIntroduceButton")
let UrbanFutureInstructionButton = document.getElementById("UrbanFutureInstructionButton")
let UrbanFutureWebsiteButton = document.getElementById("UrbanFutureWebsiteButton")

let UrbanFutureLocationButton = document.getElementById("UrbanFutureLocationButton")
let UrbanFutureLocationPinButton = document.getElementById("UrbanFutureLocationPinButton")


let UrbanFutureStartExperienceButton = document.getElementById("UrbanFutureStartExperienceButton")
let UrbanFutureSurveyButton = document.getElementById("UrbanFutureSurveyButton")

let UrbanFutureContactButton = document.getElementById("UrbanFutureContactButton");

let UrbanFutureScanningButton = document.getElementById("UrbanFutureScanningButton");

UrbanFutureScanningButton.addEventListener("click", function () {
    window.open('https://publictwin.info/HavenparkGroningen/scanningApp/', '_blank');
});
UrbanFutureWebsiteButton.addEventListener("click", function () {
    window.open('https://stadshavens.nl/havenpark/', '_blank');
});



document.getElementById('introduceCheckbox').checked = false;


UrbanFutureIntroduceButton.addEventListener("click", function () {
    document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")
    while (document.getElementById("UrbanFutureIntroduceMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureIntroduceMenu").classList.remove("UrbanFutureDisplayNone")
    }


}, true);

function enterInstruction(entered = "viaOther") {
    if (entered == "viaButton") {
        UrbanFutureRoleBack.setAttribute("enteredfrom", "viaButton");
    }
    else if (entered == "viaInform") {
        UrbanFutureRoleBack.setAttribute("enteredfrom", "viaInform");
    } else {
        UrbanFutureRoleBack.setAttribute("enteredfrom", "viaOther");
    }
    document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")
    while (document.getElementById("UrbanFutureChooseRoleMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.remove("UrbanFutureDisplayNone")
    }

}

UrbanFutureInstructionButton.addEventListener("click", function () {
    enterInstruction("viaButton");
}, true);


UrbanFutureLocationButton.addEventListener("click", function () {

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const userLongitude = position.coords.longitude;
            const userLatitude = position.coords.latitude;
            // setCheckboxState(locationCheckbox,true);

            if (!sessionStorage.getItem('LocationComplete')) {
                sessionPTCoins += 25;
                sessionStorage.setItem('userPTCoins', sessionPTCoins);
                checkCoinsRole()

                document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
            }

            sessionStorage.setItem('LocationComplete', "true");
            sessionLocationComplete = sessionStorage.getItem('LocationComplete');

            // document.getElementById("LocationCoinDiv").style.display="none";

            // locationTypeAction = "UserPositionBased";
            // document.getElementById("UrbanFutureLocateUser").click();
            locateUserPositionBasedClick();

            UrbanFutureLocationButton.style.backgroundColor = "#F9D235";
            UrbanFutureLocationPinButton.style.backgroundColor = "#FCEFC7";
            document.getElementById("StartIncompleteMessage").innerHTML = "partycypacja na podstawie lokalizacji";


        },
        (error) => {
            // console.log("Error getting location", error);
            // document.getElementById("StartIncompleteMessage").innerHTML="please, enable location services!";

            console.log("Unable to retrieve your location.");
            console.log("Switching to pin based location system.");
            document.getElementById("StartIncompleteMessage").innerHTML = "zezwól na usługi lokalizacji";

            UrbanFutureLocationButton.style.backgroundColor = "#F9D235";
            UrbanFutureLocationPinButton.style.backgroundColor = "#FCEFC7";

            setTimeout(() => {
                // Your function or code here
                UrbanFutureLocationPinButton.click();
            }, 1000);



        }
    );
    if (navigator.permissions) {
        navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
            if (result.state === 'granted') {
                // User already allowed geolocation
                // console.log("Geolocation permission granted.");

                // setCheckboxState(locationCheckbox,true);
            } else {
                // Not granted yet or denied
                // console.log("Geolocation permission not granted.");
                // document.getElementById("StartIncompleteMessage").innerHTML="please, enable location services!";
            }
        });
    } else {
        // Fallback if Permissions API is not supported
        // console.log("Permissions API not supported.");
    }


}, true);


UrbanFutureLocationPinButton.addEventListener("click", function () {

    // locationTypeAction = "PinBased";
    // document.getElementById("UrbanFutureLocatePin").click();
    locatePinPositionBasedClick();

    UrbanFutureLocationPinButton.style.backgroundColor = "#F9D235";
    UrbanFutureLocationButton.style.backgroundColor = "#FCEFC7";

    sessionStorage.setItem('LocationComplete', "true");
    sessionLocationComplete = sessionStorage.getItem('LocationComplete');
    document.getElementById("StartIncompleteMessage").innerHTML = "partycypacja na podstawie pinezki";

}, true);



UrbanFutureSurveyButton.addEventListener("click", function () {

    document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")

    while (document.getElementById("UrbanFutureSurveyMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureSurveyMenu").classList.remove("UrbanFutureDisplayNone")
    }

}, true);

UrbanFutureContactButton.addEventListener("click", function () {

    document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureSurveyMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")

    while (document.getElementById("UrbanFutureContactMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureContactMenu").classList.remove("UrbanFutureDisplayNone")
    }
    if (sessionStorage.getItem('userEmail')) {
        // let selectedValue = this.value;
        // sessionStorage.setItem('userEmail', selectedValue);
        // sessionUserEmail = sessionStorage.getItem('userEmail');
        document.getElementById("UFFormEmailMessage").value = sessionStorage.getItem('userEmail');
    }

}, true);

document.getElementById("UrbanFutureIntroduceCloseButton").addEventListener("click", function () {
    document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone");
});


UrbanFutureStartExperienceButton.addEventListener("click", function () {
    if (ReadyToStart || ReadyToStartViaLogin) {
        // alert(`ID: ${sessionUserID}\nGender: ${sessionUserGender}\nAge: ${sessionUserAge}\nRelation: ${sessionUserRelation}\nEmail: ${sessionUserEmail}\nRole: ${sessionUserRole}`);

        if (map.getStyle().sprite && !map.getStyle().sprite.includes('cmantxs6m01ii01skcbe76l1u')) {
            map.setStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u');


            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        } else {
            urbanFutureAddProjectElements();
            urbanFutureMoveLayersToFront();

        }


        if (locationTypeAction == "PinBased") {
            let cameraMoveTo = cameraStartOverview;
            flyTowards(cameraMoveTo);

        }

        document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone");
        document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone");
        document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")


        startParticipationUrbanFuture();



        // startLocating();
    }
    else {
        // alert(`ID: ${sessionUserID}\nGender: ${sessionUserGender}\nAge: ${sessionUserAge}\nRelation: ${sessionUserRelation}\nEmail: ${sessionUserEmail}\nRole: ${sessionUserRole}`);
        document.getElementById("StartIncompleteMessage").innerHTML = 'vul in de secties gemarkeerd met <img class="UFIconCoin WithMargins" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/IconSections.png"/>!';

    }
}, true);




let UrbanFutureSurveyBack = document.getElementById("UrbanFutureSurveyBack");
let UrbanFutureSurveySave = document.getElementById("UrbanFutureSurveySave");
document.getElementById("UrbanFutureSurveySave").style.backgroundColor = "#003d92";
document.getElementById("UrbanFutureSurveySave").style.setProperty("color", "white", "important");

UrbanFutureSurveySave.setAttribute("active", "true");

UrbanFutureSurveyBack.addEventListener("click", function () {

    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureSurveyMenu").classList.add("UrbanFutureDisplayNone")

    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone");

    }

}, true);

UrbanFutureSurveySave.addEventListener("click", function () {

    if (UrbanFutureSurveySave.getAttribute("active") == "true") {

        console.log("clicking the button")
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureSurveyMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")


        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
        }

        submitSurveyResponse();

        if (!sessionStorage.getItem('SurveyComplete')) {
            sessionPTCoins += 75;
            sessionStorage.setItem('userPTCoins', sessionPTCoins);
            checkCoinsRole();
            document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
        }

        sessionStorage.setItem('SurveyComplete', "true");
        sessionSurveyComplete = sessionStorage.getItem('SurveyComplete');

        document.getElementById("SurveyCoinDiv").style.display = "none";

    }
    if (UrbanFutureSurveySave.getAttribute("active") == "true") {
        const reasonOptions = Array.from(document.getElementById("UFFormReason").selectedOptions);
        const reasonValues = reasonOptions.map(opt => opt.value).join(", ");

        const associations = document.getElementById("UFFormAssociations").value || "-";
        const meaningDistrict = document.getElementById("UFSliderClose").value || 3;
        const meaningCampus = document.getElementById("UFSliderUni").value || 3;
        const meaningCity = document.getElementById("UFSliderCity").value || 3;
        const relationWeight = document.getElementById("UFSliderRole").value || 3;
        const campusAnswer = document.getElementById("UFFormCampus").value || "-";
        const elementAnswer = document.getElementById("UFFormElements").value || "-";

        fetch("https://publictwin.info/digital_maquette/php_scripts/PlacKrakowski_User_UpdateSurvey.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ip: userIP,
                Pytanie_1_Cel: reasonValues,
                Pytanie_2_Skojarzenia: associations,
                Pytanie_3a_ZnaczenieDlaDielnicy: meaningDistrict,
                Pytanie_3b_ZnaczenieDlaUczelni: meaningCampus,
                Pytanie_3c_ZnaczenieDlaMiasta: meaningCity,
                Pytanie_4_Powiazanie: relationWeight,
                Pytanie_5_Campus: campusAnswer,
                Pytanie_6_Elementy: elementAnswer
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log("Survey update result:", data.status);
            })
            .catch(error => {
                console.error("Survey update failed:", error);
            });
    }
    if (UrbanFutureSurveySave.getAttribute("active") == "true") {
        setUserSessionActive();
    }

}, true);


// Role menu save buttons:
let UrbanFutureRoleBack = document.getElementById("UrbanFutureRoleBack")
// let UrbanFutureRoleSave = document.getElementById("UrbanFutureRoleSave")



UrbanFutureRoleBack.addEventListener("click", function () {

    if (UrbanFutureRoleBack.getAttribute("enteredfrom") == "viaButton") {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone");

        }
        // setCheckboxState(roleCheckbox,true);        
        // document.getElementById('introduceCheckbox').classList.add('locked-checked');
        if (!sessionStorage.getItem('RoleComplete')) {
            sessionPTCoins += 25;
            checkCoinsRole();
            sessionStorage.setItem('userPTCoins', sessionPTCoins);

            document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
        }
        sessionStorage.setItem('RoleComplete', "true");
        sessionRoleComplete = sessionStorage.getItem('RoleComplete');

        // document.getElementById("RoleCoinDiv").style.display="none";
    }
    else if (UrbanFutureRoleBack.getAttribute("enteredfrom") == "viaInform") {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone");

        }
        UrbanFutureStartExperienceButton.click();
        // setCheckboxState(roleCheckbox,true);        
        // document.getElementById('introduceCheckbox').classList.add('locked-checked');
        if (!sessionStorage.getItem('RoleComplete')) {
            sessionPTCoins += 25;
            checkCoinsRole();
            sessionStorage.setItem('userPTCoins', sessionPTCoins);

            document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
        }
        sessionStorage.setItem('RoleComplete', "true");
        sessionRoleComplete = sessionStorage.getItem('RoleComplete');

    }

}, true);


let UrbanFutureIntroduceSave = document.getElementById("UrbanFutureIntroduceSave")
let UrbanFutureIntroduceBack = document.getElementById("UrbanFutureIntroduceBack")

UrbanFutureIntroduceBack.addEventListener("click", function () {
    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
    }
    document.getElementById("UserMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")
}, true);

UrbanFutureIntroduceSave.addEventListener("click", function () {
    if (UrbanFutureIntroduceSave.getAttribute("active") == "true") {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")

            setCheckboxState(introduceCheckbox, true);
            // document.getElementById('introduceCheckbox').classList.add('locked-checked');
            document.getElementById("IntrouceIncompleteMessage").innerHTML = "";

            if (!sessionStorage.getItem('IntroduceComplete')) {
                sessionPTCoins += 25;
                checkCoinsRole();
                sessionStorage.setItem('userPTCoins', sessionPTCoins);

                document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
            }

            sessionStorage.setItem('IntroduceComplete', "true");
            sessionIntroduceComplete = sessionStorage.getItem('IntroduceComplete');

            document.getElementById("IntroductionCoinDiv").style.display = "none";

        }
        document.getElementById("UrbanFutureStartExperienceButton").click();
    } else {
        document.getElementById("IntrouceIncompleteMessage").innerHTML = "*Selecteer een optie in elk verplicht veld!"
    }

    if (UrbanFutureIntroduceSave.getAttribute("active") == "true") {
        // Get form values
        let age = document.getElementById("UFFormAge").value || "-";
        let gender = document.getElementById("UFFormGender").value || "-";
        let relation = document.getElementById("UFFormRelation").value || "-";

        if (relation === "anders, namelijk:") {
            relation = document.getElementById("UFFormRelationSelf").value || "-";
        } else {
            relation = document.getElementById("UFFormRelation").value || "-";
        }
        let email = document.getElementById("UFFormEmail").value || "-";

        // Send data to PHP backend
        fetch("https://publictwin.info/EngagementAppPrototypes/MainPHP/User_UpdateIntro.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                table: databaseUsersName,
                ip: userIP,
                age_group: age,
                gender: gender,
                relation_to_place: relation,
                email: email,
                user_identifier: sessionStorage.getItem('userID')
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log("Update status:", data.status);
            })
            .catch(err => {
                console.error("Update failed:", err);
            });

        // Continue with UI changes...
        // [same logic as in your current function]
    } else {
        document.getElementById("IntrouceIncompleteMessage").innerHTML = "*Selecteer een optie in elk verplicht veld!";
    }
    if (UrbanFutureIntroduceSave.getAttribute("active") == "true") {
        setUserSessionActive();
    }

}, true);


// login menu back:
let UrbanFutureLoginBack = document.getElementById("UrbanFutureLoginBack")

UrbanFutureLoginBack.addEventListener("click", function () {

    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureContactMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UserLoginMenuUrbanFuture").classList.add("UrbanFutureDisplayNone")


    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
    }

}, true);



// Introduce menu save buttons:
let UrbanFutureContactBack = document.getElementById("UrbanFutureContactBack")
let UrbanFutureContactSave = document.getElementById("UrbanFutureContactSave")
UrbanFutureContactSave.style.backgroundColor = "#f9d235";
UrbanFutureContactSave.setAttribute("active", "true");



UrbanFutureContactBack.addEventListener("click", function () {

    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureContactMenu").classList.add("UrbanFutureDisplayNone")


    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
    }

}, true);

UrbanFutureContactSave.addEventListener("click", function () {
    if (UrbanFutureContactSave.getAttribute("active") == "true") {
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureContactMenu").classList.add("UrbanFutureDisplayNone")


        while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
        }


        document.getElementById("IntrouceIncompleteMessage").innerHTML = "";


        const userEmail = document.getElementById('UFFormEmailMessage').value.trim();
        const userMessage = document.getElementById('UFFormMessage').value.trim();

        fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/sendContactEmail.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                from: userEmail,
                message: userMessage
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // alert("Wiadomość została wysłana!");
                } else {
                    // alert("Wystąpił błąd: " + data.error);
                }
            });

    }
    else {
        document.getElementById("IntrouceIncompleteMessage").innerHTML = "*select an option in each complusory field!"
    }

}, true);


document.getElementById('UFFormGender').addEventListener('change', function () {
    let selectedValue = this.value;

    // console.log("Selected gender:", selectedValue);

    // Set session gender item:
    sessionStorage.setItem('userGender', selectedValue);
    sessionUserGender = sessionStorage.getItem('userGender');

    checkIfIntroReady();




});
function checkIfIntroReady() {

    if (sessionUserGender != null && sessionUserRelation != null && sessionUserAge != null && sessionUserID != null) {
        introduceReadyToSave = true;

        if (introduceReadyToSave) {
            document.getElementById("UrbanFutureIntroduceSave").style.backgroundColor = "#003d92";
            document.getElementById("UrbanFutureIntroduceSave").style.setProperty("color", "white", "important");
            document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
            document.getElementById("IntrouceIncompleteMessage").innerHTML = ""

        }
    }
    else {
        introduceReadyToSave = false;
        document.getElementById("UrbanFutureIntroduceSave").style.backgroundColor = "#616161";
        document.getElementById("UrbanFutureIntroduceSave").style.setProperty("color", "black", "important");
    }
}

document.getElementById('UFFormRelation').addEventListener('change', function () {
    let selectedValue = this.value;

    // console.log("Selected relation:", selectedValue);

    // Set session gender item:
    sessionStorage.setItem('userRelation', selectedValue);
    sessionUserRelation = sessionStorage.getItem('userRelation');

    checkIfIntroReady();




});


document.getElementById('UFFormAge').addEventListener('change', function () {
    let selectedValue = this.value;
    // console.log("Selected age:", selectedValue);

    // Set session gender item:
    sessionStorage.setItem('userAge', selectedValue);
    sessionUserAge = sessionStorage.getItem('userAge');

    checkIfIntroReady();



});

document.getElementById('UFFormEmail').addEventListener('change', function () {
    let selectedValue = this.value;
    sessionStorage.setItem('userEmail', selectedValue);
    sessionUserEmail = sessionStorage.getItem('userEmail');
})

function onSelectConfirm(el, handler) {
    const run = () => handler(el.value);

    el.addEventListener('change', run);              // value changed
    el.addEventListener('click', run);               // reselect same value (mouse/tap)
    el.addEventListener('keydown', (e) => {          // keyboard confirm
        if (e.key === 'Enter' || e.key === ' ') run();
    });
}

// --- Usage with your fields ---
const relationEl = document.getElementById('UFFormRelation');
const ageEl = document.getElementById('UFFormAge');
const emailEl = document.getElementById('UFFormEmail'); // input (keep change only)

onSelectConfirm(relationEl, (val) => {
    sessionStorage.setItem('userRelation', val);
    sessionUserRelation = val;
    checkIfIntroReady();
});

onSelectConfirm(ageEl, (val) => {
    sessionStorage.setItem('userAge', val);
    sessionUserAge = val;
    checkIfIntroReady();
});

// For inputs like email, reselect isn't a thing — keep change/input:
emailEl.addEventListener('change', function () {
    const val = this.value;
    sessionStorage.setItem('userEmail', val);
    sessionUserEmail = val;
});



function restartSession() {

    sessionStorage.removeItem('userID');
    sessionStorage.removeItem('userPTCoins');
    sessionStorage.removeItem('userRole');
    sessionStorage.removeItem('LocationComplete');
    sessionStorage.removeItem('SurveyComplete');
    sessionStorage.removeItem('IntroduceComplete');
    sessionStorage.removeItem('RoleComplete');
    sessionStorage.removeItem('userAge');
    sessionStorage.removeItem('userGender');
    sessionStorage.removeItem('userRelation');
    sessionStorage.removeItem('userRelationBusiness');
    sessionStorage.removeItem('userEmail');

    sessionUserAge = null;
    sessionUserGender = null;
    sessionUserRelation = null;
    sessionUserRelationBusiness = null;
    sessionUserEmail = null;
    sessionIntroduceComplete = null;
    sessionSurveyComplete = null;
    sessionLocationComplete = null;

    // document.getElementById("RoleCoinDiv").style.display="block";
    // document.getElementById("IntroductionCoinDiv").style.display = "block";
    // document.getElementById("SurveyCoinDiv").style.display = "block";
    // document.getElementById("LocationCoinDiv").style.display="block";



    code = Math.floor(10000000 + Math.random() * 90000000).toString();

    userID = projectCode + String(code);

    // Set item (if its not set already):
    if (!sessionStorage.getItem('userID')) {
        sessionStorage.setItem('userID', userID);
    }

    sessionUserID = sessionStorage.getItem('userID');

    sessionPTCoins = 0;
    // checkCoinsRole();
    sessionStorage.setItem('userPTCoins', sessionPTCoins);
    document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
    document.getElementById("yourCoinsInApp").innerHTML = sessionStorage.getItem('userPTCoins');

    sessionStorage.setItem('userRole', "partycypacyjny nowicjusz");
    sessionUserRole = sessionStorage.getItem('userRole');
    document.getElementById("yourRoleInApp").innerHTML = sessionUserRole;

    // sessionStorage.setItem('LocationComplete', "false");
    sessionLocationComplete = "false";

    // Clear Introduce form
    document.getElementById("UFFormAge").value = "";
    document.getElementById("UFFormGender").value = "";
    document.getElementById("UFFormRelation").value = "";
    document.getElementById("UFFormRelationSelf").value = "";
    document.getElementById("UFFormEmail").value = "";
    updateRelationField();

    // Clear Survey form
    document.getElementById("UFFormReason").selectedIndex = -1; // Deselect all in multiselect
    Array.from(document.getElementById("UFFormReason").options).forEach(opt => opt.selected = false);
    document.getElementById("UFFormAssociations").value = "";
    document.getElementById("UFFormCampus").value = "";
    document.getElementById("UFFormElements").value = "";

    // Reset sliders
    document.getElementById("UFSliderClose").value = 3;
    document.getElementById("UFSliderUni").value = 3;
    document.getElementById("UFSliderCity").value = 3;
    document.getElementById("UFSliderRole").value = 3;

    UrbanFutureIntroduceSave.setAttribute("active", "false");
    UrbanFutureIntroduceSave.style.backgroundColor = "#616161";
    UrbanFutureIntroduceSave.style.setProperty("color", "black", "important");
    document.getElementById("IntrouceIncompleteMessage").innerHTML = "";
    getUserIPAndCheck();
    checkSessionAndBoxes();

}
function resetIntroAndSurveyFields() {
    sessionStorage.removeItem('userAge');
    sessionStorage.removeItem('userGender');
    sessionStorage.removeItem('userRelation');
    sessionStorage.removeItem('userRelationBusiness');
    sessionStorage.removeItem('userEmail');

    sessionUserAge = null;
    sessionUserGender = null;
    sessionUserRelation = null;
    sessionUserRelationBusiness = null;
    sessionUserEmail = null;

    // --- Intro Fields ---
    document.getElementById("UFFormAge").value = "";
    document.getElementById("UFFormGender").value = "";
    document.getElementById("UFFormRelation").value = "";
    document.getElementById("UFFormRelationSelf").value = "";
    document.getElementById("UFFormEmail").value = "";
    updateRelationField();

    // --- Survey Fields ---
    const reasonOptions = document.getElementById("UFFormReason").options;
    for (let i = 0; i < reasonOptions.length; i++) {
        reasonOptions[i].selected = false;
    }

    document.getElementById("UFFormAssociations").value = "";
    document.getElementById("UFSliderClose").value = 3;
    document.getElementById("UFSliderUni").value = 3;
    document.getElementById("UFSliderCity").value = 3;
    document.getElementById("UFSliderRole").value = 3;
    document.getElementById("UFFormCampus").value = "";
    document.getElementById("UFFormElements").value = "";

    UrbanFutureIntroduceSave.setAttribute("active", "false");
    UrbanFutureIntroduceSave.style.backgroundColor = "#616161";
    UrbanFutureIntroduceSave.style.setProperty("color", "black", "important");
    document.getElementById("IntrouceIncompleteMessage").innerHTML = "";
}



function checkSessionAndBoxes() {


    if (sessionStorage.getItem('IntroduceComplete')) {
        setCheckboxState(introduceCheckbox, true)
        document.getElementById("IntroductionCoinDiv").style.display = "none";
        // introduceCheckbox.checked=true;

    } else {
        // introduceCheckbox.checked=false;
        setCheckboxState(introduceCheckbox, false)
    }


    if (sessionStorage.getItem('RoleComplete')) {
        // setCheckboxState(roleCheckbox,true)
        // document.getElementById("RoleCoinDiv").style.display="none";
        // roleCheckbox.checked=true;

    } else {
        // roleCheckbox.checked=false;
        // setCheckboxState(roleCheckbox,false)
    }

    if (sessionStorage.getItem('LocationComplete')) {
        // setCheckboxState(locationCheckbox,true)
        // document.getElementById("LocationCoinDiv").style.display="none";
        // locationCheckbox.checked=true;

    } else {
        // roleCheckbox.checked=false;
        // setCheckboxState(locationCheckbox,false)
    }

}

function setCheckboxState(checkbox, state) {
    checkbox.checked = state;
    onCheckboxStateChange(checkbox);
}

function onCheckboxStateChange(checkbox) {


    if (sessionStorage.getItem('IntroduceComplete')) {
        introduceCheckbox.checked = true;
    }
    if (sessionStorage.getItem('RoleComplete')) {
        // roleCheckbox.checked=true;

    }
    if (sessionStorage.getItem('LocationComplete')) {
        // locationCheckbox.checked=true;
    }
    // checkSessionAndBoxes();

    // console.log(checkbox);
    if (checkbox.checked) {
        checkbox.classList.add("checkedStyle")
    }
    else {
        while (checkbox.classList.contains("checkedStyle")) {
            checkbox.classList.remove("checkedStyle")
        }
    }
    // roleCheckbox.checked==true

    if (introduceCheckbox.checked == true) {

        ReadyToStart = true;

        if (ReadyToStart) {
            document.getElementById("StartIncompleteMessage").innerHTML = "";
            document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#003d92";
            document.getElementById("UrbanFutureStartExperienceButton").classList.add("override-color");
            document.getElementById("UrbanFutureIntroduceSave").setAttribute("active", "true");
            // document.getElementById("StartIncompleteMessage").innerHTML="";

        }
    }
    else {
        ReadyToStart = false;
        document.getElementById("UrbanFutureStartExperienceButtonSegment").style.backgroundColor = "#616161";
        document.getElementById("UrbanFutureStartExperienceButton").classList.remove("override-color");
        // document.getElementById("UrbanFutureStartExperienceButtonSegment").style.setProperty("color", "black", "important");
        console.log("not all elements are set")
    }

}

function urbanFutureAddProjectElements() {

    if (!map.getSource('UrbanFuture-region-boundary')) {
        map.addSource('UrbanFuture-region-boundary', {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [[

                        [6.5956437423312195, 53.22117514037427], [6.5917251283268286, 53.22000288822494], [6.591532975852232, 53.21996552117491], [6.590066043628042, 53.2198445749012], [6.589489644104788, 53.219648548198506], [6.589050625781397, 53.21952960169597], [6.588502875338037, 53.21937492225541], [6.587360086753961, 53.21903637871537], [6.5873605520261265, 53.21899927597664], [6.58701529560733, 53.21888818202754], [6.58697038247891, 53.21891102822366], [6.58691785041384, 53.21890053437497], [6.58692639224634, 53.21887714474167], [6.585538241322666, 53.21848674586366], [6.585810107173501, 53.21814256175122], [6.5867538339387295, 53.218430421978155], [6.587170474055682, 53.218578057443864], [6.58871071442519, 53.2190699199179], [6.588676000799296, 53.21910750762865], [6.589129746584575, 53.21927015237691], [6.589266731276581, 53.21913642986098], [6.590488665436112, 53.219541570117485], [6.590737450473995, 53.21928390571827], [6.591006338405521, 53.21900397817669], [6.591185958706518, 53.21882988998652], [6.591433791511832, 53.218805355337935], [6.59225782261484, 53.2184070012685], [6.592802390987714, 53.21856524814885], [6.592943434735275, 53.21857582712025], [6.593066954474466, 53.218592080460155], [6.59674429642277, 53.2196528939337], [6.597048739849356, 53.21973566468202], [6.59624312679901, 53.22068130865287], [6.596054711996999, 53.220898355471945], [6.5959429276821595, 53.2209541875018], [6.595784510572543, 53.22099367880455], [6.59569649107226, 53.22103844993262], [6.5956437423312195, 53.22117514037427]


                    ]]
                }
            }
        });
    }

    // Add a fill layer to show the region
    if (!map.getLayer('UrbanFuture-region-fill')) {
        map.addLayer({
            id: 'UrbanFuture-region-fill',
            type: 'fill',
            source: 'UrbanFuture-region-boundary',
            layout: {},
            paint: {
                'fill-color': '#f9d235',
                'fill-opacity': 0.1
            }
        });
    }

    // Optional: add a border line
    if (!map.getLayer('UrbanFuture-region-outline')) {
        map.addLayer({
            id: 'UrbanFuture-region-outline',
            type: 'line',
            source: 'UrbanFuture-region-boundary',
            layout: {},
            paint: {
                'line-color': '#f9d235',
                'line-width': 2
            }
        });
    }
    if (!map.getSource('UrbanFuture-walk-path')) {
        map.addSource('UrbanFuture-walk-path', {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [[
                        [6.5956437423312195, 53.22117514037427], [6.5917251283268286, 53.22000288822494], [6.591532975852232, 53.21996552117491], [6.590066043628042, 53.2198445749012], [6.589489644104788, 53.219648548198506], [6.589050625781397, 53.21952960169597], [6.588502875338037, 53.21937492225541], [6.587360086753961, 53.21903637871537], [6.5873605520261265, 53.21899927597664], [6.58701529560733, 53.21888818202754], [6.58697038247891, 53.21891102822366], [6.58691785041384, 53.21890053437497], [6.58692639224634, 53.21887714474167], [6.585538241322666, 53.21848674586366], [6.585810107173501, 53.21814256175122], [6.5867538339387295, 53.218430421978155], [6.587170474055682, 53.218578057443864], [6.58871071442519, 53.2190699199179], [6.588676000799296, 53.21910750762865], [6.589129746584575, 53.21927015237691], [6.589266731276581, 53.21913642986098], [6.590488665436112, 53.219541570117485], [6.590737450473995, 53.21928390571827], [6.591006338405521, 53.21900397817669], [6.591185958706518, 53.21882988998652], [6.591433791511832, 53.218805355337935], [6.59225782261484, 53.2184070012685], [6.592802390987714, 53.21856524814885], [6.592943434735275, 53.21857582712025], [6.593066954474466, 53.218592080460155], [6.59674429642277, 53.2196528939337], [6.597048739849356, 53.21973566468202], [6.59624312679901, 53.22068130865287], [6.596054711996999, 53.220898355471945], [6.5959429276821595, 53.2209541875018], [6.595784510572543, 53.22099367880455], [6.59569649107226, 53.22103844993262], [6.5956437423312195, 53.22117514037427]
                        // [6.590739609622574, 53.2198655360157],
                        // [6.590819396403333, 53.21972841988219],
                        // [6.591055625027678, 53.21938857575259],
                        // [6.591333062382915, 53.21908972183829],
                        // [6.592241042035283, 53.21935439665765],
                        // [6.59255116436691, 53.21913484534369],
                        // [6.5938202691685035, 53.219495681668405],
                        // [6.594595951889858, 53.219770263126776],
                        // [6.595874432126749, 53.22011637037261],
                        // [6.596050835395658, 53.22031924199996],
                        // [6.596180118863344, 53.22059885208998],
                        // [6.5961774232021355, 53.22069176822288],
                        // [6.595997548072319, 53.22088567647205],
                        // [6.595836735420477, 53.22094057442135],
                        // [6.595670990122869, 53.22101588904732],
                        // [6.595590897694223, 53.22113801995644],
                        // [6.5947487238426845, 53.2208770191267],
                        // [6.5938024831647795, 53.220595243928926],
                        // [6.592744827796167, 53.22027653606747],
                        // [6.591656921416671, 53.219952449208364],
                        // [6.590739609622574, 53.2198655360157]
                    ]]
                }
            }
        });
    }

    if (!map.getLayer('UrbanFuture-walk-path')) {
        map.addLayer({
            id: 'UrbanFuture-walk-path',
            type: 'line',
            source: 'UrbanFuture-walk-path',
            layout: {},
            paint: {
                'line-color': '#d0af2d',
                'line-width': 3,
                'line-dasharray': [2, 2]  // 2px dash, 4px gap
            }
        });
    }
    if (!map.getLayer('UrbanFuture-walk-fill')) {
        map.addLayer({
            id: 'UrbanFuture-walk-fill',
            type: 'fill',
            source: 'UrbanFuture-walk-path',
            layout: {},
            paint: {
                'fill-color': '#f9d235',
                'fill-opacity': 0.2
            }
        });
    }

    if (!map.getSource('eraser')) {

        // clip layer (eraser)
        map.addSource('eraser', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'Polygon',
                            coordinates: [[
                                [6.592818511842324, 53.219086728408854],
                                [6.592496858923454, 53.219048239654455],
                                [6.592594044874147, 53.21888118409052],
                                [6.592898329708561, 53.21888539973878],
                                [6.592818511842324, 53.219086728408854]
                            ]]
                        }
                    }
                ]
            }
        });


    }

    if (!map.getLayer('eraser')) {
        map.addLayer({
            id: 'eraser',
            type: 'clip',
            source: 'eraser',
            layout: { 'clip-layer-types': ['symbol', 'model'] }
        });
    }




    map.moveLayer('UrbanFuture-region-fill');
    map.moveLayer('UrbanFuture-region-outline');
    map.moveLayer('UrbanFuture-walk-path');
    if (map.getLayer('PTProjects'))
        map.moveLayer('PTProjects');

    // Add context parks (green areas visible only at far zoom out)
    addContextParksLayers();

    loadPinQuestionImages();

    // exploreUrbanFutureScreen()

}
function urbanFutureMoveLayersToFront() {
    map.moveLayer('UrbanFuture-region-fill');
    map.moveLayer('UrbanFuture-region-outline');
    map.moveLayer('UrbanFuture-walk-path');
    if (map.getLayer('PinQuestions'))
        map.moveLayer('PinQuestions');
    if (map.getLayer('PTProjects'))
        map.moveLayer('PTProjects');
}

// Add context elements as colored areas with labels (visible only at far zoom out)
// Parks are green, POIs are brown
function addContextParksLayers() {
    const maxZoomVisible = 14; // Elements only visible when zoomed out further than this

    // Helper to calculate polygon centroid for label placement
    function getPolygonCentroid(points) {
        let sumLng = 0, sumLat = 0;
        for (const [lng, lat] of points) {
            sumLng += lng;
            sumLat += lat;
        }
        return [sumLng / points.length, sumLat / points.length];
    }

    // Create GeoJSON features for all elements (include type for styling)
    const elementFeatures = contextElements.map(element => ({
        type: 'Feature',
        properties: {
            name: element.name,
            elementType: element.type.toLowerCase()
        },
        geometry: {
            type: 'Polygon',
            coordinates: [element.points]
        }
    }));

    // Create label points at centroids (include type for styling)
    const labelFeatures = contextElements.map(element => ({
        type: 'Feature',
        properties: {
            name: element.name,
            elementType: element.type.toLowerCase()
        },
        geometry: {
            type: 'Point',
            coordinates: getPolygonCentroid(element.points)
        }
    }));

    // Add elements source
    if (!map.getSource('context-parks')) {
        map.addSource('context-parks', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: elementFeatures
            }
        });
    }

    // Add labels source
    if (!map.getSource('context-parks-labels')) {
        map.addSource('context-parks-labels', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: labelFeatures
            }
        });
    }

    // Add element fill layer (green for parks, brown for POIs)
    if (!map.getLayer('context-parks-fill')) {
        map.addLayer({
            id: 'context-parks-fill',
            type: 'fill',
            source: 'context-parks',
            maxzoom: maxZoomVisible,
            paint: {
                'fill-color': [
                    'match',
                    ['get', 'elementType'],
                    'park', '#4CAF50',
                    'poi', '#8B4513',
                    '#4CAF50' // default to green
                ],
                'fill-opacity': 0.3
            }
        });
    }

    // Add element outline layer
    if (!map.getLayer('context-parks-outline')) {
        map.addLayer({
            id: 'context-parks-outline',
            type: 'line',
            source: 'context-parks',
            maxzoom: maxZoomVisible,
            paint: {
                'line-color': [
                    'match',
                    ['get', 'elementType'],
                    'park', '#2E7D32',
                    'poi', '#5D3A1A',
                    '#2E7D32' // default to dark green
                ],
                'line-width': 2
            }
        });
    }

    // Add element labels
    if (!map.getLayer('context-parks-labels')) {
        map.addLayer({
            id: 'context-parks-labels',
            type: 'symbol',
            source: 'context-parks-labels',
            maxzoom: maxZoomVisible,
            layout: {
                'text-field': ['get', 'name'],
                'text-font': ['DIN Pro Medium', 'Arial Unicode MS Regular'],
                'text-size': 14,
                'text-anchor': 'center',
                'text-allow-overlap': false
            },
            paint: {
                'text-color': [
                    'match',
                    ['get', 'elementType'],
                    'park', '#1B5E20',
                    'poi', '#5D3A1A',
                    '#1B5E20' // default to dark green
                ],
                'text-halo-color': '#ffffff',
                'text-halo-width': 2
            }
        });
    }
}

function startParticipationUrbanFuture() {

    try {
        if (sessionStorage.getItem('userRole')) {

            if (sessionStorage.getItem('userRole') == "GreenGuardian") {

                document.getElementById("yourRoleInApp").innerHTML = "Green Guardian";

            } else if (sessionStorage.getItem('userRole') == "AccessInspector") {

                document.getElementById("yourRoleInApp").innerHTML = "Access Inspector";

            } else if (sessionStorage.getItem('userRole') == "ActivityScout") {
                document.getElementById("yourRoleInApp").innerHTML = "Activity Scout";

            }

        }
    } catch {
    }
    try {
        document.getElementById("yourCoinsInApp").innerHTML = sessionStorage.getItem('userPTCoins')
    } catch {

    }

    document.getElementById("TopNavbarUrbanFuture").style.display = "block";
    document.getElementById("BottomMenuUrbanFuture").style.display = "block";
    showElement(document.getElementById("BottomLocateUser"));
    showElement(document.getElementById("BottomStyleSwitch"))
}


document.getElementById("UrbanFutureTopNavbarSelectOptions").addEventListener("click", function () {

    if (!UrbanFutureSelectOptionsMenuOpen) {
        document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display = "flex";
        document.getElementById("UrbanFutureTopNavbarOpenClose").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseMenu.png";

        // Closing the Participate Panel:

        // hideElement(document.getElementById("UrbanFutureMainMenu"));

        hideElement(document.getElementById("ParticipateMenuWrapper"));

        hideElement(document.getElementById("BotomActionsUrbanReaction"));
        hideElement(document.getElementById("BotomActionsUrbanComment"));
        hideElement(document.getElementById("BotomActionsUrbanPhoto"));
        hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
        hideElement(document.getElementById("UrbanFutureWalkshopThank"));



        hideElement(document.getElementById("UrbanFutureConfirmLocation"));
        hideElement(document.getElementById("UserLoginMenuUrbanFuture"));
        endPinPlacKrakowskifFunction();
        whiteFrame();



    } else {
        document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display = "none";
        hideElement(document.getElementById("UserLoginMenuUrbanFuture"))
        document.getElementById("UrbanFutureTopNavbarOpenClose").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/OpenMenu.png";
    }

    UrbanFutureSelectOptionsMenuOpen = !UrbanFutureSelectOptionsMenuOpen

})


document.getElementById("UrbanFutureMainMenuButton").addEventListener("click", function () {


    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();


    document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
    document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")

    while (document.getElementById("UrbanFutureMainMenu").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UrbanFutureMainMenu").classList.remove("UrbanFutureDisplayNone")
    }
    while (document.getElementById("UserMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
        document.getElementById("UserMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone")
    }

    // document.getElementById("UserMenuUrbanFuture").style.display="block";
    // document.getElementById("UserMenuUrbanFuture").style.visibility="visible";



});


document.getElementById("UrbanFutureReCenterButton").addEventListener("click", function () {


    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();



    let cameraMoveTo = cameraStartOverview;

    flyTowards(cameraMoveTo);


});


document.getElementById("UrbanFutureEndTourButton").addEventListener("click", function () {

    showElement(document.getElementById("UrbanFutureWalkshopConclusion"))
});


document.getElementById('UrbanFutureLearnMoreButton').addEventListener('click', function () {
    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();
    window.open('https://eoxsnlhinp7.typeform.com/to/r0rGuJYy', '_blank');
});

// QR Code Modal
document.getElementById('UrbanFutureShowQRButton').addEventListener('click', function () {
    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();
    document.getElementById("QRCodeModal").classList.remove("UrbanFutureDisplayNone");
});

document.getElementById('QRCodeModalClose').addEventListener('click', function () {
    document.getElementById("QRCodeModal").classList.add("UrbanFutureDisplayNone");
});

document.getElementById('QRCodeModal').addEventListener('click', function (e) {
    if (e.target === this) {
        this.classList.add("UrbanFutureDisplayNone");
    }
});


// === Elements To Database Submission: ===



document.getElementById('UrbanFutureParticipationReact').addEventListener('click', function () {

    if (locationTypeAction == "PinBased") {
        // iniciateSwitchReactionMenu();
        document.getElementById("ReactionSubmitButton").innerHTML = '<img class="UFInTextIcon" id="CameraSubmitButtonIcon" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/IconLocationPinWhite.svg"/> ustaw'
        lanuchReactionMenu();

    } else {
        document.getElementById("ReactionSubmitButton").innerHTML = '<img class="UFInTextIcon" id="CameraSubmitButtonIcon" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/SubmitIconWhite.svg"/> zapisz '
        lanuchReactionMenu();
        addInfomationPopup();
    }



});

document.getElementById("ReactionCloseButton").addEventListener('click', function () {
    hideElement(document.getElementById("BotomActionsUrbanReaction"));
    document.getElementById('UrbanFutureReactionComment').value = '';
    endPinPlacKrakowskifFunction();
    whiteFrame();
});

document.getElementById("ReactionSubmitButton").addEventListener('click', function () {
    if (locationTypeAction == "PinBased") {
        iniciateSwitchReactionMenu();

    } else {
        reactionSubmitToDatabase();
    }



});

function reactionSubmitToDatabase() {
    hideElement(document.getElementById("BotomActionsUrbanReaction"));
    hideElement(document.getElementById("UrbanFutureConfirmLocation"));

    // dataToSubmit - needs to contain: reaction_comment, rating, coordinates
    slectedReactionComment = "-";
    if (document.getElementById("UrbanFutureReactionComment").value) {
        slectedReactionComment = document.getElementById("UrbanFutureReactionComment").value;
    } else {
        slectedReactionComment = "-";
    }
    dataToSubmit.reaction_comment = slectedReactionComment;
    dataToSubmit.rating = parseInt(slectedReactionValue);


    if (locationTypeAction == "PinBased") {
        let coordinatesToSave = PlacKrakowskiDropPinMarker.getLngLat();
        let coordinatesValueTextToSave = `${coordinatesToSave.lng.toFixed(4)},${coordinatesToSave.lat.toFixed(4)}`;
        dataToSubmit.coordinates = coordinatesValueTextToSave;


    } else {
        let coordinatesToSave = userMarker.getLngLat();
        let coordinatesValueTextToSave = `${coordinatesToSave.lng.toFixed(4)},${coordinatesToSave.lat.toFixed(4)}`;
        dataToSubmit.coordinates = coordinatesValueTextToSave;
    }



    submitReaction(dataToSubmit);
}


document.getElementById('UrbanFutureParticipationComment').addEventListener('click', function () {

    if (locationTypeAction == "PinBased") {
        // iniciateSwitchCommentMenu();
        document.getElementById("CommentSubmitButton").innerHTML = '<img class="UFInTextIcon" id="CameraSubmitButtonIcon" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/IconLocationPinWhite.svg"/> ustaw'
        launchCommentMenu();
    } else {
        document.getElementById("CommentSubmitButton").innerHTML = '<img class="UFInTextIcon" id="CameraSubmitButtonIcon" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/SubmitIconWhite.svg"/> zapisz '
        launchCommentMenu();
        addInfomationPopup();
    }

});


document.getElementById("CommentCloseButton").addEventListener('click', function () {
    hideElement(document.getElementById("BotomActionsUrbanComment"));
    document.getElementById('UrbanFutureCommentComment').value = '';
    endPinPlacKrakowskifFunction();
    whiteFrame();
});

document.getElementById("CommentSubmitButton").addEventListener('click', function () {
    if (locationTypeAction == "PinBased") {
        iniciateSwitchCommentMenu();

    } else {
        commentSubmitToDatabase();
    }


});

function commentSubmitToDatabase() {
    hideElement(document.getElementById("BotomActionsUrbanComment"));
    hideElement(document.getElementById("UrbanFutureConfirmLocation"));

    // dataToSubmit - needs to contain: reaction_comment, rating, coordinates
    slectedReactionComment = "-";
    slectedReactionComment = document.getElementById("UrbanFutureCommentComment").value;

    dataToSubmit.reaction_comment = slectedReactionComment;

    slectedCommentQuestion = "-"
    slectedCommentQuestion = document.getElementById("UFCommentQuestion").value;
    dataToSubmit.selected_comment_question = slectedCommentQuestion;



    if (locationTypeAction == "PinBased") {
        let coordinatesToSave = PlacKrakowskiDropPinMarker.getLngLat();
        let coordinatesValueTextToSave = `${coordinatesToSave.lng.toFixed(4)},${coordinatesToSave.lat.toFixed(4)}`;
        dataToSubmit.coordinates = coordinatesValueTextToSave;


    } else {
        let coordinatesToSave = userMarker.getLngLat();
        let coordinatesValueTextToSave = `${coordinatesToSave.lng.toFixed(4)},${coordinatesToSave.lat.toFixed(4)}`;
        dataToSubmit.coordinates = coordinatesValueTextToSave;
    }

    submitComment(dataToSubmit);

}





document.getElementById("CameraCloseButton").addEventListener('click', function () {
    hideElement(document.getElementById("BotomActionsUrbanPhoto"));
    document.getElementById('UrbanFuturePhotoComment').value = '';
    endPinPlacKrakowskifFunction();
    whiteFrame();
});

document.getElementById("CameraSubmitButton").addEventListener('click', function () {



    if (capturedState) {
        // alert("into image submission");
        if (locationTypeAction == "PinBased") {
            iniciateSwitchPhotoMenu();

        } else {
            photoSubmitToDatabase();
        }

    }


});

function photoSubmitToDatabase() {
    // Convert canvas to Data URL (base64)
    const imageDataUrl = document.getElementById("canvas").toDataURL('image/jpeg');

    // Send to PHP
    fetch('https://publictwin.info/digital_maquette/php_scripts/PlacKrakowskiSaveCapturedFileToServer.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ imageData: imageDataUrl })
    })
        .then(res => res.json())
        .then(response => {
            if (response.success) {
                console.log("Image uploaded:", response.fileName);
                // alert("uploaded successfuly");

                slectedReactionComment = "-";
                slectedReactionComment = document.getElementById("UrbanFuturePhotoComment").value;

                dataToSubmit.reaction_comment = slectedReactionComment;
                dataToSubmit.httpadress = "https://publictwin.info/digital_maquette/content/Plac_Krakowski/Saved_User_Images/" + response.fileName;

                if (locationTypeAction == "PinBased") {
                    let coordinatesToSave = PlacKrakowskiDropPinMarker.getLngLat();
                    let coordinatesValueTextToSave = `${coordinatesToSave.lng.toFixed(4)},${coordinatesToSave.lat.toFixed(4)}`;
                    dataToSubmit.coordinates = coordinatesValueTextToSave;


                } else {
                    let coordinatesToSave = userMarker.getLngLat();
                    let coordinatesValueTextToSave = `${coordinatesToSave.lng.toFixed(4)},${coordinatesToSave.lat.toFixed(4)}`;
                    dataToSubmit.coordinates = coordinatesValueTextToSave;
                }



                submitPhoto(dataToSubmit);
                hideElement(document.getElementById("UrbanFutureConfirmLocation"));




            } else {
                console.error("Upload failed:", response.error);
                // alert("failed")
            }
        })
        .catch(err => console.error("Fetch error:", err));

}




document.getElementById('UrbanFutureParticipationPhoto').addEventListener('click', function () {
    if (cameraFunctionActive) {
        if (locationTypeAction == "PinBased") {
            // iniciateSwitchPhotoMenu();
            document.getElementById("CameraSubmitButton").innerHTML = '<img class="UFInTextIcon" id="CameraSubmitButtonIcon" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/IconLocationPinWhite.svg"/> ustaw'

            launchPhotoMenu();
        }
        else {
            document.getElementById("CameraSubmitButton").innerHTML = '<img class="UFInTextIcon" id="CameraSubmitButtonIcon" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/SubmitIconWhite.svg"/> zapisz '

            launchPhotoMenu()
            addInfomationPopup();
        }
    } else {
        showErrorMessage('funkcjonalość dotępna tylko w trybie lokalizacji <img class="UFIconCoin" src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/IconLocationArrow.svg"/> w pobliżu Placu Krakowskiego');
    }

});



// === Iniciate and Launch Reaction leaving funcitons: === //

function iniciateSwitchReactionMenu() {

    hideElement(document.getElementById("BotomActionsUrbanReaction"));
    // dropPinPlacKrakowskifFunction();
    showElement(document.getElementById("UrbanFutureConfirmLocation"));
    openMenu = "ReactionMenu";


}
function iniciateSwitchCommentMenu() {
    hideElement(document.getElementById("BotomActionsUrbanComment"));
    // dropPinPlacKrakowskifFunction();
    showElement(document.getElementById("UrbanFutureConfirmLocation"));
    openMenu = "CommentMenu";




}
function iniciateSwitchPhotoMenu() {

    if (document.getElementById('BotomActionsUrbanPhoto').getAttribute("menuIniciated") == "false") {
        openMenu = "PhotoMenu";
        showElement(document.getElementById("UrbanFutureConfirmLocation"));
        whiteFrame(document.getElementById("BotomActionsUrbanPhoto"));
        // document.getElementById("UrbanFutureParticipationPhoto").classList.add("whiteBorder");
        // dropPinPlacKrakowskifFunction()

        document.getElementById('BotomActionsUrbanPhoto').setAttribute("menuIniciated", "true");

        hideElement(document.getElementById("BotomActionsUrbanReaction"));
        hideElement(document.getElementById("BotomActionsUrbanComment"));

    } else {
        document.getElementById('BotomActionsUrbanPhoto').setAttribute("menuIniciated", "false");
        hideElement(document.getElementById("UrbanFutureConfirmLocation"));

        endPinPlacKrakowskifFunction();
        whiteFrame();
        hideElement(document.getElementById("BotomActionsUrbanPhoto"));
        stopCamera();

    }

}

const adminPanel = document.getElementById("admin-panel");

function lanuchReactionMenu() {
    if (document.getElementById('BotomActionsUrbanReaction').getAttribute("menuOpened") == "false") {

        // alert(locationTypeAction);
        openMenu = "ReactionMenu";

        showElement(document.getElementById("BotomActionsUrbanReaction"));
        hideElement(document.getElementById("BotomActionsUrbanComment"));
        hideElement(document.getElementById("BotomActionsUrbanPhoto"));
        hideElement(document.getElementById("UrbanFutureConfirmLocation"));
        hideElement(adminPanel);




        if (locationTypeAction == "PinBased") {
            dropPinPlacKrakowskifFunction();
            centerUpdatePin();
        } else {
            centerUpdateLocation();
        }


    } else {

        hideElement(document.getElementById("BotomActionsUrbanReaction"));
        endPinPlacKrakowskifFunction();
        map.setLayoutProperty('PinQuestions', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');

    }

}

function launchCommentMenu() {
    if (document.getElementById('BotomActionsUrbanComment').getAttribute("menuOpened") == "false") {

        // alert(locationTypeAction);
        openMenu = "CommentMenu";

        showElement(document.getElementById("BotomActionsUrbanComment"));
        hideElement(document.getElementById("BotomActionsUrbanReaction"));
        hideElement(document.getElementById("BotomActionsUrbanPhoto"));
        hideElement(document.getElementById("UrbanFutureConfirmLocation"));
        hideElement(adminPanel);

        if (locationTypeAction == "PinBased") {
            dropPinPlacKrakowskifFunction();
            centerUpdatePin();
        } else {
            centerUpdateLocation();
        }

    } else {

        hideElement(document.getElementById("BotomActionsUrbanComment"));
        endPinPlacKrakowskifFunction();
        map.setLayoutProperty('PinQuestions', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');

    }

}

function launchPhotoMenu() {

    if (document.getElementById('BotomActionsUrbanPhoto').getAttribute("menuOpened") == "false") {

        // alert(locationTypeAction);
        openMenu = "PhotoMenu";

        showElement(document.getElementById("BotomActionsUrbanPhoto"));
        hideElement(document.getElementById("BotomActionsUrbanReaction"));
        hideElement(document.getElementById("BotomActionsUrbanComment"));
        hideElement(document.getElementById("UrbanFutureConfirmLocation"));
        hideElement(adminPanel);

        if (locationTypeAction == "PinBased") {
            dropPinPlacKrakowskifFunction();
            centerUpdatePin();
        } else {
            centerUpdateLocation();
        }

        // Start camera on page load
        startCamera();

    } else {

        hideElement(document.getElementById("BotomActionsUrbanPhoto"));
        endPinPlacKrakowskifFunction();
        map.setLayoutProperty('PinQuestions', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');
        stopCamera();

    }

}





document.getElementById("UrbanFutureParticipationConfirmPin").addEventListener('click', function () {

    if (openMenu == "ReactionMenu") {
        reactionSubmitToDatabase();
        // lanuchReactionMenu();
    } else if (openMenu == "CommentMenu") {
        commentSubmitToDatabase();
        // launchCommentMenu();
    } else {
        photoSubmitToDatabase();
        // launchPhotoMenu();
    }
});

document.getElementById("TourCloseButton").addEventListener('click', function () {
    hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
});


document.getElementById("TourSubmitButton").addEventListener('click', function () {
    hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
    submitScore();

    const table = databaseUsersName;
    const uid = sessionStorage.getItem('userID') || '-';

    const ensureIp = () =>
        (window.userIP && window.userIP !== '')
            ? Promise.resolve({ ip: window.userIP })
            : fetch('https://publictwin.info/EngagementAppPrototypes/MainPHP/getUserIP.php').then(r => r.json());

    ensureIp().then(({ ip }) => {
        // End session
        const endSession = fetch("https://publictwin.info/EngagementAppPrototypes/MainPHP/User_EndSession.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ip, uid, table })
        }).then(r => r.json());

        return Promise.all([endSession]);
    })
        .then(([endRes]) => {
            console.log("End session:", endRes);
            resetIntroAndSurveyFields(); // clear frontend fields
        })
        .catch(err => console.error("Finalize session failed:", err));

    document.getElementById("UrbanFutureMainMenuButton").click();
    restartSession();
});


document.getElementById("TypeformButton").addEventListener('click', function () {
    window.open("https://eoxsnlhinp7.typeform.com/to/DZUDal7b", "_blank"); // "_blank" opens in a new tab
});





const reactionIcons = document.querySelectorAll('.UrbanFutureReactionIcon');

reactionIcons.forEach(icon => {
    icon.addEventListener('click', () => {
        // Remove 'whiteBorder' from all icons
        reactionIcons.forEach(el => el.classList.remove('whiteBorder'));

        // Add 'whiteBorder' to the clicked one
        icon.classList.add('whiteBorder');

        console.log(document.getElementById("BotomActionsUrbanReaction").getAttribute("apeneded"))

        if (document.getElementById("BotomActionsUrbanReaction").getAttribute("apeneded") == "false") {

            while (document.getElementById("CommentWrapper").classList.contains("UrbanFutureDisplayNone")) {
                document.getElementById("CommentWrapper").classList.remove("UrbanFutureDisplayNone");
            }
            document.getElementById("BotomActionsUrbanReaction").setAttribute("apeneded", "true");

        }

        slectedReactionValue = icon.getAttribute("score");

    });



});

// Show Element Logic Needs to be simplified:

function showElement(element) {
    while (element.classList.contains("UrbanFutureDisplayNone")) {

        element.classList.remove("UrbanFutureDisplayNone")
    }
    element.setAttribute("menuOpened", "true");

    if (element.id == "BotomActionsUrbanReaction") {
        document.getElementById("CommentWrapper").classList.add("UrbanFutureDisplayNone");
        document.getElementById("BotomActionsUrbanReaction").setAttribute("apeneded", "false");



        document.getElementById("UrbanFutureParticipationReact").classList.add("whiteBorder");

        while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
        }
        hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
        hideElement(document.getElementById("UrbanFutureWalkshopThank"));
        map.setLayoutProperty('PinQuestions', 'visibility', 'none');



    }
    if (element.id == "BotomActionsUrbanComment") {

        document.getElementById("UrbanFutureParticipationComment").classList.add("whiteBorder");

        while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
        }
        hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
        hideElement(document.getElementById("UrbanFutureWalkshopThank"));
        map.setLayoutProperty('PinQuestions', 'visibility', 'none');


    }
    if (element.id == "BotomActionsUrbanPhoto") {

        document.getElementById("UrbanFutureParticipationPhoto").classList.add("whiteBorder");

        while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
        }
        hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
        hideElement(document.getElementById("UrbanFutureWalkshopThank"));
        map.setLayoutProperty('PinQuestions', 'visibility', 'none');



    }
    if (element.id == "UrbanFutureConfirmLocation") {
        map.setLayoutProperty('PinQuestions', 'visibility', 'none');
    }
    if (element.id == "UserLoginMenuUrbanFuture") {
        // hideElement(document.getElementById("TopNavbarUrbanFutureSelectOptions"))

    } else {
    }


    // if(UrbanFutureSelectOptionsMenuOpen){

    //     document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display="none";
    //     document.getElementById("UrbanFutureTopNavbarOpenClose").src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/OpenMenu.png";

    //     UrbanFutureSelectOptionsMenuOpen=!UrbanFutureSelectOptionsMenuOpen;
    // }

}

function whiteFrame(element = "none") {
    if (element == "none") {

        document.getElementById('BotomActionsUrbanReaction').setAttribute("menuIniciated", "false");
        document.getElementById('BotomActionsUrbanComment').setAttribute("menuIniciated", "false");
        document.getElementById('BotomActionsUrbanPhoto').setAttribute("menuIniciated", "false");


        while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
        }
        while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
        }
        map.setLayoutProperty('PinQuestions', 'visibility', 'visible');
        // map.setLayoutProperty('PinQuestions', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');


    } else {

        if (element.id == "BotomActionsUrbanReaction") {
            document.getElementById("CommentWrapper").classList.add("UrbanFutureDisplayNone");
            document.getElementById("BotomActionsUrbanReaction").setAttribute("apeneded", "false");


            document.getElementById('BotomActionsUrbanPhoto').setAttribute("menuIniciated", "false");
            document.getElementById('BotomActionsUrbanComment').setAttribute("menuIniciated", "false");

            document.getElementById("UrbanFutureParticipationReact").classList.add("whiteBorder");

            while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
            }
            while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
            }
            hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
            hideElement(document.getElementById("UrbanFutureWalkshopThank"));



        }
        if (element.id == "BotomActionsUrbanComment") {
            document.getElementById('BotomActionsUrbanPhoto').setAttribute("menuIniciated", "false");
            document.getElementById('BotomActionsUrbanReaction').setAttribute("menuIniciated", "false");

            document.getElementById("UrbanFutureParticipationComment").classList.add("whiteBorder");

            while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
            }
            while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
            }
            hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
            hideElement(document.getElementById("UrbanFutureWalkshopThank"));


        }
        if (element.id == "BotomActionsUrbanPhoto") {
            document.getElementById('BotomActionsUrbanReaction').setAttribute("menuIniciated", "false");
            document.getElementById('BotomActionsUrbanComment').setAttribute("menuIniciated", "false");

            document.getElementById("UrbanFutureParticipationPhoto").classList.add("whiteBorder");



            while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
            }
            while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
                document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
            }
            hideElement(document.getElementById("UrbanFutureWalkshopConclusion"));
            hideElement(document.getElementById("UrbanFutureWalkshopThank"));



        }
    }
}

function hideElement(element) {
    element.classList.add("UrbanFutureDisplayNone");
    element.setAttribute("menuOpened", "false");

    if (element.id == "BotomActionsUrbanReaction") {

        while (document.getElementById("UrbanFutureParticipationReact").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationReact").classList.remove("whiteBorder")
        }

    }
    if (element.id == "BotomActionsUrbanComment") {

        while (document.getElementById("UrbanFutureParticipationComment").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationComment").classList.remove("whiteBorder")
        }


    }
    if (element.id == "BotomActionsUrbanPhoto") {

        while (document.getElementById("UrbanFutureParticipationPhoto").classList.contains("whiteBorder")) {
            document.getElementById("UrbanFutureParticipationPhoto").classList.remove("whiteBorder")
        }
        let capturedState = false;
        document.getElementById("CameraSubmitButton").style.backgroundColor = "#d0af2d";
        stopCamera();


    }
}







const video = document.getElementById('video');
const canvas = document.getElementById('canvas');
const captureBtn = document.getElementById('captureBtn');
const retakeBtn = document.getElementById('retakeBtn');

let stream = null;



async function startCamera() {
    try {
        stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: 'environment' },
            audio: false
        });

        video.srcObject = stream;
        video.play();

        video.style.display = 'block';
        canvas.style.display = 'none';
        retakeBtn.style.display = 'none';
        captureBtn.style.display = 'flex';
    } catch (error) {
        console.log('Error accessing camera:', error);
    }
}

function stopCamera() {
    if (stream) {
        stream.getTracks().forEach(track => {
            track.stop(); // Fully stop the camera hardware
        });
        stream = null;
    }

    if (video) {
        video.pause();
        video.srcObject = null;
        video.style.display = 'none';
    }

    // Reset visual state
    canvas.style.display = 'none';
    captureBtn.style.display = 'flex';
    retakeBtn.style.display = 'none';

    capturedState = false;
    document.getElementById("CameraSubmitButton").style.backgroundColor = "#d0af2d";
}


function captureImage() {
    const context = canvas.getContext('2d');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Stop the video stream (freeze)
    video.pause();
    video.style.display = 'none';
    canvas.style.display = 'block';
    captureBtn.style.display = 'none';
    retakeBtn.style.display = 'flex';

    capturedState = true;
    document.getElementById("CameraSubmitButton").style.backgroundColor = "#003d92"
}

function retakeImage() {
    video.play();
    video.style.display = 'block';
    canvas.style.display = 'none';
    captureBtn.style.display = 'flex';
    retakeBtn.style.display = 'none';

    capturedState = false;
    document.getElementById("CameraSubmitButton").style.backgroundColor = "#d0af2d"
}




captureBtn.addEventListener('click', captureImage);
retakeBtn.addEventListener('click', retakeImage);



let userMarker = new mapboxgl.Marker({ color: 'blue' });
userMarker.getElement().style.opacity = '0';
userMarker.getElement().style.display = 'none';




// === Location Functionalities: === 


function updateLocation(position) {
    try {
        const lng = position.coords.longitude;
        const lat = position.coords.latitude;

        userMarker.setLngLat([lng, lat]).addTo(map);
        userMarker.getElement().style.opacity = '0';
        userMarker.getElement().style.display = 'none';
    } catch {

    }

    // map.setCenter([lng, lat]);
}

function centerUpdateLocation() {
    try {
        // userMarker.setLngLat([lng, lat]).addTo(map);
        const coords = userMarker.getLngLat();
        // console.log(coords.lng, coords.lat);
        map.easeTo({
            center: [coords.lng, coords.lat],
            bearing: 0, // Reset rotation to north
            pitch: 0,   // Reset any tilt
            duration: 1000 // smooth animation (optional)
        });

    }
    catch {

    }

}
function UpdateLocationToUser() {
    try {
        // userMarker.setLngLat([lng, lat]).addTo(map);
        const coords = userMarker.getLngLat();
        // console.log(coords.lng, coords.lat);
        map.easeTo({
            center: [coords.lng, coords.lat],
            bearing: 0, // Reset rotation to north
            pitch: 45,   // Reset any tilt
            zoom: 16.5,
            duration: 1000 // smooth animation (optional)
        });

    }
    catch {

    }

}



function handleError(error) {
    console.error("Geolocation error:", error.message);
    // alert("Unable to get your location. Please enable location access.");
}


function startLocating() {
    if (navigator.geolocation) {


        navigator.geolocation.watchPosition(updateLocation, handleError, {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 3000 //10000
        });

        // Initialize the geolocate control.
        const geolocate = new mapboxgl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true
            },
            trackUserLocation: true,
            showUserHeading: true
        });
        // Add the control to the map.
        map.addControl(geolocate);
        locatingEnabled = true;

        setTimeout(() => {
            geolocate.trigger();
            // UpdateLocationToUser();
        }, 300);


        // Optionally hide the default control container
        const ctrl = document.querySelector('.mapboxgl-ctrl-top-right');
        if (ctrl) ctrl.style.display = 'none';



    } else {
        // alert("Geolocation is not supported by this browser.");
    }
}


document.getElementById("BottomLocateUser").addEventListener("click", function () {
    if (locationTypeAction == "PinBased") {
        locateUserPositionBasedClick();

    } else {
        locatePinPositionBasedClick();
    }






})


const GEOLOCATION_REFRESH_INTERVAL = 30000; // 30 seconds

setInterval(() => {
    if (locationTypeAction !== "UserPositionBased") return;

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const coords = [position.coords.longitude, position.coords.latitude];
            console.log("Refreshed user location:", coords);

            lastKnownUserCoords = coords;

            if (userMarker) {
                userMarker.setLngLat(coords);
            } else {
                userMarker = new mapboxgl.Marker().setLngLat(coords).addTo(map);
            }

            // Optional: Center camera if user moved a lot (e.g. >50m)
            // waitForUserMarkerThenUpdateCamera();
        },
        (error) => {
            console.warn("Geolocation refresh failed:", error);
        },
        {
            enableHighAccuracy: false,
            timeout: 10000,
            maximumAge: 0
        }
    );
}, GEOLOCATION_REFRESH_INTERVAL);



//  === Location Switch: ===

function locateUserPositionBasedClick() {
    locationTypeActionNew = "UserPositionBased";

    UrbanFutureLocationButton.style.backgroundColor = "#F9D235";
    UrbanFutureLocationPinButton.style.backgroundColor = "#FCEFC7";
    document.getElementById("StartIncompleteMessage").innerHTML = "remote participation";

    let fallbackTriggered = false;

    // ⏱ Start timeout for fallback (1 second)
    const fallbackTimeout = setTimeout(() => {
        fallbackTriggered = true;
        if (lastKnownUserCoords) {
            console.warn("Geolocation took too long, using last known user coords.");
            applyUserLocation(lastKnownUserCoords);
        } else {
            console.warn("No known user location to fall back to.");
            locatePinPositionBasedClick();
        }
    }, 1000);

    navigator.geolocation.getCurrentPosition(
        (position) => {
            if (fallbackTriggered) return; // already fell back

            clearTimeout(fallbackTimeout);

            const coords = [position.coords.longitude, position.coords.latitude];
            lastKnownUserCoords = coords;

            const isSwitching = (locationTypeAction !== locationTypeActionNew);
            locationTypeAction = "UserPositionBased";

            if (isSwitching) {
                toggleSelectionButtons("User");
                startOrUpdateLocating();
                // updateCameraStatusIfWithinDistance();
                waitForUserMarkerThenUpdateCamera();
                clearLocationActionUI();
            } else {
                startOrUpdateLocating();
                // updateCameraStatusIfWithinDistance();
                waitForUserMarkerThenUpdateCamera();
            }
        },
        () => {
            if (fallbackTriggered) return;
            clearTimeout(fallbackTimeout);

            toggleSelectionButtons("User");
            locationTypeAction = "UserPositionBased";
            clearLocationActionUI();
            showErrorMessage("enable location services");

            setTimeout(() => {
                locatePinPositionBasedClick();
            }, 1000);
        },
        {
            enableHighAccuracy: false,
            timeout: 10000,
            maximumAge: 0
        }
    );
}

function locatePinPositionBasedClick() {
    locationTypeActionNew = "PinBased";

    UrbanFutureLocationPinButton.style.backgroundColor = "#F9D235";
    UrbanFutureLocationButton.style.backgroundColor = "#FCEFC7";
    document.getElementById("StartIncompleteMessage").innerHTML = "remote participation";

    const isSwitching = (locationTypeAction !== locationTypeActionNew);
    locationTypeAction = "PinBased";

    if (isSwitching) {
        toggleSelectionButtons("Pin");
        disableCameraFunction();
        ProjectReCenter();
        clearLocationActionUI();
    } else {
        disableCameraFunction();
        ProjectReCenter();
    }
}

// === Utility Functions: ===

function waitForUserMarkerThenUpdateCamera(retries = 8) {
    try {
        if (
            userMarker &&
            typeof userMarker.getLngLat === "function" &&
            userMarker.getLngLat() &&
            typeof userMarker.getLngLat().lng === "number"
        ) {
            updateCameraStatusIfWithinDistance();
        } else if (retries > 0) {
            setTimeout(() => waitForUserMarkerThenUpdateCamera(retries - 1), 300);
        } else {
            console.warn("userMarker never became valid for camera check.");
        }
    } catch (e) {
        console.warn("Error in waitForUserMarkerThenUpdateCamera():", e);
    }
}

function applyUserLocation(coords) {
    if (!coords) return;

    // Set userMarker if needed or fly camera there
    if (userMarker) {
        userMarker.setLngLat(coords);
    } else {
        // Create marker if not available
        userMarker = new mapboxgl.Marker().setLngLat(coords).addTo(map);
    }

    map.flyTo({ center: coords, zoom: 16 });

    toggleSelectionButtons("User");
    startOrUpdateLocating();
    // updateCameraStatusIfWithinDistance();
    waitForUserMarkerThenUpdateCamera();
    clearLocationActionUI();
    locationTypeAction = "UserPositionBased";
}

function toggleSelectionButtons(type) {
    const userBtn = document.getElementById("UrbanFutureLocateUser");
    const pinBtn = document.getElementById("UrbanFutureLocatePin");

    if (type === "User") {
        userBtn.classList.add("SelectdToggleButton");
        pinBtn.classList.remove("SelectdToggleButton");
    } else {
        pinBtn.classList.add("SelectdToggleButton");
        userBtn.classList.remove("SelectdToggleButton");
    }
}

function startOrUpdateLocating() {
    if (locatingEnabled) {
        UpdateLocationToUser();
    } else {
        startLocating();
    }
}

function updateCameraStatusIfWithinDistance() {
    try {
        if (!userMarker || typeof userMarker.getLngLat !== "function") {
            console.warn("userMarker is not ready or invalid.");
            return;
        }

        const lngLat = userMarker.getLngLat();

        if (!lngLat || typeof lngLat.lng !== "number" || typeof lngLat.lat !== "number") {
            console.warn("userMarker.getLngLat() returned invalid value:", lngLat);
            return;
        }

        const userCoords = [lngLat.lng, lngLat.lat];
        const targetCoords = [18.6732, 50.2916];
        const distance = getDistanceInKm(userCoords, targetCoords);

        console.log("Distance to target:", distance);

        if (distance <= 2.79) {
            document.getElementById("UFParticipationIcon").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CameraIcon.png";
            document.getElementById("UrbanFutureParticipationPhotoCoinIcon").style.display = "block";
            cameraFunctionActive = true;
        }
    } catch (e) {
        console.warn("Error in updateCameraStatusIfWithinDistance():", e);
    }
}

function disableCameraFunction() {
    document.getElementById("UFParticipationIcon").src = "https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CameraIconGrey.png";
    document.getElementById("UrbanFutureParticipationPhotoCoinIcon").style.display = "none";
    cameraFunctionActive = false;
}

function clearLocationActionUI() {
    whiteFrame();
    hideElement(document.getElementById("BotomActionsUrbanReaction"));
    hideElement(document.getElementById("BotomActionsUrbanComment"));
    hideElement(document.getElementById("BotomActionsUrbanPhoto"));
    hideElement(document.getElementById("UrbanFutureConfirmLocation"));
    endPinPlacKrakowskifFunction();
}

function getDistanceInKm(coord1, coord2) {
    const R = 6371;
    const toRad = deg => deg * (Math.PI / 180);

    const [lon1, lat1] = coord1;
    const [lon2, lat2] = coord2;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a = Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function ProjectReCenter() {
    const cameraMoveTo = {
        zoom: 16,
        pitch: 45,
        bearing: 0,
        center: [18.6656, 50.2941] // for Gliwice
    };

    flyTowards(cameraMoveTo);
}

function centerUpdatePin() {
    const coordinates = PlacKrakowskiDropPinMarker.getLngLat();
    const screenPoint = map.project(coordinates);

    screenPoint.y += 30; // offset down by 30px

    const offsetCenter = map.unproject(screenPoint);

    const cameraMoveTo = {
        zoom: 16.5,
        pitch: 0,
        bearing: 0,
        center: [offsetCenter.lng, offsetCenter.lat]
    };

    flyTowards(cameraMoveTo);
}




// === Submitting elements to the database: ===

function submitReaction(dataToSubmit) {

    // dataToSubmit - needs to contain: reaction_comment, rating, coordinates

    let saveUserID = sessionStorage.getItem('userID');
    let saveAgeGroup = sessionStorage.getItem('userAge');
    let saveRelationToPlace = sessionStorage.getItem('userRelation');

    let saveLoginUserID = sessionStorage.getItem("loginUserID");

    let saveRelationBusiness;
    if (sessionStorage.getItem('userRelationBusiness')) {
        saveRelationBusiness = sessionStorage.getItem('userRelationBusiness');
    } else {
        saveRelationBusiness = "-"
    }


    let saveGender = sessionStorage.getItem('userGender');
    let saveEmail;
    if (sessionStorage.getItem('userEmail')) {
        saveEmail = sessionStorage.getItem('userEmail');
    } else {
        saveEmail = "-"
    }
    let saveUserRole = sessionStorage.getItem('userRole');


    let formData = {

        reaction_comment: dataToSubmit.reaction_comment,
        rating: dataToSubmit.rating,
        coordinates: dataToSubmit.coordinates,
        user_identifier: saveUserID,
        age_group: saveAgeGroup,
        relation_to_place: saveRelationToPlace,
        relation_business: saveRelationBusiness,
        gender: saveGender,
        email: saveEmail,
        users_role: saveUserRole,
        location_type_action: locationTypeAction,
        loginUserID: saveLoginUserID

    };

    fetch('https://publictwin.info/digital_maquette/php_scripts/PlacKrakowskiSubmitReaction.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                sessionPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
                sessionPTCoins += 10;
                checkCoinsRole();
                sessionStorage.setItem('userPTCoins', sessionPTCoins);
                document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
                document.getElementById("yourCoinsInApp").innerHTML = sessionStorage.getItem('userPTCoins');

                explorePlacKrakowskiReactions();
                explorePlacKrakowskiComments();
                explorePlacKrakowskiPhotos();

                document.getElementById('UrbanFutureReactionComment').value = '';
                endPinPlacKrakowskifFunction();
                whiteFrame();
                showSuccessMessage("twoja reakcja została zapisana");
                // alert("Reaction submitted successfully!");
            } else {
                // alert("Error: " + data.error);
            }
        })
        .catch(error => {
            console.error("Fetch error:", error);
        });
}

function submitComment(dataToSubmit) {
    // dataToSubmit - needs to contain: reaction_comment, rating, coordinates

    let saveUserID = sessionStorage.getItem('userID');
    let saveAgeGroup = sessionStorage.getItem('userAge');
    let saveRelationToPlace = sessionStorage.getItem('userRelation');

    let saveLoginUserID = sessionStorage.getItem("loginUserID");

    let saveRelationBusiness;
    if (sessionStorage.getItem('userRelationBusiness')) {
        saveRelationBusiness = sessionStorage.getItem('userRelationBusiness');
    } else {
        saveRelationBusiness = "-"
    }
    let saveGender = sessionStorage.getItem('userGender');

    let saveEmail;
    if (sessionStorage.getItem('userEmail')) {
        saveEmail = sessionStorage.getItem('userEmail');
    } else {
        saveEmail = "-"
    }
    let saveUserRole = sessionStorage.getItem('userRole');


    let formData = {
        selected_comment_question: dataToSubmit.selected_comment_question,
        reaction_comment: dataToSubmit.reaction_comment,
        coordinates: dataToSubmit.coordinates,
        user_identifier: saveUserID,
        relation_business: saveRelationBusiness,
        age_group: saveAgeGroup,
        relation_to_place: saveRelationToPlace,

        gender: saveGender,
        email: saveEmail,
        users_role: saveUserRole,
        location_type_action: locationTypeAction,
        loginUserID: saveLoginUserID

    };

    fetch('https://publictwin.info/digital_maquette/php_scripts/PlacKrakowskiSubmitComment.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                sessionPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
                sessionPTCoins += 20;
                checkCoinsRole();
                sessionStorage.setItem('userPTCoins', sessionPTCoins);
                document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
                document.getElementById("yourCoinsInApp").innerHTML = sessionStorage.getItem('userPTCoins');

                explorePlacKrakowskiReactions();
                explorePlacKrakowskiComments();
                explorePlacKrakowskiPhotos();

                document.getElementById('UrbanFutureCommentComment').value = '';
                endPinPlacKrakowskifFunction();
                whiteFrame();
                showSuccessMessage("twój komentarz został zapisany");
                // alert("Comment submitted successfully!");
            } else {
                // alert("Error: " + data.error);
            }
        })
        .catch(error => {
            console.error("Fetch error:", error);
        });
}

function submitPhoto(dataToSubmit) {
    // dataToSubmit - needs to contain: reaction_comment, rating, coordinates

    let saveUserID = sessionStorage.getItem('userID');
    let saveAgeGroup = sessionStorage.getItem('userAge');
    let saveRelationToPlace = sessionStorage.getItem('userRelation');

    let saveLoginUserID = sessionStorage.getItem("loginUserID");

    let saveRelationBusiness;
    if (sessionStorage.getItem('userRelationBusiness')) {
        saveRelationBusiness = sessionStorage.getItem('userRelationBusiness');
    } else {
        saveRelationBusiness = "-"
    }
    let saveGender = sessionStorage.getItem('userGender');

    let saveEmail;
    if (sessionStorage.getItem('userEmail')) {
        saveEmail = sessionStorage.getItem('userEmail');
    } else {
        saveEmail = "-"
    }
    let saveUserRole = sessionStorage.getItem('userRole');


    let formData = {

        reaction_comment: dataToSubmit.reaction_comment,
        httpadress: dataToSubmit.httpadress,
        coordinates: dataToSubmit.coordinates,
        user_identifier: saveUserID,
        age_group: saveAgeGroup,
        relation_to_place: saveRelationToPlace,
        relation_business: saveRelationBusiness,
        gender: saveGender,
        email: saveEmail,
        users_role: saveUserRole,
        location_type_action: locationTypeAction,
        loginUserID: saveLoginUserID

    };

    fetch('https://publictwin.info/digital_maquette/php_scripts/PlacKrakowskiSubmitPhoto.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                // alert("Photo submitted successfully!");
                sessionPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
                sessionPTCoins += 30;
                checkCoinsRole();
                sessionStorage.setItem('userPTCoins', sessionPTCoins);
                document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
                document.getElementById("yourCoinsInApp").innerHTML = sessionStorage.getItem('userPTCoins');

                explorePlacKrakowskiReactions();
                explorePlacKrakowskiComments();
                explorePlacKrakowskiPhotos();

                document.getElementById('UrbanFuturePhotoComment').value = '';
                endPinPlacKrakowskifFunction();
                whiteFrame();
                hideElement(document.getElementById("BotomActionsUrbanPhoto"));
                showSuccessMessage("twoje zdjęcie zostało zapisane");


            } else {
                // alert("Error: " + data.error);
            }
        })
        .catch(error => {
            console.error("Fetch error:", error);
        });
}

function submitSurveyResponse() {

    // Text values (VARCHAR(1024))
    let SavePytanie_1_Cel = "-";
    let SavePytanie_2_Skojarzenia = "-";
    let SavePytanie_5_Campus = "-";
    let SavePytanie_6_Elementy = "-";

    // Integer values (INT)
    let SavePytanie_3a_ZnaczenieDlaDielnicy = 0;
    let SavePytanie_3b_ZnaczenieDlaUczelni = 0;
    let SavePytanie_3c_ZnaczenieDlaMiasta = 0;
    let SavePytanie_4_Powiazanie = 0;

    // Save multi-select values (as comma-separated string)
    const reasonSelect = document.getElementById("UFFormReason");
    if (reasonSelect && reasonSelect.selectedOptions.length > 0) {
        const selected = Array.from(reasonSelect.selectedOptions).map(opt => opt.value).filter(Boolean);
        if (selected.length > 0) SavePytanie_1_Cel = selected.join(", ");
    }

    // Save text input (associations)
    const assocInput = document.getElementById("UFFormAssociations");
    if (assocInput && assocInput.value.trim()) {
        SavePytanie_2_Skojarzenia = assocInput.value.trim();
    }

    // Save range sliders (as integers)
    const rangeClose = document.getElementById("UFSliderClose");
    if (rangeClose && !isNaN(parseInt(rangeClose.value))) {
        SavePytanie_3a_ZnaczenieDlaDielnicy = parseInt(rangeClose.value);
    }

    const rangeUni = document.getElementById("UFSliderUni");
    if (rangeUni && !isNaN(parseInt(rangeUni.value))) {
        SavePytanie_3b_ZnaczenieDlaUczelni = parseInt(rangeUni.value);
    }

    const rangeCity = document.getElementById("UFSliderCity");
    if (rangeCity && !isNaN(parseInt(rangeCity.value))) {
        SavePytanie_3c_ZnaczenieDlaMiasta = parseInt(rangeCity.value);
    }

    const rangeRole = document.getElementById("UFSliderRole");
    if (rangeRole && !isNaN(parseInt(rangeRole.value))) {
        SavePytanie_4_Powiazanie = parseInt(rangeRole.value);
    }

    // Save text input (campus)
    const campusInput = document.getElementById("UFFormCampus");
    if (campusInput && campusInput.value.trim()) {
        SavePytanie_5_Campus = campusInput.value.trim();
    }

    // Save text input (elements)
    const elementsInput = document.getElementById("UFFormElements");
    if (elementsInput && elementsInput.value.trim()) {
        SavePytanie_6_Elementy = elementsInput.value.trim();
    }



    let saveUserID = sessionStorage.getItem('userID');
    let saveAgeGroup;

    if (sessionStorage.getItem('userAge')) {
        saveAgeGroup = sessionStorage.getItem('userAge');
    } else {
        saveAgeGroup = "-"
    }


    let saveRelationToPlace;
    if (sessionStorage.getItem('userRelation')) {
        saveRelationToPlace = sessionStorage.getItem('userRelation');
    } else {
        saveRelationToPlace = "-"
    }

    let saveRelationBusiness;
    if (sessionStorage.getItem('userRelationBusiness')) {
        saveRelationBusiness = sessionStorage.getItem('userRelationBusiness');
    } else {
        saveRelationBusiness = "-"
    }

    let saveGender
    if (sessionStorage.getItem('userGender')) {
        saveGender = sessionStorage.getItem('userGender');
    } else {
        saveGender = "-"
    }

    let saveEmail;
    if (sessionStorage.getItem('userEmail')) {
        saveEmail = sessionStorage.getItem('userEmail');
    } else {
        saveEmail = "-"
    }

    let saveUserRole;
    if (sessionStorage.getItem('userRole')) {
        saveUserRole = sessionStorage.getItem('userRole');
    } else {
        saveUserRole = "-"
    }


    let formData = {
        Pytanie_1_Cel: SavePytanie_1_Cel,
        Pytanie_2_Skojarzenia: SavePytanie_2_Skojarzenia,
        Pytanie_3a_ZnaczenieDlaDielnicy: SavePytanie_3a_ZnaczenieDlaDielnicy,
        Pytanie_3b_ZnaczenieDlaUczelni: SavePytanie_3b_ZnaczenieDlaUczelni,
        Pytanie_3c_ZnaczenieDlaMiasta: SavePytanie_3c_ZnaczenieDlaMiasta,
        Pytanie_4_Powiazanie: SavePytanie_4_Powiazanie,
        Pytanie_5_Campus: SavePytanie_5_Campus,
        Pytanie_6_Elementy: SavePytanie_6_Elementy,

        user_identifier: saveUserID,
        age_group: saveAgeGroup,
        relation_to_place: saveRelationToPlace,
        relation_business: saveRelationBusiness,
        gender: saveGender,
        email: saveEmail,
        users_role: saveUserRole

    };




    fetch('https://publictwin.info/digital_maquette/php_scripts/PlacKrakowskiSubmitSurvey.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                console.log("respose to survey submitted")
                // alert("Reaction submitted successfully!");
            } else {
                // alert("Error: " + data.error);
            }
        })
        .catch(error => {
            console.error("Fetch error:", error);
        });




}

function submitOpenQuestionResponse() {



    let saveUserID = sessionStorage.getItem('userID');

    let saveAgeGroup;
    if (sessionStorage.getItem('userAge')) {
        saveAgeGroup = sessionStorage.getItem('userAge');
    } else {
        saveAgeGroup = "-"
    }


    let saveRelationToPlace;
    if (sessionStorage.getItem('userRelation')) {
        saveRelationToPlace = sessionStorage.getItem('userRelation');
    } else {
        saveRelationToPlace = "-"
    }

    let saveRelationBusiness;
    if (sessionStorage.getItem('userRelationBusiness')) {
        saveRelationBusiness = sessionStorage.getItem('userRelationBusiness');
    } else {
        saveRelationBusiness = "-"
    }

    let saveGender
    if (sessionStorage.getItem('userGender')) {
        saveGender = sessionStorage.getItem('userGender');
    } else {
        saveGender = "-"
    }

    let saveEmail;
    if (sessionStorage.getItem('userEmail')) {
        saveEmail = sessionStorage.getItem('userEmail');
    } else {
        saveEmail = "-"
    }

    let saveUserRole;
    if (sessionStorage.getItem('userRole')) {
        saveUserRole = sessionStorage.getItem('userRole');
    } else {
        saveUserRole = "-"
    }



    let formData = {

        open_question_name: dataToSubmit.open_question_name,
        open_question_answer: dataToSubmit.open_question_answer,
        user_identifier: saveUserID,
        age_group: saveAgeGroup,
        relation_to_place: saveRelationToPlace,
        relation_business: saveRelationBusiness,
        gender: saveGender,
        email: saveEmail,
        users_role: saveUserRole

    };




    fetch('https://publictwin.info/digital_maquette/php_scripts/PlacKrakowskiSubmitOpenQuestion.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                console.log("respose to survey submitted")
                popupQuestions.remove();
                sessionPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
                sessionPTCoins += 50;
                checkCoinsRole();
                sessionStorage.setItem('userPTCoins', sessionPTCoins);
                document.getElementById("yourCoins").innerHTML = sessionStorage.getItem('userPTCoins');
                document.getElementById("yourCoinsInApp").innerHTML = sessionStorage.getItem('userPTCoins');
                showSuccessMessage("twoja odpowiedź została zapisana")
                // alert("Reaction submitted successfully!");
            } else {
                // alert("Error: " + data.error);
            }
        })
        .catch(error => {
            console.error("Fetch error:", error);
        });




}

function submitScore() {
    // dataToSubmit - needs to contain: reaction_comment, rating, coordinates

    let saveUserID = sessionStorage.getItem('userID');
    let saveUserPTCoins = parseInt(sessionStorage.getItem('userPTCoins'));
    let saveEmail;
    if (sessionStorage.getItem('userEmail')) {
        saveEmail = sessionStorage.getItem('userEmail');
    } else {
        saveEmail = "-"
    }


    let formData = {
        user_identifier: saveUserID,
        user_PTCoins: saveUserPTCoins,
        email: saveEmail,
    };

    fetch('https://publictwin.info/digital_maquette/php_scripts/PlacKrakowskiSubmitScore.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                // alert("finto.")
                // alert("Comment submitted successfully!");
            } else {
                // alert("Error: " + data.error);
            }
        })
        .catch(error => {
            console.error("Fetch error:", error);
        });
}



// === Explore data functions: ===

function explorePlacKrakowskiReactions() {
    const userID = sessionStorage.getItem('userID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiReactions.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `user_identifier=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFutureReactionsLayer')) map.removeLayer('UrbanFutureReactionsLayer');
            if (map.getSource('UrbanFutureReactionsSource')) map.removeSource('UrbanFutureReactionsSource');

            map.addSource('UrbanFutureReactionsSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'rating'],
                1, '#ea3621',
                2, '#f46a48',
                3, '#faca24',
                4, '#94c05c',
                5, '#528d23',
                '#cccccc'
            ];

            map.addLayer({
                id: 'UrbanFutureReactionsLayer',
                type: 'circle',
                source: 'UrbanFutureReactionsSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });

            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}
function explorePlacKrakowskiComments() {
    const userID = sessionStorage.getItem('userID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiComments.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `user_identifier=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFutureCommentsLayer')) map.removeLayer('UrbanFutureCommentsLayer');
            if (map.getSource('UrbanFutureCommentsSource')) map.removeSource('UrbanFutureCommentsSource');

            map.addSource('UrbanFutureCommentsSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'users_role'],

                'GreenGuardian', '#15803d',
                'ActivityScout', '#c2410c',
                'AccessInspector', '#1d4ed8',
                '#999999' // fallback for unknown roles
            ];

            map.addLayer({
                id: 'UrbanFutureCommentsLayer',
                type: 'circle',
                source: 'UrbanFutureCommentsSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });
            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}
function explorePlacKrakowskiPhotos() {
    const userID = sessionStorage.getItem('userID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiPhotos.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `user_identifier=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFuturePhotosLayer')) map.removeLayer('UrbanFuturePhotosLayer');
            if (map.getSource('UrbanFuturePhotosSource')) map.removeSource('UrbanFuturePhotosSource');

            map.addSource('UrbanFuturePhotosSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'users_role'],

                'GreenGuardian', '#15803d',
                'ActivityScout', '#c2410c',
                'AccessInspector', '#1d4ed8',
                '#999999' // fallback for unknown roles
            ];

            map.addLayer({
                id: 'UrbanFuturePhotosLayer',
                type: 'circle',
                source: 'UrbanFuturePhotosSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });
            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}





// === Pin Dropping Utilities: ===

function dropPinPlacKrakowskifFunction() {
    popupQuestions.remove();

    map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'none');
    map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'none');
    map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'none');

    const isMobile = window.innerWidth <= 768; // Define your mobile breakpoint
    if (isMobile) {
        // document.getElementsByClassName("mobileParticipateButtonsDiv")[0].style.display="none";
    }

    if (selectedProject) {
        try {
            if (selectedProject.properties.participatoryModuleActive == true) {
                // console.log("removing participatory icons!")
                if (map.getLayer('ParticipatoryActions')) {
                    map.removeLayer('ParticipatoryActions');
                }
                if (map.getSource('ParticipatoryActions')) {
                    map.removeSource('ParticipatoryActions');
                }
                participatePopup.remove();
            }
        }
        catch {
            console.log("no participatory module");
        }
    }

    dropingPinState = true;




    let target = {
        zoom: 16,
        pitch: 0,
        bearing: 0,
        center: [18.6732, 50.2916],
    }
    target.center = map.getCenter();

    flyTowards(target)

    PlacKrakowskiDropPinMarker.setLngLat(map.getCenter());
    PlacKrakowskiDropPinMarker.addTo(map);

    const coordinates = PlacKrakowskiDropPinMarker.getLngLat();

    if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }
    }



    addInfomationPopup();




}

function endPinPlacKrakowskifFunction() {

    const isMobile = window.innerWidth <= 768; // Define your mobile breakpoint
    if (isMobile) {
        // document.getElementsByClassName("mobileParticipateButtonsDiv")[0].style.display="block";
    }

    PlacKrakowskiDropPinMarker.remove();
    popupParticipateApp.remove();
    // popupQuestions.remove();

    dropingPinState = false;

};

function onPlacKrakowskiDragEnd() {

    // popupParticipateApp.remove();
}
function onPlacKrakowskiDrag() {
    const coordinates = PlacKrakowskiDropPinMarker.getLngLat();


    if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }
    }



    popupParticipateApp
        .setLngLat(coordinates)
}


PlacKrakowskiDropPinMarker.on('dragend', onPlacKrakowskiDragEnd);
PlacKrakowskiDropPinMarker.on('drag', onPlacKrakowskiDrag);



function loadPinQuestionImages() {
    // Load images
    if (map.hasImage('IconLike') && map.hasImage('IconDislike') && map.hasImage('IconIdentity') && map.hasImage('IconActivity')) {
        addPinQuestions();
        return;
    } else {
        map.loadImage('./res/map/IconLike.png', (error, image) => {
            if (error) throw error;
            map.addImage('IconLike', image);
            addPinQuestions();
        });

        map.loadImage('./res/map/IconDislike.png', (error, image) => {
            if (error) throw error;
            map.addImage('IconDislike', image);
            addPinQuestions();
        });
        map.loadImage('./res/map/IconIdentity.png', (error, image) => {
            if (error) throw error;
            map.addImage('IconIdentity', image);
            addPinQuestions();
        });
        map.loadImage('./res/map/IconActivity.png', (error, image) => {
            if (error) throw error;
            map.addImage('IconActivity', image);
            addPinQuestions();
        });
    }

}

function addPinQuestions() {
    QuestionImagesLoaded++;
    if (QuestionImagesLoaded >= 4) {



        if (!map.getSource('PinQuestions')) {
            map.addSource('PinQuestions', {
                'type': 'geojson',
                'data': PinQuestions
            });
        }
        if (!map.getLayer('PinQuestions')) {
            map.addLayer({
                'id': 'PinQuestions',
                'type': 'symbol',
                'source': 'PinQuestions',
                'layout': {
                    'icon-image': [
                        'case',
                        ['==', ['get', 'icon'], 'IconLike'], 'IconLike',
                        ['==', ['get', 'icon'], 'IconDislike'], 'IconDislike',
                        ['==', ['get', 'icon'], 'IconIdentity'], 'IconIdentity',
                        ['==', ['get', 'icon'], 'IconActivity'], 'IconActivity',
                        'logo1'
                    ],
                    'icon-size': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        11, 0.005,     // At zoom 9 → size 0.1
                        17, 0.10    // At zoom 16 → size 0.25
                    ],
                    'icon-padding': 0,
                    'icon-allow-overlap': true
                }
            });
        }




        map.on('click', 'PinQuestions', (e) => {
            // map.getCanvas().style.cursor = 'pointer';
            popupQuestions.remove();

            // selectedProject = e.features[0];
            const coordinates = e.features[0].geometry.coordinates.slice();
            const question = e.features[0].properties.question;
            selectedQuestion = e.features[0].properties.title;



            //         'properties': {
            //   'title': 'Pytania_Otwarte_01',
            //   'icon': 'IconLike',
            //   'question': 'Czym Plac Cię zachęca? Które elementy są dla Ciebie ważne?',
            //   "origin":[18.6737,50.2926],
            //   "cameraReset":{
            //     center: [18.6737,50.2926],
            //     zoom: 16.00,
            //     bearing: 45,
            //     pitch:45,
            //   },

            if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            }

            // map.stop();

            setTimeout(() => {
                map.flyTo({
                    center: coordinates,
                    zoom: 16.5,
                    pitch: 45,
                    bearing: 0,
                    essential: true,
                    duration: 1000,
                });
            }, 50);



            popupQuestions
                .setLngLat(coordinates)
                .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>${e.features[0].properties.question}</h3>
                        </div>

                        <div>
                            <textarea placeholder="twoja odpowiedź..." rows="2" id="questionAnswer-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionComment QuestionFinalize" autocomplete="off" tabindex="-1"></textarea>
                        </div>

                        <div class="UrbanFutureReactionFinalize QuestionFinalize">
                            <button id="closeQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionsClose UrbanFutureReactions">zamknij!</button>
                            <div class="marginUrbanFuture"></div>
                            <button id="submitQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionsSubmit UrbanFutureReactions">zapisz!</button>
                        </div>
                    `)
                .addTo(map);

            map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'none');
            map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'none');
            map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'none');



            const textarea = document.getElementById(`questionAnswer-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
            if (document.activeElement === textarea) {
                textarea.blur();
            }
            // document.getElementsByClassName("questionTitleDiv")[0].click();
            // document.getElementsByClassName("questionTitleDiv")[0].focus();

            const popupContent = document.querySelector('.mapboxgl-popup-content');
            const popupTip = document.querySelector('.mapboxgl-popup-tip');

            const enterButton = document.getElementById(`submitQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
            const closeButton = document.getElementById(`closeQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}`);


            if (enterButton) {
                enterButton.addEventListener('click', () => {
                    dataToSubmit.open_question_name = selectedQuestion;
                    dataToSubmit.open_question_answer = textarea.value && textarea.value.trim() !== "" ? textarea.value : "-";
                    submitOpenQuestionResponse(dataToSubmit);
                    map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
                    map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
                    map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');
                });
            }
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    popupQuestions.remove();
                    map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
                    map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
                    map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');

                });
            }


            popupReactions.remove();
            popupContent.classList.add("openQuestions");
            popupTip.classList.add("openQuestions");


            popupContent.classList.remove("reactionsPopUp");
            popupTip.classList.remove("reactionsPopUp");

            popupContent.classList.remove("ParticipateAppPopUp");
            popupTip.classList.remove("ParticipateAppPopUp");

            popupContent.classList.remove("Rating0");
            popupContent.classList.remove("Rating1");
            popupContent.classList.remove("Rating2");
            popupContent.classList.remove("Rating3");
            popupContent.classList.remove("Rating4");
            popupContent.classList.remove("Rating5");

            popupContent.classList.remove("maquetteInDevelopment");
            popupTip.classList.remove("maquetteInDevelopment");
            popupContent.classList.remove("activeMaquette");
            popupTip.classList.remove("activeMaquette");


        });

        map.on('touchstart', 'PinQuestions', (e) => {
            if (multitouchDetected == false && raycast == true) {
                // map.getCanvas().style.cursor = 'pointer';
                popupQuestions.remove();

                // selectedProject = e.features[0];
                const coordinates = e.features[0].geometry.coordinates.slice();
                const question = e.features[0].properties.question;
                selectedQuestion = e.features[0].properties.title;



                //         'properties': {
                //   'title': 'Pytania_Otwarte_01',
                //   'icon': 'IconLike',
                //   'question': 'Czym Plac Cię zachęca? Które elementy są dla Ciebie ważne?',
                //   "origin":[18.6737,50.2926],
                //   "cameraReset":{
                //     center: [18.6737,50.2926],
                //     zoom: 16.00,
                //     bearing: 45,
                //     pitch:45,
                //   },

                if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }
                }

                // map.stop();

                setTimeout(() => {
                    map.flyTo({
                        center: coordinates,
                        zoom: 16.5,
                        pitch: 45,
                        bearing: 0,
                        essential: true,
                        duration: 1000,
                    });
                }, 50);



                popupQuestions
                    .setLngLat(coordinates)
                    .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>${e.features[0].properties.question}</h3>
                        </div>

                        <div>
                            <textarea placeholder="twoja odpowiedź..." rows="2" id="questionAnswer-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionComment QuestionFinalize" autocomplete="off" tabindex="-1"></textarea>
                        </div>

                        <div class="UrbanFutureReactionFinalize QuestionFinalize">
                            <button id="closeQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionsClose UrbanFutureReactions">zamknij!</button>
                            <div class="marginUrbanFuture"></div>
                            <button id="submitQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}" class="UrbanFutureReactionsSubmit UrbanFutureReactions">zapisz!</button>
                        </div>
                    `)
                    .addTo(map);

                map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'none');
                map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'none');
                map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'none');



                const textarea = document.getElementById(`questionAnswer-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
                if (document.activeElement === textarea) {
                    textarea.blur();
                }
                // document.getElementsByClassName("questionTitleDiv")[0].click();
                // document.getElementsByClassName("questionTitleDiv")[0].focus();

                const popupContent = document.querySelector('.mapboxgl-popup-content');
                const popupTip = document.querySelector('.mapboxgl-popup-tip');

                const enterButton = document.getElementById(`submitQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}`);
                const closeButton = document.getElementById(`closeQuestion-${e.features[0].properties.title.replace(/\s+/g, '-')}`);


                if (enterButton) {
                    enterButton.addEventListener('click', () => {
                        dataToSubmit.open_question_name = selectedQuestion;
                        dataToSubmit.open_question_answer = textarea.value && textarea.value.trim() !== "" ? textarea.value : "-";
                        submitOpenQuestionResponse(dataToSubmit);
                        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
                        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
                        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');
                    });
                }
                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        popupQuestions.remove();
                        map.setLayoutProperty('UrbanFutureReactionsLayer', 'visibility', 'visible');
                        map.setLayoutProperty('UrbanFutureCommentsLayer', 'visibility', 'visible');
                        map.setLayoutProperty('UrbanFuturePhotosLayer', 'visibility', 'visible');

                    });
                }


                popupReactions.remove();
                popupContent.classList.add("openQuestions");
                popupTip.classList.add("openQuestions");


                popupContent.classList.remove("reactionsPopUp");
                popupTip.classList.remove("reactionsPopUp");

                popupContent.classList.remove("ParticipateAppPopUp");
                popupTip.classList.remove("ParticipateAppPopUp");

                popupContent.classList.remove("Rating0");
                popupContent.classList.remove("Rating1");
                popupContent.classList.remove("Rating2");
                popupContent.classList.remove("Rating3");
                popupContent.classList.remove("Rating4");
                popupContent.classList.remove("Rating5");

                popupContent.classList.remove("maquetteInDevelopment");
                popupTip.classList.remove("maquetteInDevelopment");
                popupContent.classList.remove("activeMaquette");
                popupTip.classList.remove("activeMaquette");
            }

        });


        map.on('mouseleave', 'PinQuestions', () => {
            map.getCanvas().style.cursor = '';
        });
        map.on('mouseenter', 'PinQuestions', () => {
            map.getCanvas().style.cursor = 'pointer';
        });
    }
}


function addInfomationPopup() {

    if (locationTypeAction == "PinBased") {




        const coordinates = PlacKrakowskiDropPinMarker.getLngLat();


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }



        popupParticipateApp
            .setLngLat(coordinates)
            .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>ustaw pinezkę w miejscu w którym chcesz zapisać reakcję</h3>
                        </div>
                    `)
            .addTo(map);



        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');




        popupReactions.remove();
        popupContent.classList.add("ParticipateAppPopUp");
        popupTip.classList.add("ParticipateAppPopUp");

        popupContent.classList.remove("reactionsPopUp");
        popupTip.classList.remove("reactionsPopUp");

        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");




    } else {
        const coordinates = userMarker.getLngLat();


        if (['mercator', 'equirectangular'].includes(map.getProjection().name)) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
        }



        popupParticipateApp
            .setLngLat(coordinates)
            .setHTML(`
                        <div class="questionTitleDiv">
                            <h3>twoja reakcja zostanie zapisana w miejscu twojej lokalizacji</h3>
                        </div>
                    `)
            .addTo(map);



        const popupContent = document.querySelector('.mapboxgl-popup-content');
        const popupTip = document.querySelector('.mapboxgl-popup-tip');


        popupReactions.remove();
        popupContent.classList.add("ParticipateAppPopUp");
        popupTip.classList.add("ParticipateAppPopUp");

        popupContent.classList.remove("reactionsPopUp");
        popupTip.classList.remove("reactionsPopUp");

        popupContent.classList.remove("Rating0");
        popupContent.classList.remove("Rating1");
        popupContent.classList.remove("Rating2");
        popupContent.classList.remove("Rating3");
        popupContent.classList.remove("Rating4");
        popupContent.classList.remove("Rating5");

        popupContent.classList.remove("maquetteInDevelopment");
        popupTip.classList.remove("maquetteInDevelopment");
        popupContent.classList.remove("activeMaquette");
        popupTip.classList.remove("activeMaquette");
        popupContent.classList.remove("openQuestions");
        popupTip.classList.remove("openQuestions");

        setTimeout(() => {
            popupParticipateApp.remove()
        }, 3000)



    }

}

function showErrorMessage(message) {
    showElement(document.getElementById("ErrorMessageDiv"));
    document.getElementById("ErrorMessageDiv").innerHTML = message;

    document.getElementById("AnalyticsTriggerButton").style.top = "130px"

    setTimeout(() => {
        hideElement(document.getElementById("ErrorMessageDiv"));
        document.getElementById("ErrorMessageDiv").innerHTML = "";
        document.getElementById("AnalyticsTriggerButton").style.top = "105px"

    }, 2500)

}
function showSuccessMessage(message) {
    showElement(document.getElementById("ErrorMessageDiv"));
    document.getElementById("ErrorMessageDiv").innerHTML = message;
    document.getElementById("AnalyticsTriggerButton").style.top = "130px"

    setTimeout(() => {
        hideElement(document.getElementById("ErrorMessageDiv"));
        document.getElementById("ErrorMessageDiv").innerHTML = "";
        document.getElementById("AnalyticsTriggerButton").style.top = "105px"

    }, 3500)

}







function switchMapStyle(styleUrl) {
    // Save camera state
    const camera = {
        center: map.getCenter(),
        zoom: map.getZoom(),
        bearing: map.getBearing(),
        pitch: map.getPitch()
    };

    // Switch map style
    map.setStyle(styleUrl);

    map.once('style.load', function () {
        imagesLoaded = 0;
        // Restore camera position
        map.jumpTo(camera);

        // Re-add necessary sources
        if (!map.getSource('UrbanFuture-region-boundary')) {
            map.addSource('UrbanFuture-region-boundary', {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: [[
                            [6.592574886374905, 53.2191053494941],
                            [6.592847606930604, 53.21843203926446],
                            [6.59243106761096, 53.21830640734353],
                            [6.5914580196954375, 53.21878630108276],
                            [6.591118663746869, 53.218818283022244],
                            [6.590448461090347, 53.219590460413656],
                            [6.590018692633635, 53.21944945862708],
                            [6.589223079928104, 53.21918044036704],
                            [6.589124603905276, 53.21928276496763],
                            [6.588644518609755, 53.21911895524411],
                            [6.5871706259762846, 53.21858439791987],
                            [6.586741745319898, 53.21843451598727],
                            [6.58583369183242, 53.218148220199964],
                            [6.585521032876869, 53.21848832846081],
                            [6.586936239107928, 53.21888771433544],
                            [6.586920023974841, 53.21890319368404],
                            [6.586961761383151, 53.21891588722511],
                            [6.587005686429734, 53.21889122899725],
                            [6.587358594167682, 53.218996783098106],
                            [6.587354006297801, 53.21903690584051],
                            [6.5883282691950456, 53.21932535081126],
                            [6.5888256289186415, 53.21947089971795],
                            [6.589487064296293, 53.21964708143713],
                            [6.590059295911374, 53.2198405306772],
                            [6.591538077712585, 53.2199667307861],
                            [6.591689978486755, 53.21999636543339],
                            [6.592377685085722, 53.22020222710441],
                            [6.593482270091556, 53.22053327598687],
                            [6.595620350361571, 53.22117368571543],
                            [6.595707453225629, 53.22104638563357],
                            [6.595809542728887, 53.22098255146804],
                            [6.595986187787133, 53.22092889665274],
                            [6.596084619523424, 53.22085625521217],
                            [6.5962298966636865, 53.22069659774414],
                            [6.596236765197091, 53.220642763650886],
                            [6.5962219092053545, 53.22056794506915],
                            [6.596069654618873, 53.22027424196574],
                            [6.5959419913577335, 53.22010694052619],
                            [6.5946249539887845, 53.21972660147651],
                            [6.594341104904146, 53.219612711507125],
                            [6.593639984976875, 53.21940263944444],
                            [6.593276984850263, 53.21929678646825],
                            [6.592574886374905, 53.2191053494941]

                        ]]
                    }
                }
            });
        }

        if (!map.getSource('UrbanFuture-walk-path')) {
            map.addSource('UrbanFuture-walk-path', {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    geometry: {
                        type: 'Polygon',
                        coordinates: [[
                            [6.590739609622574, 53.2198655360157],
                            [6.590819396403333, 53.21972841988219],
                            [6.591055625027678, 53.21938857575259],
                            [6.591333062382915, 53.21908972183829],
                            [6.592241042035283, 53.21935439665765],
                            [6.59255116436691, 53.21913484534369],
                            [6.5938202691685035, 53.219495681668405],
                            [6.594595951889858, 53.219770263126776],
                            [6.595874432126749, 53.22011637037261],
                            [6.596050835395658, 53.22031924199996],
                            [6.596180118863344, 53.22059885208998],
                            [6.5961774232021355, 53.22069176822288],
                            [6.595997548072319, 53.22088567647205],
                            [6.595836735420477, 53.22094057442135],
                            [6.595670990122869, 53.22101588904732],
                            [6.595590897694223, 53.22113801995644],
                            [6.5947487238426845, 53.2208770191267],
                            [6.5938024831647795, 53.220595243928926],
                            [6.592744827796167, 53.22027653606747],
                            [6.591656921416671, 53.219952449208364],
                            [6.590739609622574, 53.2198655360157]
                        ]]
                    }
                }
            });
        }


        // Re-add layers if needed
        if (!map.getLayer('UrbanFuture-walk-path')) {
            map.addLayer({
                id: 'UrbanFuture-walk-path',
                type: 'line',
                source: 'UrbanFuture-walk-path',
                layout: {},
                paint: {
                    'line-color': '#d0af2d',
                    'line-width': 3,
                    'line-dasharray': [2, 2]
                }
            });
        }
        if (!map.getLayer('UrbanFuture-walk-fill')) {
            map.addLayer({
                id: 'UrbanFuture-walk-fill',
                type: 'fill',
                source: 'UrbanFuture-walk-path',
                layout: {},
                paint: {
                    'fill-color': '#f9d235',
                    'fill-opacity': 0.2
                }
            });
        }

        if (!map.getLayer('UrbanFuture-region-fill')) {
            map.addLayer({
                id: 'UrbanFuture-region-fill',
                type: 'fill',
                source: 'UrbanFuture-region-boundary',
                layout: {},
                paint: {
                    'fill-color': '#f9d235',
                    'fill-opacity': 0.1
                }
            });
        }

        if (!map.getLayer('UrbanFuture-region-outline')) {
            map.addLayer({
                id: 'UrbanFuture-region-outline',
                type: 'line',
                source: 'UrbanFuture-region-boundary',
                layout: {},
                paint: {
                    'line-color': '#f9d235',
                    'line-width': 2
                }
            });
        }



        if (!map.getSource('eraser')) {

            // clip layer (eraser)
            map.addSource('eraser', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: [
                        {
                            type: 'Feature',
                            properties: {},
                            geometry: {
                                type: 'Polygon',
                                coordinates: [[
                                    [6.592818511842324, 53.219086728408854],
                                    [6.592496858923454, 53.219048239654455],
                                    [6.592594044874147, 53.21888118409052],
                                    [6.592898329708561, 53.21888539973878],
                                    [6.592818511842324, 53.219086728408854]
                                ]]
                            }
                        }
                    ]
                }
            });


        }

        if (!map.getLayer('eraser')) {
            map.addLayer({
                id: 'eraser',
                type: 'clip',
                source: 'eraser',
                layout: { 'clip-layer-types': ['symbol', 'model'] }
            });
        }

        // Re-add context parks layers
        addContextParksLayers();

        function checkImagesLoaded() {
            // console.log("running check images loaded!")
            imagesLoaded++;
            if (imagesLoaded >= 2) { // Number of images
                // Add the source and layer after images are loaded
                map.addSource('PTProjects', {
                    'type': 'geojson',
                    'data': PublicTwinProjects
                });

                map.addLayer({
                    'id': 'PTProjects',
                    'type': 'symbol',
                    'source': 'PTProjects',
                    'layout': {
                        'icon-image': [
                            'case',
                            ['==', ['get', 'activeStatus'], 'maquetteInDevelopment'], 'logo2',
                            ['==', ['get', 'activeStatus'], 'activeMaquette'], 'logo1',
                            'logo1'
                        ],
                        'icon-size': 0.025,
                        'icon-padding': 0,
                        'icon-allow-overlap': true
                    }
                });

                map.moveLayer("PTProjects")
                zoomLevelCheck(camera.zoom);
            }
        }
        // console.log(PublicTwinProjects);

        // Load images
        map.loadImage('./res/map/PublicTwin_Marker_Logo_Yellow.png', (error, image) => {
            if (error) throw error;
            map.addImage('logo1', image);
            checkImagesLoaded();
        });

        map.loadImage('./res/map/PublicTwin_Marker_Logo_Grey.png', (error, image) => {
            if (error) throw error;
            map.addImage('logo2', image);
            checkImagesLoaded();
        });










    });
}




document.getElementById("BottomStyleSwitch").addEventListener("click", function () {
    if (modelTypeSelection == "3Dmodel") {
        switchToSatelite();

    } else {
        switchTo3DModel();
    }

})

function switchToSatelite() {
    switchMapStyle('mapbox://styles/dripvisual/cmboqxo4600u301s594k89ie0')
    modelTypeSelection = "Satelite";

    document.getElementById("UrbanFutureSateliteMap").classList.add("SelectdToggleButton")
    while (document.getElementById("UrbanFuture3DmodelMap").classList.contains("SelectdToggleButton")) {
        document.getElementById("UrbanFuture3DmodelMap").classList.remove("SelectdToggleButton")
    }
}
function switchTo3DModel() {
    switchMapStyle('mapbox://styles/dripvisual/cmantxs6m01ii01skcbe76l1u')
    modelTypeSelection = "3Dmodel";
    document.getElementById("UrbanFuture3DmodelMap").classList.add("SelectdToggleButton")
    while (document.getElementById("UrbanFutureSateliteMap").classList.contains("SelectdToggleButton")) {
        document.getElementById("UrbanFutureSateliteMap").classList.remove("SelectdToggleButton")
    }
}



document.getElementById("SwitchToLogin").addEventListener("click", function () {

    toggleLogInFunctionUF();

})
document.getElementById("SwitchToRegister").addEventListener("click", function () {

    toggleSignUpFunctionUF();

})
document.getElementById("forgotPasswordUF").addEventListener("click", function () {

    toggleRemindFunctionUF();

})
document.getElementById("forgotPasswordLoginUF").addEventListener("click", function () {

    toggleLogInFunctionUF();

})



//SignUp/Login Menu Toggles:
function toggleLogInFunctionUF() {
    // console.log("toggle Log In!");
    document.getElementById("menuSignUpDivUF").style.display = "none";
    document.getElementById("menuLogInDivUF").style.display = "block";
    document.getElementById("passwordResetRequestDivUF").style.display = "none";
    document.getElementById("passwordResetDivUF").style.display = "none";

}
function toggleRemindFunctionUF() {
    document.getElementById("menuSignUpDivUF").style.display = "none";
    document.getElementById("menuLogInDivUF").style.display = "none";
    document.getElementById("passwordResetRequestDivUF").style.display = "block";
}
function toggleSignUpFunctionUF() {
    // console.log("toggle Sign Up!");
    document.getElementById("menuSignUpDivUF").style.display = "block";
    document.getElementById("menuLogInDivUF").style.display = "none";
    document.getElementById("passwordResetRequestDivUF").style.display = "none";
    document.getElementById("passwordResetDivUF").style.display = "none";
}
function toggleRemindTokenFunctionUF() {
    document.getElementById("menuSignUpDivUF").style.display = "none";
    document.getElementById("menuLogInDivUF").style.display = "none";
    document.getElementById("passwordResetRequestDivUF").style.display = "none";
    document.getElementById("passwordResetDivUF").style.display = "block";

}



//login actions PublicTwin Participate App:


document.getElementById('menuSignUpFormUF').addEventListener('submit', function (event) {
    event.preventDefault();

    const formData = new FormData(this);
    formData.append('user_role', '-');

    const password = String(formData.get('password'));
    const confirmPassword = String(formData.get('confirm_password'));
    const areEqual = password === confirmPassword;
    const signUpMessage = document.getElementById('signUpMessageUF');

    // Client-side wachtwoordcontrole (zelfde regels als server)
    function validatePassword(pw) {
        const hasUpperCase = /[A-Z]/.test(pw);
        const hasDigit = /\d/.test(pw);
        return pw.length >= 8 && hasUpperCase && hasDigit;
    }
    const isPasswordValid = validatePassword(password);

    if (!isPasswordValid) {
        signUpMessage.style.color = 'red';
        signUpMessage.innerText = 'Wachtwoord moet minstens 8 tekens bevatten, één hoofdletter en één cijfer.';
        return;
    }

    if (!areEqual) {
        signUpMessage.style.color = 'red';
        signUpMessage.innerText = 'Wachtwoorden komen niet overeen!';
        return;
    }

    // Helper: vertaal bekende serverberichten naar NL
    const toDutch = (msg) => {
        switch (msg) {
            case 'Sign up successful!':
                return 'Registratie gelukt!';
            case 'Email is already in use!':
                return 'Er bestaat al een gebruiker met dit e-mailadres!';
            case 'Passwords do not match!':
                return 'Wachtwoorden komen niet overeen!';
            case 'Password does not meet complexity requirements':
                return 'Wachtwoord moet minstens 8 tekens bevatten, één hoofdletter en één cijfer.';
            case 'Registration failed!':
                return 'Registratie mislukt. Probeer het opnieuw.';
            case 'Invalid email address':
                return 'Ongeldig e-mailadres.';
            case 'Server error':
                return 'Er is een serverfout opgetreden. Probeer het later opnieuw.';
            default:
                return msg || 'Er is iets misgegaan.';
        }
    };

    fetch('https://publictwin.info/digital_maquette/php_scripts/registerEngagement.php', {
        method: 'POST',
        body: formData,
        credentials: 'include'
    })
        .then(async (response) => {
            // Probeer JSON te lezen, ook bij non-2xx
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
                const msg = toDutch(data.message);
                throw new Error(msg);
            }
            return data;
        })
        .then((data) => {
            if (data.success) {
                signUpMessage.style.color = 'green';
                signUpMessage.innerText = toDutch(data.message);

                setTimeout(function () {
                    if (window.self !== window.top) {
                        // In een iframe
                        try {
                            window.parent.postMessage({
                                type: 'userLoggedIn',
                                payload: {
                                    user_id: data.user.user_id,
                                    email: data.user.email,
                                    role: data.user.user_role,
                                    user_permissions: data.user.user_permissions,
                                    project_permissions: data.user.project_permissions,
                                }
                            }, '*');
                        } catch {
                            // noop
                        }
                    } else {
                        // Top-level
                        checkLoginStatus();
                    }
                }, 500);
            } else {
                signUpMessage.style.color = 'red';
                signUpMessage.innerText = toDutch(data.message);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            signUpMessage.style.color = 'red';
            signUpMessage.innerText = error.message || 'Er is iets misgegaan.';
        });

    posthog.capture('userSignUp');
});



// --- LOGIN ---
document.getElementById('menuLogInFormUF').addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const loginMessage = document.getElementById('loginMessageUF');

    fetch('https://publictwin.info/digital_maquette/php_scripts/login.php', {
        method: 'POST',
        body: formData,
        credentials: 'include',
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                loginMessage.style.color = 'green';
                loginMessage.innerText = 'Succesvol ingelogd!';

                setTimeout(function () {
                    if (window.self !== window.top) {
                        // In iframe → inform parent
                        try {
                            window.parent.postMessage({
                                type: 'userLoggedIn',
                                payload: {
                                    user_id: data.user.user_id,
                                    email: data.user.email,
                                    role: data.user.user_role,
                                    user_permissions: data.user.user_permissions,
                                    project_permissions: data.user.project_permissions,
                                }
                            }, '*');
                        } catch { }
                    } else {
                        // Top-level
                        checkLoginStatus();
                    }
                }, 500);

            } else {
                loginMessage.style.color = 'red';
                if (data.message === 'Login failed, incorrect password!') {
                    loginMessage.innerText = 'Onjuist wachtwoord, probeer het opnieuw!';
                } else {
                    loginMessage.innerText = data.message || 'Inloggen mislukt.';
                }
            }
        })
        .catch(error => {
            console.error('Error:', error);
            loginMessage.style.color = 'red';
            loginMessage.innerText = 'Inloggen mislukt, probeer het nog eens!';
        });

    posthog.capture('userLogin');
});


// --- PASSWORD RESET REQUEST (send link) ---
document.getElementById('passwordResetRequestFormUF').addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(this);

    // Include the page we’re on, so the email link comes back here
    formData.append('return_url', window.location.href);

    // Preserve activeProject if present
    const urlParams = new URLSearchParams(window.location.search);
    const activeProject = urlParams.get('activeProject') || '';
    if (activeProject) formData.append('activeProject', activeProject);

    // Determine language: from URL (?lang=nl), or fallback to 'en'
    const lang = (urlParams.get('lang') || 'nl').toLowerCase();
    formData.append('lang', (lang === 'nl') ? 'nl' : 'en');

    fetch('https://publictwin.info/digital_maquette/php_scripts/password_Reset_EngagementPrototypes.php', {
        method: 'POST',
        body: formData
    })
        .then(r => r.json())
        .then(data => {
            const resetMessage = document.getElementById('resetRequestMessageUF');
            resetMessage.style.color = data.success ? 'green' : 'red';
            resetMessage.innerText = data.message || (data.success
                ? (lang === 'nl'
                    ? 'Er is een link om je wachtwoord te resetten naar je e-mail verzonden.'
                    : 'A password reset link has been sent to your email.')
                : (lang === 'nl'
                    ? 'E-mail verzenden is mislukt. Probeer het opnieuw.'
                    : 'Failed to send the email. Please try again.'));
        })
        .catch(() => {
            const resetMessage = document.getElementById('resetRequestMessageUF');
            resetMessage.style.color = 'red';
            resetMessage.innerText = (lang === 'nl')
                ? 'E-mail verzenden is mislukt. Probeer het opnieuw.'
                : 'Failed to send the email. Please try again.';
        });
});



// --- PASSWORD RESET (set new password) ---
document.getElementById('passwordResetFormUF').addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(this);
    const resetMessage = document.getElementById('resetMessageUF');
    const newPassword = document.getElementById('newPasswordUF').value;
    const confirmPassword = document.getElementById('confirmNewPasswordUF').value;

    // Validatie: minimaal 8, hoofdletter, cijfer
    if (newPassword.length < 8 || !/[A-Z]/.test(newPassword) || !/[0-9]/.test(newPassword)) {
        resetMessage.style.color = 'red';
        resetMessage.innerText = 'Het wachtwoord moet minimaal 8 tekens, een hoofdletter en een cijfer bevatten!';
        return;
    }
    if (newPassword !== confirmPassword) {
        resetMessage.style.color = 'red';
        resetMessage.innerText = 'Wachtwoorden komen niet overeen!';
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/reset_password.php', {
        method: 'POST',
        body: formData,
        credentials: 'include',
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                resetMessage.style.color = 'green';
                resetMessage.innerText =
                    (data.message === 'Password has been reset successfully.')
                        ? 'Nieuw wachtwoord opgeslagen!'
                        : (data.message || 'Nieuw wachtwoord opgeslagen!');
                setTimeout(function () {
                    checkLoginStatus();
                    toggleLogInFunctionUF();
                }, 800);
            } else {
                resetMessage.style.color = 'red';
                if (data.message === 'Invalid or expired token.') {
                    resetMessage.innerText = 'Je resetlink is verlopen!';
                } else {
                    resetMessage.innerText = data.message || 'Resetten mislukt.';
                }
            }
        });

    posthog.capture('passwordReset');
});



document.getElementById("togglePasswordUF").addEventListener('click', () => {
    const password = document.querySelector('#passwordUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordUF").classList.toggle("bi-eye");
});

document.getElementById("togglePasswordConfirmUF").addEventListener('click', () => {
    const password = document.querySelector('#confirm_passwordUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordConfirmUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordConfirmUF").classList.toggle("bi-eye");
});


document.getElementById("togglePasswordLoginUF").addEventListener('click', () => {
    const password = document.querySelector('#passwordLogInUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordLoginUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordLoginUF").classList.toggle("bi-eye");
});


document.getElementById("togglePasswordResetUF").addEventListener('click', () => {
    const password = document.querySelector('#newPasswordUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordResetUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordResetUF").classList.toggle("bi-eye");
});

document.getElementById("togglePasswordResetConfirmUF").addEventListener('click', () => {
    const password = document.querySelector('#confirmNewPasswordUF');
    const type = password
        .getAttribute('type') === 'password' ?
        'text' : 'password';
    password.setAttribute('type', type);

    // Toggle the eye and bi-eye icon:
    document.getElementById("togglePasswordResetConfirmUF").classList.toggle("bi-eye-slash");
    document.getElementById("togglePasswordResetConfirmUF").classList.toggle("bi-eye");
});


const cancelResetBtn = document.getElementById('cancelPasswordResetUF');
if (cancelResetBtn) {
    cancelResetBtn.addEventListener('click', () => {
        PasswordReset = false; // turn off reset mode
        // Show regular login view
        document.getElementById("menuSignUpDivUF").style.display = "none";
        document.getElementById("menuLogInDivUF").style.display = "block";
        document.getElementById("passwordResetRequestDivUF").style.display = "none";
        document.getElementById("passwordResetDivUF").style.display = "none";
        document.getElementById("userPanelUF").style.display = "none";

        // (Optional) remove token from URL so the page doesn't re-enter reset mode on refresh
        try {
            const url = new URL(window.location.href);
            url.searchParams.delete('token');
            history.replaceState({}, '', url.toString());
        } catch { }
    });
}

document.getElementById('UrbanFutureLoginButton').addEventListener('click', function () {
    // document.getElementById("UrbanFutureTopNavbarSelectOptions").click();

    let status = document.getElementById("UrbanFutureLoginButton").getAttribute("loggedInStatus");
    console.log(status); // "false" or "true"

    if (status == "false") {


        document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UserLoginMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UserLoginMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone")
        }

        document.getElementById("menuSignUpDivUF").style.display = "none";
        document.getElementById("menuLogInDivUF").style.display = "block";
        document.getElementById("passwordResetRequestDivUF").style.display = "none";
        document.getElementById("passwordResetDivUF").style.display = "none";
        document.getElementById("userPanelUF").style.display = "none";

        document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display = "none";
    }
    else {
        console.log("showing account panel");

        document.getElementById("UrbanFutureMainMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureChooseRoleMenu").classList.add("UrbanFutureDisplayNone")
        document.getElementById("UrbanFutureIntroduceMenu").classList.add("UrbanFutureDisplayNone")
        while (document.getElementById("UserLoginMenuUrbanFuture").classList.contains("UrbanFutureDisplayNone")) {
            document.getElementById("UserLoginMenuUrbanFuture").classList.remove("UrbanFutureDisplayNone")
        }

        document.getElementById("menuSignUpDivUF").style.display = "none";
        document.getElementById("menuLogInDivUF").style.display = "none";
        document.getElementById("passwordResetRequestDivUF").style.display = "none";
        document.getElementById("passwordResetDivUF").style.display = "none";
        document.getElementById("userPanelUF").style.display = "block";


        document.getElementById("TopNavbarUrbanFutureSelectOptions").style.display = "none";
    }


    try {
        const urlParams = new URLSearchParams(window.location.search);
        let resetToken = urlParams.get('token');
        if (resetToken) {
            document.getElementById("menuSignUpDivUF").style.display = "none";
            document.getElementById("menuLogInDivUF").style.display = "none";
            document.getElementById("passwordResetRequestDivUF").style.display = "none";
            document.getElementById("passwordResetDivUF").style.display = "block";
            document.getElementById("userPanelUF").style.display = "none";


        }

    } catch {
        console.log("no reset token found");
    }

});

document.getElementById("logoutButtonUF").addEventListener('click', function () {


    if (window.self !== window.top) {
        // This is running in an iframe
        try {
            window.parent.postMessage({
                type: 'userLoggedOut',
                payload: {
                    user_id: "none"
                }
            }, '*');
        } catch {

        }

    } else {

    }
    // Get the current URL
    var currentUrl = window.location.href;

    // Encode the URL to make it safe to pass as a query parameter
    var encodedUrl = encodeURIComponent(currentUrl);

    // Redirect to the PHP script with the current URL as a parameter
    window.location.href = 'https://publictwin.info/digital_maquette/php_scripts/logout.php?current_url=' + encodedUrl;

    setTimeout(
        checkLoginStatus(), 500
    )


});
document.getElementById("deleteAccountButtonUF").addEventListener('click', function () {
    console.log("deleting user account!");
    showElement(document.getElementById("confirmUserDelete"));
    document.getElementById("userPanelUF").style.display = "none";
    // hideElement(document.getElementById("userPanelUF"));
});
document.getElementById("UrbanFutureConfirmDelete").addEventListener('click', function () {
    console.log("confirming deleting user account!");
    deleteUser();

});
document.getElementById("UrbanFutureDeleteBack").addEventListener('click', function () {
    hideElement(document.getElementById("confirmUserDelete"));
    document.getElementById("userPanelUF").style.display = "block";
    // showElement(document.getElementById("userPanelUF"));
});



document.getElementById("AnalyticsTriggerButton").addEventListener('click', function () {
    if (adminPanel.classList.contains("UrbanFutureDisplayNone")) {
        adminPanel.classList.remove("UrbanFutureDisplayNone");
        openAdminPanel();

        hideElement(document.getElementById("BotomActionsUrbanPhoto"));
        hideElement(document.getElementById("BotomActionsUrbanReaction"));
        hideElement(document.getElementById("BotomActionsUrbanComment"));
        hideElement(document.getElementById("UrbanFutureConfirmLocation"));
        endPinPlacKrakowskifFunction();
        whiteFrame();
    } else {
        adminPanel.classList.add("UrbanFutureDisplayNone")
    }

    if (userPermissionsStatus == "KOM" || userPermissionsStatus == "admin" || userProjectPermissionsStatus.includes("HPGroningen")) {
        showElement(document.getElementById("reactionsFilteringSystem"));
    } else {
        hideElement(document.getElementById("reactionsFilteringSystem"));
    }
});

document.getElementById("CloseAnalyticsMenuUF").addEventListener('click', function () {
    adminPanel.classList.add("UrbanFutureDisplayNone")
});

document.getElementById("ShowMyDataUF").addEventListener('click', function () {
    //
    showMyReactions();

});
document.getElementById("ShowAllDataUF").addEventListener('click', function () {
    //
    if (userPermissionsStatus == "KOM" || userPermissionsStatus == "admin" || userProjectPermissionsStatus.includes("HPGroningen")) {
        showAllRactions();
    } else {
        showErrorMessage("you dont have permissions to see all data!");
    }

});

document.getElementById("HideAllDataUF").addEventListener('click', function () {
    //
    hideReactions();

});

// userPermissionsStatus = data.user_permissions;
// userProjectPermissionsStatus = data.project_permissions;


function showMyReactions() {
    console.log("showing my reactions");
    explorePlacKrakowskiReactionsLogedIn();
    explorePlacKrakowskiCommentsLogedIn();
    explorePlacKrakowskiPhotosLogedIn();
    popupReactions.remove();


}


function showAllRactions() {
    console.log("showing all reactions");
    explorePlacKrakowskiReactionsAll();
    explorePlacKrakowskiCommentsAll();
    explorePlacKrakowskiPhotosAll();
    popupReactions.remove();

}

function hideReactions() {
    if (map.getLayer('UrbanFutureReactionsLayer')) map.removeLayer('UrbanFutureReactionsLayer');
    if (map.getSource('UrbanFutureReactionsSource')) map.removeSource('UrbanFutureReactionsSource');
    if (map.getLayer('UrbanFutureCommentsLayer')) map.removeLayer('UrbanFutureCommentsLayer');
    if (map.getSource('UrbanFutureCommentsSource')) map.removeSource('UrbanFutureCommentsSource');
    if (map.getLayer('UrbanFuturePhotosLayer')) map.removeLayer('UrbanFuturePhotosLayer');
    if (map.getSource('UrbanFuturePhotosSource')) map.removeSource('UrbanFuturePhotosSource');
    popupReactions.remove();

}

document.getElementById("CloseUserPanel").addEventListener('click', function () {
    document.getElementById("UrbanFutureTopNavbarSelectOptions").click();
});


function explorePlacKrakowskiReactionsLogedIn() {
    const userID = sessionStorage.getItem('loginUserID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }
    if (userID == "-") {
        console.error("Missing userID in sessionStorage.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiReactions_LoggedIn.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFutureReactionsLayer')) map.removeLayer('UrbanFutureReactionsLayer');
            if (map.getSource('UrbanFutureReactionsSource')) map.removeSource('UrbanFutureReactionsSource');

            map.addSource('UrbanFutureReactionsSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'rating'],
                1, '#ea3621',
                2, '#f46a48',
                3, '#faca24',
                4, '#94c05c',
                5, '#528d23',
                '#cccccc'
            ];

            map.addLayer({
                id: 'UrbanFutureReactionsLayer',
                type: 'circle',
                source: 'UrbanFutureReactionsSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });

            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}
function explorePlacKrakowskiCommentsLogedIn() {
    const userID = sessionStorage.getItem('loginUserID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }
    if (userID == "-") {
        console.error("Missing userID in sessionStorage.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiComments_LoggedIn.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFutureCommentsLayer')) map.removeLayer('UrbanFutureCommentsLayer');
            if (map.getSource('UrbanFutureCommentsSource')) map.removeSource('UrbanFutureCommentsSource');

            map.addSource('UrbanFutureCommentsSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'users_role'],

                'GreenGuardian', '#15803d',
                'ActivityScout', '#c2410c',
                'AccessInspector', '#1d4ed8',
                '#999999' // fallback for unknown roles
            ];

            map.addLayer({
                id: 'UrbanFutureCommentsLayer',
                type: 'circle',
                source: 'UrbanFutureCommentsSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });
            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}
function explorePlacKrakowskiPhotosLogedIn() {
    const userID = sessionStorage.getItem('loginUserID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }
    if (userID == "-") {
        console.error("Missing userID in sessionStorage.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiPhotos_LoggedIn.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFuturePhotosLayer')) map.removeLayer('UrbanFuturePhotosLayer');
            if (map.getSource('UrbanFuturePhotosSource')) map.removeSource('UrbanFuturePhotosSource');

            map.addSource('UrbanFuturePhotosSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'users_role'],

                'GreenGuardian', '#15803d',
                'ActivityScout', '#c2410c',
                'AccessInspector', '#1d4ed8',
                '#999999' // fallback for unknown roles
            ];

            map.addLayer({
                id: 'UrbanFuturePhotosLayer',
                type: 'circle',
                source: 'UrbanFuturePhotosSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });
            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}



function explorePlacKrakowskiReactionsAll() {
    const userID = sessionStorage.getItem('loginUserID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiReactionsAll.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFutureReactionsLayer')) map.removeLayer('UrbanFutureReactionsLayer');
            if (map.getSource('UrbanFutureReactionsSource')) map.removeSource('UrbanFutureReactionsSource');

            map.addSource('UrbanFutureReactionsSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'rating'],
                1, '#ea3621',
                2, '#f46a48',
                3, '#faca24',
                4, '#94c05c',
                5, '#528d23',
                '#cccccc'
            ];

            map.addLayer({
                id: 'UrbanFutureReactionsLayer',
                type: 'circle',
                source: 'UrbanFutureReactionsSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });

            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}
function explorePlacKrakowskiCommentsAll() {
    const userID = sessionStorage.getItem('userID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }


    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiCommentsAll.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFutureCommentsLayer')) map.removeLayer('UrbanFutureCommentsLayer');
            if (map.getSource('UrbanFutureCommentsSource')) map.removeSource('UrbanFutureCommentsSource');

            map.addSource('UrbanFutureCommentsSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'users_role'],

                'GreenGuardian', '#15803d',
                'ActivityScout', '#c2410c',
                'AccessInspector', '#1d4ed8',
                '#999999' // fallback for unknown roles
            ];

            map.addLayer({
                id: 'UrbanFutureCommentsLayer',
                type: 'circle',
                source: 'UrbanFutureCommentsSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });
            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}
function explorePlacKrakowskiPhotosAll() {
    const userID = sessionStorage.getItem('userID');

    if (!userID) {
        console.error("Missing userID in sessionStorage.");
        return;
    }
    if (userID == "-") {
        console.error("Missing userID in sessionStorage.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiPhotosAll.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(response => response.json())
        .then(data => {
            if (map.getLayer('UrbanFuturePhotosLayer')) map.removeLayer('UrbanFuturePhotosLayer');
            if (map.getSource('UrbanFuturePhotosSource')) map.removeSource('UrbanFuturePhotosSource');

            map.addSource('UrbanFuturePhotosSource', {
                type: 'geojson',
                data: data
            });

            // Combined match on role + rating
            const colorExpression = [
                'match',
                ['get', 'users_role'],

                'GreenGuardian', '#15803d',
                'ActivityScout', '#c2410c',
                'AccessInspector', '#1d4ed8',
                '#999999' // fallback for unknown roles
            ];

            map.addLayer({
                id: 'UrbanFuturePhotosLayer',
                type: 'circle',
                source: 'UrbanFuturePhotosSource',
                paint: {
                    'circle-radius': {
                        base: 1.25,
                        stops: [[11, 2], [18, 18]]
                    },
                    'circle-opacity': 0.55,
                    'circle-stroke-width': 0,
                    'circle-stroke-color': '#000',
                    'circle-color': colorExpression
                }
            });
            if (map.getLayer('PinQuestions')) {
                map.moveLayer("PinQuestions");
            }
            // alert("pins reading functioned correctly")
        })
        .catch(error => {
            console.error("Error fetching UrbanFuture reactions:", error);
            // alert("pins reading failed")
        });
}



// listening for events sent from an iframe:


window.addEventListener("message", function (event) {
    if (event.data && event.data.type === 'loginStatus') {
        const user = event.data.user;
        checkLoginStatus(true, user);
        // console.log(user);
    }

});



function deleteUser() {
    const userId = sessionStorage.getItem('loginUserID');

    if (!userId || userId === "none") {
        console.warn("User ID missing; cannot delete.");
        return;
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/delete_user.php', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `user_id=${encodeURIComponent(userId)}`
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                console.log("User deleted.");
                document.getElementById("logoutButtonUF").click();

            } else {
                console.warn("Delete failed:", data.message);
            }
        })
        .catch(error => {
            console.error("Delete error:", error);
        });
}


// All functions related to reactions filtering:

const minSlider = document.getElementById('rangeMin');
const maxSlider = document.getElementById('rangeMax');
const range = document.getElementById('sliderRange');
const minLabel = document.getElementById('rangeMinLabel');
const maxLabel = document.getElementById('rangeMaxLabel');
const ratingColors = {
    1: '#ea3621',
    2: '#f46a48',
    3: '#faca24',
    4: '#94c05c',
    5: '#528d23'
};

function updateRange() {
    const min = parseFloat(minSlider.min);
    const max = parseFloat(minSlider.max);
    const minVal = Math.min(parseFloat(minSlider.value), parseFloat(maxSlider.value));
    const maxVal = Math.max(parseFloat(minSlider.value), parseFloat(maxSlider.value));

    const percentMin = ((minVal - min) / (max - min)) * 100;
    const percentMax = ((maxVal - min) / (max - min)) * 100;

    // Update range bar
    range.style.left = `${percentMin}%`;
    range.style.right = `${100 - percentMax}%`;

    // Set label values
    minLabel.textContent = minVal;
    maxLabel.textContent = maxVal;

    // Set background color
    minLabel.style.backgroundColor = ratingColors[minVal] || '#ccc';
    maxLabel.style.backgroundColor = ratingColors[maxVal] || '#ccc';

    // Accurate position over thumbs
    const sliderWidth = minSlider.clientWidth;
    const thumbWidth = 16; // match CSS thumb size exactly

    const minThumbX = (percentMin / 100) * (sliderWidth - thumbWidth) + (thumbWidth / 2);
    const maxThumbX = (percentMax / 100) * (sliderWidth - thumbWidth) + (thumbWidth / 2);

    minLabel.style.left = `${minThumbX}px`;
    maxLabel.style.left = `${maxThumbX}px`;
}

// Sync on input
minSlider.addEventListener('input', () => {
    updateRange();
    applyExploreFilters();

});
maxSlider.addEventListener('input', () => {
    updateRange();
    applyExploreFilters();

});


// Show/hide filters based on selection
function updateFilterVisibility() {
    document.getElementById('ratingRangeLabel').style.display = chkReactions.checked ? 'block' : 'none';
    document.getElementById('commentQuestionLabel').style.display = chkComments.checked ? 'block' : 'none';
}


// Listen for checkbox changes
document.querySelectorAll('#chkReactions, #chkComments, #chkPhotos').forEach(cb =>
    cb.addEventListener('change', function () {
        updateFilterVisibility();
        applyExploreFilters();
    })
);

// Main filter function
function applyExploreFilters() {
    if (userPermissionsStatus == "KOM" || userPermissionsStatus == "admin" || userProjectPermissionsStatus.includes("PKrak")) {
        if (chkReactions.checked) {
            loadFilteredReactions();
            updateRange();
        } else {
            removeLayerAndSource('UrbanFutureReactionsLayer', 'UrbanFutureReactionsSource');

            minSlider.value = minSlider.min;
            maxSlider.value = maxSlider.max;


            updateRange();
        }

        if (chkComments.checked) {
            loadFilteredComments();
        } else {
            removeLayerAndSource('UrbanFutureCommentsLayer', 'UrbanFutureCommentsSource');
        }

        // Deselect all comment options when checkbox is unchecked
        if (!chkComments.checked) {
            if (window.innerWidth > 768) {
                // Desktop: uncheck all checkboxes
                document.querySelectorAll('#commentCheckboxContainer input[type="checkbox"]').forEach(cb => {
                    cb.checked = false;
                });
            } else {
                // Mobile: deselect all options in <select multiple>
                const select = document.getElementById('commentQuestionSelect');
                Array.from(select.options).forEach(opt => {
                    opt.selected = false;
                });
            }
        }

        if (chkPhotos.checked) {
            loadPhotos();
        } else {
            removeLayerAndSource('UrbanFuturePhotosLayer', 'UrbanFuturePhotosSource');
        }

        popupReactions.remove();
    } else {
        showErrorMessage("nie posiadasz odpowiednich pozwoleń")
    }

}

// Load reactions based on slider range
function loadFilteredReactions() {
    const userID = sessionStorage.getItem('loginUserID');
    if (!userID || userID === "-") return;

    const minRating = Math.min(parseInt(minSlider.value), parseInt(maxSlider.value));
    const maxRating = Math.max(parseInt(minSlider.value), parseInt(maxSlider.value));

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiReactionsAll.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(res => res.json())
        .then(data => {
            const filtered = {
                ...data,
                features: data.features.filter(f =>
                    f.properties.rating >= minRating && f.properties.rating <= maxRating
                )
            };
            renderLayer('UrbanFutureReactionsLayer', 'UrbanFutureReactionsSource', filtered, ['get', 'rating'], {
                1: '#ea3621', 2: '#f46a48', 3: '#faca24', 4: '#94c05c', 5: '#528d23'
            });
        });
}

// Load comments filtered by selected question(s)
function loadFilteredComments() {
    const userID = sessionStorage.getItem('loginUserID');
    if (!userID || userID === "-") return;

    let selectedOptions = [];
    if (window.innerWidth > 768) {
        // Desktop: use checkboxes
        selectedOptions = Array.from(document.querySelectorAll('#commentCheckboxContainer input[type="checkbox"]:checked'))
            .map(cb => cb.value);
    } else {
        // Mobile: use <select multiple>
        selectedOptions = Array.from(document.getElementById('commentQuestionSelect').selectedOptions)
            .map(opt => opt.value);
    }

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiCommentsAll.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(res => res.json())
        .then(data => {
            const filtered = {
                ...data,
                features: data.features.filter(f =>
                    selectedOptions.includes(f.properties.selected_comment_question)
                )
            };
            renderLayer('UrbanFutureCommentsLayer', 'UrbanFutureCommentsSource', filtered, ['get', 'users_role'], {
                'GreenGuardian': '#15803d',
                'ActivityScout': '#c2410c',
                'AccessInspector': '#1d4ed8'
            });
        });
}

// Load all photos
function loadPhotos() {
    const userID = sessionStorage.getItem('loginUserID');
    if (!userID || userID === "-") return;

    fetch('https://publictwin.info/digital_maquette/php_scripts/read_PlacKrakowskiPhotosAll.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `loginUserID=${encodeURIComponent(userID)}`
    })
        .then(res => res.json())
        .then(data => {
            renderLayer('UrbanFuturePhotosLayer', 'UrbanFuturePhotosSource', data, ['get', 'users_role'], {
                'GreenGuardian': '#15803d',
                'ActivityScout': '#c2410c',
                'AccessInspector': '#1d4ed8'
            });
        });
}

function renderLayer(layerID, sourceID, geojsonData, matchField, colorMap) {
    if (map.getLayer(layerID)) map.removeLayer(layerID);
    if (map.getSource(sourceID)) map.removeSource(sourceID);

    map.addSource(sourceID, { type: 'geojson', data: geojsonData });

    const colorExpression = ['match', matchField];
    for (const key in colorMap) {
        colorExpression.push(isNaN(key) ? key : parseInt(key), colorMap[key]);
    }
    colorExpression.push('#cccccc');

    map.addLayer({
        id: layerID,
        type: 'circle',
        source: sourceID,
        paint: {
            'circle-radius': { base: 1.25, stops: [[11, 2], [18, 18]] },
            'circle-opacity': 0.55,
            'circle-stroke-width': 0,
            'circle-stroke-color': '#000',
            'circle-color': colorExpression
        }
    });

    if (map.getLayer('PinQuestions')) map.moveLayer('PinQuestions');
}
function removeLayerAndSource(layerID, sourceID) {
    if (map.getLayer(layerID)) map.removeLayer(layerID);
    if (map.getSource(sourceID)) map.removeSource(sourceID);
}


function convertSelectToCheckboxes() {
    const select = document.getElementById('commentQuestionSelect');
    const checkboxContainer = document.getElementById('commentCheckboxContainer');

    // Only apply on desktop
    if (window.innerWidth > 768) {
        checkboxContainer.innerHTML = ''; // Clear if re-rendering
        Array.from(select.options).forEach(option => {
            const label = document.createElement('label');
            label.innerHTML = `
    <input type="checkbox" value="${option.value}">
    <span>${option.text}</span>
    `;
            checkboxContainer.appendChild(label);
        });

        // Hide the select, show checkboxes
        select.style.display = 'none';
        checkboxContainer.style.display = 'block';
    }
}
// Trigger filter when desktop checkboxes are changed
document.addEventListener('change', function (e) {
    const isDesktop = window.innerWidth > 768;
    const isCommentCheckbox = e.target.closest('#commentCheckboxContainer input[type="checkbox"]');
    if (isDesktop && isCommentCheckbox) {
        applyExploreFilters();
    }
});

// Trigger filter when mobile <select multiple> changes
const mobileSelect = document.getElementById('commentQuestionSelect');
mobileSelect.addEventListener('change', () => {
    if (window.innerWidth <= 768) {
        applyExploreFilters();
    }
});

window.addEventListener('DOMContentLoaded', function () {
    convertSelectToCheckboxes();
    updateRange();

});
window.addEventListener('resize', function () {
    convertSelectToCheckboxes();
    updateRange();
});



document.getElementById("introduce").addEventListener('click', function () {
    console.log("introduceCheckbox clicked");
    document.getElementById("UrbanFutureIntroduceButton").click();
});




// ───────────────────────────────────────────────────────────────────────────────
// Mobile landscape → ask user to rotate to portrait
// ───────────────────────────────────────────────────────────────────────────────
(function initRotateHint() {
    const id = 'rotate-hint';
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement('div');
        el.id = id;
        el.innerHTML = `
      <div class="box">
        <div style="font-size:20px;margin-bottom:4px;">Best viewed in portrait</div>
        <div style="font-size:14px;opacity:.9;">Rotate your device for the full experience.</div>
      </div>`;
        document.body.appendChild(el);
    }
    const mq = window.matchMedia('(max-width: 860px) and (orientation: landscape)');
    const update = () => { el.classList.toggle('is-open', mq.matches); };
    update();
    mq.addEventListener('change', update);
    window.addEventListener('resize', update, { passive: true });
})();






// === config ===

// Inline SVGs (inherit currentColor)
const ICONS = {
    messenger: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M12 2C6.48 2 2 6 2 10.86c0 2.73 1.39 5.2 3.72 6.8v3.34l3.4-1.87c.93.26 1.92.4 2.88.4 5.52 0 10-4 10-8.86S17.52 2 12 2Zm1.54 10.69-2.52-2.69-5.14 2.69 5.67-6.03 2.52 2.69 5.14-2.69-5.67 6.03Z"/>
    </svg>`,
    whatsapp: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M20.52 3.48A11.85 11.85 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.55 4.16 1.6 5.98L0 24l6.2-1.62A12 12 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52ZM12 22c-1.81 0-3.56-.49-5.08-1.42l-.36-.22-3.17.83.85-3.09-.23-.38A9.96 9.96 0 0 1 2 12C2 6.49 6.49 2 12 2c2.66 0 5.17 1.04 7.06 2.94A9.95 9.95 0 0 1 22 12c0 5.51-4.49 10-10 10Zm5.08-6.41c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.62.14-.19.28-.72.9-.88 1.08-.16.19-.33.21-.61.07-.28-.14-1.19-.44-2.27-1.41-.84-.75-1.41-1.68-1.58-1.96-.16-.28-.02-.43.12-.57.12-.12.28-.33.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.62-1.49-.85-2.04-.22-.53-.45-.46-.62-.47l-.53-.01c-.19 0-.49.07-.75.35-.26.28-1 1-1 2.45s1.03 2.84 1.17 3.03c.14.19 2.02 3.09 4.89 4.33.68.29 1.21.47 1.63.6.69.22 1.31.19 1.8.12.55-.08 1.65-.68 1.89-1.34.23-.66.23-1.22.16-1.34-.07-.12-.25-.19-.53-.33Z"/>
    </svg>`,
    email: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM4 8l8 5 8-5v10H4V8Zm16-2-8 5-8-5h16Z"/>
    </svg>`,
    copy: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M16 1H4a2 2 0 0 0-2 2v12h2V3h12V1Zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H8V7h11v14Z"/>
    </svg>`
};

const SHARE_ICON_URL = 'https://publictwin.info/HavenparkGroningen/content/Icons/ShareIconWhite.svg';

const APP_SHARE_URL = window.APP_SHARE_URL || (location.origin + location.pathname);
const APP_SHARE_TITLE = window.APP_SHARE_TITLE || 'Havenpark – doe mee!';
const APP_SHARE_TEXT = window.APP_SHARE_TEXT || 'Deel je ideeën voor Havenpark in Groningen.';

const USE_SYSTEM_SHARE_ON_MOBILE = true; // keep true
const FORCE_WEB_ONLY_WHATSAPP = true;  // set true to avoid whatsapp:// auto-open
const FORCE_WEB_ONLY_MESSENGER = false;  // set true to avoid fb-messenger:// auto-open

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);


// Popups for map pins - indicating categories:
// Category -> emoji (or swap for your own small icon URLs)
const CATEGORY_ICONS = {
    nature: '🌿',
    housing: '🏠',
    economy: '💼',
    heritage: '🏛️',
    biodiversity: '🦋',
    climate: '🌍',
    tourism: '🧭',
    accessibility: '♿',
    infrastructure: '🏗️',
    leisure: '🎈',
    activities: '🎯',
    mobility: '🚲',
    privacy: '🔐',
    sports: '🏃',
    aesthetics: '🎨',
    comfort: '🛋️',
    safety: '🛡️',
    experience: '✨',
    identity: '🧭',
    fun: '😄',
    other: '❓'
};
// Category -> Dutch display label
const CATEGORY_LABELS_NL = {
    nature: 'natuur',
    housing: 'wonen',
    economy: 'economie',
    heritage: 'erfgoed',
    biodiversity: 'biodiversiteit',
    climate: 'klimaat',
    tourism: 'toerisme',
    accessibility: 'toegankelijkheid',
    infrastructure: 'infrastructuur',
    leisure: 'vrije tijd',
    activities: 'activiteiten',
    mobility: 'mobiliteit',
    privacy: 'privacy',
    sports: 'sport',
    aesthetics: 'esthetiek',
    comfort: 'comfort',
    safety: 'veiligheid',
    experience: 'beleving',
    identity: 'identiteit',
    fun: 'plezier',
    other: 'anders'
};

// helpers
function labelNL(cat) {
    return CATEGORY_LABELS_NL[cat] || cat;
}
function iconFor(cat) {
    return CATEGORY_ICONS[cat] || '•';
}

// Keep a single popup instance so only one appears at a time
let __pinPopupEl = null;
function closePinPopup() { __pinPopupEl?.remove?.(); __pinPopupEl = null; }


// Robust copy (works in http dev via execCommand fallback)
async function copyToClipboardSmart(text, btn) {
    try {
        if (navigator.clipboard?.writeText && (location.protocol === 'https:' || location.hostname === 'localhost')) {
            await navigator.clipboard.writeText(text);
        } else {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy'); // best-effort fallback
            document.body.removeChild(ta);
        }
        if (btn) {
            const prev = btn.textContent; btn.textContent = 'Copied!'; setTimeout(() => btn.textContent = prev, 1200);
        }
    } catch {
        window.prompt('Copy this link:', text); // last resort
    }
}

// === util: try app scheme first, then fallback to web ===
function openThenFallback(appHref, webHref) {
    const t0 = Date.now();
    window.location.assign(appHref);
    setTimeout(() => {
        if (Date.now() - t0 < 1500) window.open(webHref, '_blank', 'noopener');
    }, 700);
}

// ==== Mobile detection (robust) ====
function isMobilePlatform() {
    // 1) UA hints (new-ish)
    if (navigator.userAgentData?.mobile) return true;

    // 2) Classic UA check
    const ua = navigator.userAgent || navigator.vendor || '';
    if (/android|iphone|ipad|ipod/i.test(ua)) return true;

    // 3) Coarse pointer + small viewport — “mobile enough”
    const coarse = window.matchMedia?.('(pointer: coarse)').matches;
    const small = Math.min(window.innerWidth, window.innerHeight) <= 820;
    return !!(coarse && small);
}

// ==== Native system share on mobile ====
async function trySystemShareMobile(anchorEl) {
    const url = window.APP_SHARE_URL || (location.origin + location.pathname);
    const title = window.APP_SHARE_TITLE || 'deel';
    const text = window.APP_SHARE_TEXT || '';

    if (!navigator.share) return false;   // not supported -> caller will fallback

    try {
        await navigator.share({ title, text, url });
        return true; // user saw system sheet
    } catch (err) {
        // user canceled or the call failed; treat as “handled”
        return true;
    }
}



// === build share button (reuse coin styles) ===
function initShareButton(container) {
    const host =
        container ||
        document.getElementById('UrbanFutureTopNavbarMainMenuTitle') ||
        document.body;

    if (document.getElementById('ShareAppButton')) return;

    const SHARE_ICON_URL = 'https://publictwin.info/HavenparkGroningen/content/Icons/ShareIconWhite.svg';

    const btn = document.createElement('button');
    btn.id = 'ShareAppButton';
    btn.className = 'PTcoinDiv ShareInAppDiv clickableButton';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'share with a friend');
    btn.innerHTML = `
    <img class="UFIconCoin" src="${SHARE_ICON_URL}" alt="" />
    <span class="ShareInAppLabel">deel</span>
  `;
    if (document.getElementById('ParticipateMenuWrapper')?.classList.contains('is-open')) {
        btn.classList.add('participate-suspend');
    }
    host.appendChild(btn);

    btn.addEventListener('click', async (e) => {
        e.stopPropagation();

        // If on mobile, try native system share. If available, do NOT open our menu.
        if (isMobilePlatform()) {
            const handled = await trySystemShareMobile(btn);
            if (handled) return;  // system share shown or user canceled
            // If not supported (very old browser), fall back to our sheet:
            openShareSheet(btn);
            return;
        }

        // Desktop (or not-mobile): open our share sheet
        openShareSheet(btn);
    });

    // Click-away to close sheet on desktop
    document.addEventListener('click', (ev) => {
        const sheet = document.getElementById('ShareSheet');
        if (!sheet) return;
        if (!sheet.contains(ev.target) && ev.target !== btn) sheet.remove();
    });
}

// ==== Boot ====
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initShareButton());
} else {
    initShareButton();
}

// === share sheet with Instagram / Messenger / WhatsApp / Email / Copy ===
function openShareSheet(anchorEl) {
    let sheet = document.getElementById('ShareSheet');
    if (sheet) sheet.remove();

    const url = APP_SHARE_URL;
    const text = APP_SHARE_TEXT;
    const title = APP_SHARE_TITLE;

    const encURL = encodeURIComponent(url);
    const encText = encodeURIComponent(text);
    const encSubj = encodeURIComponent(title);

    // Deep links + fallbacks
    const msApp = `fb-messenger://share?link=${encURL}`;
    const msWeb = `https://m.me/?link=${encURL}`;

    const waApp = `whatsapp://send?text=${encText}%20${encURL}`;
    const waWeb = `https://api.whatsapp.com/send?text=${encText}%20${encURL}`;

    const mailTo = `mailto:?subject=${encSubj}&body=${encText}%0A%0A${encURL}`;

    sheet = document.createElement('div');
    sheet.id = 'ShareSheet';
    sheet.className = 'ShareSheetPopover';
    sheet.innerHTML = `
  <div class="share-row">
    <button class="share-link" data-app="messenger">
      <span class="share-ico brand-messenger">${ICONS.messenger}</span>
      <span>Messenger</span>
    </button>
    <button class="share-link" data-app="whatsapp">
      <span class="share-ico brand-whatsapp">${ICONS.whatsapp}</span>
      <span>WhatsApp</span>
    </button>
    <button class="share-link" data-app="email" data-mailto="${mailTo}">
      <span class="share-ico">${ICONS.email}</span>
      <span>Email</span>
    </button>
    <button class="share-copy" type="button">
      <span class="share-ico">${ICONS.copy}</span>
      <span>Copy link</span>
    </button>
  </div>
`;

    document.body.appendChild(sheet);
    positionShareSheet(sheet, anchorEl);

    // Click handlers
    sheet.querySelector('.share-row').addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-app], .share-copy');
        if (!btn) return;

        const url = APP_SHARE_URL;
        const text = APP_SHARE_TEXT;
        const title = APP_SHARE_TITLE;

        // 1) Prefer native system share on mobile -> single system UI, no extra prompts
        if (USE_SYSTEM_SHARE_ON_MOBILE && isMobile() && navigator.share) {
            try { await navigator.share({ title, text, url }); } catch (_) { }
            return;
        }

        const app = btn.getAttribute('data-app');

        if (app === 'messenger') {
            const encURL = encodeURIComponent(url);
            const web = `https://m.me/?link=${encURL}`;
            if (FORCE_WEB_ONLY_MESSENGER) {
                window.open(web, '_blank', 'noopener'); // avoids immediate app launch
            } else {
                // may open app immediately on Android (expected)
                openThenFallback(`fb-messenger://share?link=${encURL}`, web);
            }
        } else if (app === 'whatsapp') {
            const encTxt = encodeURIComponent(`${text} ${url}`);
            const web = `https://api.whatsapp.com/send?text=${encTxt}`;
            if (FORCE_WEB_ONLY_WHATSAPP) {
                window.open(web, '_blank', 'noopener'); // avoids immediate app launch
            } else {
                // may open app immediately on Android (expected)
                openThenFallback(`whatsapp://send?text=${encTxt}`, web);
            }
        } else if (app === 'email') {
            const encSubj = encodeURIComponent(title);
            const encBody = encodeURIComponent(`${text}\n\n${url}`);
            window.location.href = `mailto:?subject=${encSubj}&body=${encBody}`;
        } else if (btn.classList.contains('share-copy')) {
            copyToClipboardSmart(url, btn);
        }
    });

    // Copy link
    sheet.querySelector('.share-copy')?.addEventListener('click', () => {
        copyToClipboard(url, sheet.querySelector('.share-copy'));
    });

    // Reposition on resize/scroll
    const onScroll = () => positionShareSheet(sheet, anchorEl);
    window.addEventListener('resize', onScroll, { passive: true, once: true });
    window.addEventListener('scroll', onScroll, { passive: true, once: true });
}


function positionShareSheet(sheet, anchorEl) {
    const r = anchorEl.getBoundingClientRect();
    // Ensure layout has computed
    sheet.style.visibility = 'hidden';
    sheet.style.top = '0px';
    sheet.style.left = '0px';
    // Let it size, then place
    requestAnimationFrame(() => {
        const top = r.bottom + window.scrollY + 6;
        const left = r.right + window.scrollX - sheet.offsetWidth;
        sheet.style.top = `${top}px`;
        sheet.style.left = `${Math.max(8, left)}px`;
        sheet.style.visibility = 'visible';
    });
}




// ============================================================
// IMAGE GALLERY LIGHTBOX FUNCTIONALITY
// ============================================================

let galleryImages = []; // Stores all gallery images data
let currentLightboxIndex = null; // Current image index in lightbox
let showingOriginal = false; // Track which version is displayed

// Initialize gallery lightbox functionality
function initGalleryLightbox() {
    const overlay = document.getElementById('gallery-lightbox-overlay');
    const closeBtn = document.getElementById('lightbox-close-button');
    const prevBtn = document.getElementById('previous-image-button');
    const nextBtn = document.getElementById('next-image-button');
    const toggleBtn = document.getElementById('image-version-button');
    const lightboxImg = document.getElementById('lightbox-image');
    const originalImg = document.getElementById('lightbox-original-image');
    const likesDiv = document.getElementById('lightbox-likes');

    if (!overlay) return;

    // Close lightbox
    closeBtn?.addEventListener('click', () => closeLightbox());
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeLightbox();
    });

    // Navigation
    prevBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        navigateLightbox(-1);
    });

    nextBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        navigateLightbox(1);
    });

    // Toggle between original and generated
    toggleBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleImageVersion();
    });

    // Like image on click
    lightboxImg?.addEventListener('click', (e) => {
        e.stopPropagation();
        if (currentLightboxIndex !== null && galleryImages[currentLightboxIndex]) {
            likeImage(galleryImages[currentLightboxIndex].id);
        }
    });

    likesDiv?.addEventListener('click', (e) => {
        e.stopPropagation();
        if (currentLightboxIndex !== null && galleryImages[currentLightboxIndex]) {
            likeImage(galleryImages[currentLightboxIndex].id);
        }
    });
}

// Open lightbox with specific image
function openLightbox(imageIndex) {
    if (imageIndex < 0 || imageIndex >= galleryImages.length) return;

    currentLightboxIndex = imageIndex;
    showingOriginal = false;

    const image = galleryImages[imageIndex];
    const overlay = document.getElementById('gallery-lightbox-overlay');
    const lightboxImg = document.getElementById('lightbox-image');
    const originalImg = document.getElementById('lightbox-original-image');
    const toggleBtn = document.getElementById('image-version-button');
    const prevBtn = document.getElementById('previous-image-button');
    const nextBtn = document.getElementById('next-image-button');

    // Set image sources
    lightboxImg.src = image.generated_image || image.image_url;
    originalImg.src = image.original_image || image.IconImage;

    // Update metadata
    document.getElementById('lightbox-question').textContent = image.question || image.description || '';
    document.getElementById('lightbox-answer').textContent = image.answer_text || image.user_response || '';
    document.getElementById('lightbox-cue-card').textContent = image.trigger_text || image.cue_card || '';
    document.getElementById('lightbox-likes-count').textContent = image.number_of_likes || image.likes || 0;

    // Show/hide navigation buttons
    prevBtn.disabled = imageIndex === 0;
    nextBtn.disabled = imageIndex === galleryImages.length - 1;

    // Reset to showing generated image
    lightboxImg.style.display = 'block';
    originalImg.style.display = 'none';
    toggleBtn.textContent = 'bekijk origineel';

    // Show overlay
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
}

// Close lightbox
function closeLightbox() {
    const overlay = document.getElementById('gallery-lightbox-overlay');
    overlay.style.display = 'none';
    document.body.style.overflow = ''; // Restore scrolling
    currentLightboxIndex = null;
    showingOriginal = false;
}

// Navigate to previous/next image
function navigateLightbox(direction) {
    if (currentLightboxIndex === null) return;

    const newIndex = currentLightboxIndex + direction;
    if (newIndex >= 0 && newIndex < galleryImages.length) {
        openLightbox(newIndex);
    }
}

// Toggle between original and generated image
function toggleImageVersion() {
    const lightboxImg = document.getElementById('lightbox-image');
    const originalImg = document.getElementById('lightbox-original-image');
    const toggleBtn = document.getElementById('image-version-button');

    showingOriginal = !showingOriginal;

    if (showingOriginal) {
        lightboxImg.style.display = 'none';
        originalImg.style.display = 'block';
        toggleBtn.textContent = 'bekijk gegenereerd';
    } else {
        lightboxImg.style.display = 'block';
        originalImg.style.display = 'none';
        toggleBtn.textContent = 'bekijk origineel';
    }
}

// Like/unlike an image
async function likeImage(imageId) {
    try {
        const userIP = localStorage.getItem('userIP') || '';
        const userUID = localStorage.getItem('userUID') || '';

        const response = await fetch(
            `https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Like_Gallery_Image.php`,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    image_id: imageId,
                    user_ip: userIP,
                    user_uid: userUID
                })
            }
        );

        const data = await response.json();

        if (data.success) {
            // Update the like count in the gallery data
            const image = galleryImages.find(img => img.id === imageId);
            if (image) {
                image.number_of_likes = data.new_like_count || (image.number_of_likes || 0) + 1;

                // Update display if this image is currently shown
                if (currentLightboxIndex !== null && galleryImages[currentLightboxIndex].id === imageId) {
                    document.getElementById('lightbox-likes-count').textContent = image.number_of_likes;
                }
            }
        }
    } catch (error) {
        console.error('Error liking image:', error);
    }
}

// Fetch gallery images from server
async function fetchGalleryImages() {
    try {
        const userIP = localStorage.getItem('userIP') || '';
        const userUID = localStorage.getItem('userUID') || '';

        const response = await fetch(
            `https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Get_Gallery_Images.php?ip=${encodeURIComponent(userIP)}&uid=${encodeURIComponent(userUID)}`
        );

        const data = await response.json();

        if (data && Array.isArray(data)) {
            galleryImages = data.filter(img =>
                img.generated_image && img.generated_image.trim() !== '-'
            );

            // Check if any images are still being generated
            const stillGenerating = data.some(img =>
                !img.generated_image || img.generated_image.trim() === '-'
            );

            if (stillGenerating) {
                // Poll again in 5 seconds
                setTimeout(fetchGalleryImages, 5000);
            }
        }
    } catch (error) {
        console.error('Error fetching gallery images:', error);
    }
}

// Add click handler to participate-media images to open lightbox
function addImageClickHandlers() {
    // Add click handler to location images in participate panel
    const participateMedia = document.querySelector('.participate-media');
    if (participateMedia) {
        participateMedia.style.cursor = 'pointer';
        participateMedia.addEventListener('click', () => {
            // For now, just show the current location image in lightbox
            // Later this can be enhanced to show related gallery images
            const currentPoint = participationPoints.find(p =>
                document.querySelector(`.participate-panel[data-point-id="${p.id}"]`)
            );

            if (currentPoint) {
                // Create a temporary gallery entry for the location image
                galleryImages = [{
                    id: currentPoint.id,
                    generated_image: currentPoint.media?.src || currentPoint.BaseImage,
                    original_image: currentPoint.BaseImage,
                    question: currentPoint.title,
                    answer_text: currentPoint.description,
                    trigger_text: '',
                    number_of_likes: 0
                }];
                openLightbox(0);
            }
        });
    }
}

// Make location image clickable when participation panel is rendered
const originalRenderParticipatePanel = renderParticipatePanel;
renderParticipatePanel = function(point) {
    originalRenderParticipatePanel(point);
    if (point) {
        // Add click handler after panel is rendered
        setTimeout(() => addImageClickHandlers(), 100);
    }
};


// Boot
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initShareButton();
        initGalleryLightbox();
        fetchGalleryImages(); // Start fetching gallery images
    });
} else {
    initShareButton();
    initGalleryLightbox();
    fetchGalleryImages();
}
